<template>
  <div class="movies-form new_movie_layout">
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">
        {{ $t("add") }} {{ $tc("movie", 1) }}
      </div>
      <router-link class="btn-blue" to="movies"
        >{{ $tc("movie", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper" style="margin-bottom: 12px">
      <b-row>
        <b-col sm="6" offset="3">
          <multiselect
            v-model="selectedSearchMovies"
            id="ajax"
            label="Title"
            track-by="Title"
            placeholder="Type to search movies"
            open-direction="bottom"
            :options="searchMovies"
            :multiple="false"
            :searchable="true"
            :loading="isSearchLoading"
            :internal-search="false"
            :clear-on-select="false"
            :close-on-select="true"
            :options-limit="300"
            :max-height="600"
            :show-no-results="true"
            :hide-selected="true"
            @select="onHandleSelectSearchMovies"
            @search-change="onAsyncSearchMovies"
            select-label="Select"
            deselect-label="Remove"
          >
            <span slot="noResult">Oops! No Results found.</span>
            <span slot="option" slot-scope="props"
              >{{ props.option.Title }}&nbsp;{{ props.option.Year }}&nbsp;
              <p class="externalmovies text-muted" v-if="props.option.suisa_id">
                Cinepool
              </p></span
            >
          </multiselect>
        </b-col>
      </b-row>
    </div>

    <div class="section-space-50"></div>

    <div class="white-wrapper">
      <form>
        <!-- MOVIE TOP INFO SECTION -->
        <section
          class="mb-3"
          :class="
            errorHandlerObj['errorSectionIndex'] == 1 ? 'sectionError' : ''
          "
        >
          <div class="row col-12">
            <div
              class="section-title mb-2 d-flex justify-content-between section-border section-border col-10"
              style="padding: 6px; align-items: center"
              v-b-toggle.basicInfoCollapse
            >
              <div>
                <span class="fs"
                  >{{ $tc("basic") }} {{ $tc("information") }}</span
                ><span class="font-weight-normal fs">{{ basicinfotext }} </span>

                <span
                  style="color: green; font-size: 17px"
                  v-if="this.MovieContainer.movie_isActive === 'Y'"
                >
                  Active
                </span>
                <span v-else style="color: red; font-size: 17px">
                  Inactive
                </span>
              </div>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>

            <div class="col-2 d-flex align-items-center justify-content-center">
              <label class="mb-0">{{ $t("active") }}</label>
              <b-form-checkbox
                v-model="MovieContainer.movie_isActive"
                unchecked-value="N"
                value="Y"
                name="check-button"
                class="j-checkbox ml-2 pb-0"
                @input="onChangeActiveStatus"
              />
            </div>
          </div>
          <b-collapse
            id="basicInfoCollapse"
            v-model="sectionCollapse.basicInfo"
          >
            <div class="basicInforWrapper">
              <div class="row px-2">
                <!-- show type -->
                <div class="col-md-12 mb-3" v-if="false">
                  <div class="row">
                    <div
                      class="col-md-3 col-lg-2 heading"
                      style="margin-top: 0px !important"
                    >
                      <h5>{{ $tc("screeningType") }}</h5>
                    </div>
                    <div
                      class="col-md-4 col-lg-2"
                      v-for="(screeningType,
                      screeningTypeIndex) in ShowTypeArrayNew"
                      :key="screeningTypeIndex"
                    >
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          :disabled="disableFeatureVersion"
                          :id="`ogshowtypearr${screeningTypeIndex}`"
                          v-model="MovieContainer[screeningType.column_name]"
                          @change="
                            onChangeOriginalShowtype(
                              $event,
                              screeningType.column_name
                            )
                          "
                        />

                        <label
                          class=""
                          :for="`ogshowtypearr${screeningTypeIndex}`"
                        >
                          {{ screeningType.screening_name }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- MOVIE TITLE -->
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <label
                        >Movie Title <span class="required_star">*</span></label
                      >
                      <input
                        v-model="MovieContainer.movieTitle"
                        type="text"
                        name="movietitle"
                        id="movietitle"
                        placeholder="Movie Name"
                        @input="onChangeMovieTitle($event)"
                      />
                    </div>
                  </div>
                  <p class="error_message"></p>
                </div>
                <!-- MOVIE TITLE -->

                <!-- Unique Movie ID -->
                <div class="col-md-2 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <!-- <label>{{ $tc("movieUniqueID") }}</label> -->
                      <label
                        >Movie UUID <span class="required_star">*</span></label
                      >
                      <input
                        style="text-align: right"
                        v-model="MovieContainer.movie_unique_identifier"
                        type="text"
                        :disabled="
                          MovieContainer.is_event &&
                            MovieContainer.parent_movie_id
                        "
                        name="movie_unique_identifier"
                        id="movie_unique_identifier"
                        placeholder="UUID"
                      />
                    </div>
                    <div
                      class="input-material ml-3 w-50"
                      v-if="
                        MovieContainer.is_event &&
                          MovieContainer.parent_movie_id
                      "
                    >
                      <label>{{ "Event ID" }}</label>
                      <input
                        v-model="event_identifier"
                        type="text"
                        name="event_identifier"
                        id="event_identifier"
                        :disabled="true"
                        :maxlength="3"
                        v-validate="{ required: 'required', regex: /^\S*$/ }"
                        placeholder="."
                      />
                    </div>
                  </div>
                  <p class="error_message"></p>
                </div>

                <!--ORIGINAL LANGUAGE DROPDOWN -->
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label>
                        {{ $tc("Language") }} ( {{ $t("original") }})<span
                          class="required_star"
                          >*</span
                        >
                      </label>

                      <multiselect
                        v-model="MovieContainer.selected_original_language"
                        @select="onSelectOriginalLanguageHandler"
                        placeholder="Original Language"
                        :options="Languages"
                        label="lang_name"
                        track-by="lang_id"
                        :multiple="false"
                        name="selectoriginallanguage"
                        id="selectoriginallanguage"
                        select-label="Select"
                        deselect-label="Remove"
                      ></multiselect>
                    </div>
                  </div>
                  <p class="error_message"></p>
                </div>
                <!--ORIGINAL LANGUAGE DROPDOWN -->

                <!-- Original Movie distributor -->
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label>
                        {{ $t("default") }}
                        {{ $tc("distributor", 1)
                        }}<span class="required_star">*</span>
                      </label>

                      <multiselect
                        v-model="original_distributor"
                        @select="onSelectOriginalDistributorHandler"
                        placeholder="Default Distributor"
                        :options="Distributors"
                        label="d_company_name"
                        track-by="d_id"
                        :multiple="false"
                        name="selectoriginalDistributor"
                        id="selectoriginalDistributor"
                        select-label="Select"
                        deselect-label="Remove"
                      ></multiselect>
                    </div>
                  </div>
                  <p class="error_message"></p>
                </div>
                <!-- Original Movie distributor -->

                <!-- EVENT CHECKBOX -->
                <div class="col-md-1 mt-4">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="eventCheckbox"
                      name="eventCheckbox"
                      v-model="MovieContainer.is_event"
                      @change="onClickEvent($event)"
                    />
                    <label class="form-check-label" for="eventCheckbox">
                      {{ "Event?" }}
                    </label>
                  </div>
                </div>
                <!-- EVENT CHECKBOX -->

                <!-- EVENT SECTION -->
                <div class="col-12" v-if="MovieContainer.is_event">
                  <div class="row pt-2 mb-2">
                    <div class="col-md-3 mb-2">
                      <div class="d-flex align-items-center">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              MovieContainer.selected_parent_movie
                                ? 'shift-up'
                                : ''
                            "
                          >
                            {{ $t("parent_movie")
                            }}<span class="required_star">*</span>
                          </label>
                          <multiselect
                            v-model="MovieContainer.selected_parent_movie"
                            id="ajax"
                            label="movie_title"
                            track-by="movie_id"
                            placeholder="Parent Movie"
                            open-direction="bottom"
                            :options="Movies"
                            :multiple="false"
                            :searchable="true"
                            :loading="isSearchLoading"
                            :internal-search="false"
                            :clear-on-select="false"
                            :close-on-select="true"
                            :options-limit="300"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @select="onSelectParentMovie"
                            @search-change="onAsyncSearchParentMovie"
                            select-label="Select"
                            deselect-label="Remove"
                          >
                            <span slot="noOptions">Search Parent Movie</span>
                            <span slot="noResult">Oops! No Results found.</span>
                          </multiselect>
                        </div>
                      </div>
                      <p class="error_message"></p>
                    </div>

                    <div
                      class="col-md-5 mb-2"
                      v-if="MovieContainer.selected_parent_movie"
                    >
                      <div class="d-flex align-items-center">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              MovieContainer.selected_version.length > 0
                                ? 'shift-up'
                                : ''
                            "
                          >
                            {{ $t("parent_version")
                            }}<span class="required_star">*</span>
                          </label>

                          <multiselect
                            v-model="MovieContainer.selected_version"
                            @input="onSelectParentVersion($event)"
                            @remove="onRemoveParentVersion($event)"
                            :allow-empty="false"
                            placeholder="Parent Version"
                            :options="versionArray"
                            label="version_name"
                            track-by="version_id"
                            :multiple="true"
                            name="parent_version"
                            id="parent_version"
                            select-label="Select"
                            deselect-label="Remove"
                          ></multiselect>
                        </div>
                      </div>
                      <p class="error_message"></p>
                    </div>
                  </div>
                </div>
                <!-- EVENT SECTION -->

                <!-- GENRE MULTISELECT -->
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label>
                        {{ $tc("Genre", 1) }}
                      </label>
                      <multiselect
                        v-model="MovieContainer.genres"
                        :placeholder="'Genre'"
                        :options="Genres"
                        label="g_name"
                        track-by="g_id"
                        :multiple="true"
                        name="selectgenre"
                        id="selectgenre"
                        select-label="Select"
                        deselect-label="Remove"
                        :closeOnSelect="false"
                        :limit="2"
                        :limit-text="(count) => `& +${count} More`"
                      >
                        <span
                          class="checkbox-label"
                          slot="option"
                          slot-scope="scope"
                        >
                          <input
                            class="test"
                            type="checkbox"
                            :checked="
                              MovieContainer.genres.some(
                                (x) => scope.option.g_id == x.g_id
                              )
                            "
                            @focus.prevent
                          />
                          {{ scope.option.g_name }}
                        </span>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <!-- GENRE MULTISELECT -->

                <!-- HO CODE -->
                <div class="col-md-2 mb-2">
                  <label>{{ "HO Film Code" }}</label>
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        style="text-align: right"
                        v-model.trim="MovieContainer.ho_film_code"
                        :disabled="MovieContainer.is_event"
                        type="text"
                        name="ho_film_code"
                        id="ho_film_code"
                        placeholder="HO Film Code"
                      />
                    </div>
                  </div>
                </div>
                <!-- HO CODE -->

                <!-- LABELS MULTISELECT -->
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label>
                        {{ $t("label") }}
                      </label>
                      <multiselect
                        v-model="MovieContainer.labels"
                        :placeholder="'Movie Labels'"
                        :options="Labels"
                        label="label_name"
                        track-by="label_id"
                        :multiple="true"
                        name="movielabel"
                        id="movielabel"
                        select-label="Select"
                        deselect-label="Remove"
                        :closeOnSelect="false"
                        :limit="2"
                        :limit-text="(count) => `& +${count} More`"
                      >
                        <span
                          class="checkbox-label"
                          slot="option"
                          slot-scope="scope"
                        >
                          <input
                            class="test"
                            type="checkbox"
                            :checked="
                              MovieContainer.labels.some(
                                (x) => scope.option.label_id == x.label_id
                              )
                            "
                            @focus.prevent
                          />
                          {{ scope.option.label_name }}
                        </span>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <!-- LABELS MULTISELECT -->

                <div class="col-md-3">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <label :class="['', originalReleaseDate ? 'active' : '']"
                        >Release Date (Original)<span class="required_star"
                          >*</span
                        ></label
                      >
                      <div class="add-datepicker">
                        <input
                          type="date"
                          min="1900-01-01"
                          max="2099-12-31"
                          placeholder="Original Release Date"
                          v-model="originalReleaseDate"
                          ref="programaticOpen"
                          name="originalreleasedate"
                          id="originalreleasedate"
                          @keypress.enter.prevent
                          @change="onChangeOriginalReleaseDate($event)"
                          @input="onInputOriginalReleaseDate($event)"
                        />
                      </div>
                    </div>
                  </div>
                  <p class="error_message"></p>
                </div>

                <!-- Movie titles of other languages -->
                <div
                  class="col-md-3 mb-5"
                  v-for="(MovieContent,
                  MovieContentIndex) in MovieContentContainer"
                  :key="MovieContentIndex"
                  v-if="
                    !EPIX_CLIENT &&
                      MovieContent.langauge.toLowerCase() != 'english'
                  "
                >
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <label>{{
                        `Movie Title (${MovieContent.langauge})`
                      }}</label>
                      <input
                        v-model="MovieContent.movieContentTitle"
                        type="text"
                        :name="`movietitle_${MovieContentIndex}`"
                        :id="`movietitle_${MovieContentIndex}`"
                        :placeholder="`Movie Title (${MovieContent.langauge})`"
                      />
                    </div>
                  </div>
                  <p class="error_message">
                    <span
                      v-if="
                        submitted &&
                          showErrorMessages &&
                          MovieContent.langauge.toLowerCase() === 'english' &&
                          !MovieContent.movieContentTitle
                      "
                      >Enter Movie Title For
                      {{ MovieContent.langauge }} Language</span
                    >
                  </p>
                </div>
                <!---------Proudction Company------------>
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label>
                        {{ $tc("production", 1)
                        }} {{ $tc("company", 1)
                      }}<span class="required_star">*</span>
                      </label>

                      <multiselect
                        v-model="MovieContainer.productionCompany"
                        @select="onSelectProductionCompany($event)"
                        @remove="onRemoveProudctionCompany()"
                        placeholder="Producers"
                        :options="Productions"
                        label="production_name"
                        track-by="production_id"
                        :multiple="true"
                        name="selectorProductionCompany"
                        id="selectorProductionCompany"
                        select-label="Select"
                        deselect-label="Remove"
                        :closeOnSelect="false"
                        :limit="2"
                        :limit-text="(count) => `& +${count} More`"
                      ></multiselect>
                    </div>
                  </div>
                  <p class="error_message"></p>
                </div>
               <!---------Proudction Company------------>

               <div class="col-2 d-flex align-items-center justify-content-center">
                 <label class="mb-0">{{ "Foreign Movie" }}</label>
                 <b-form-checkbox
                   v-model="MovieContainer.ms_foreign_movie"
                   unchecked-value="N"
                   value="Y"
                   name="check-button"
                   class="j-checkbox ml-2 pb-0"
                 />
               </div>

              </div>

              <div class="row p-0 m-0">
                <div class="col-12 p-0">
                  <table
                    class="swc-report-table"
                    border="1"
                    style="table-layout: auto; background: white; zoom: 0.9"
                  >
                    <thead>
                      <tr>
                        <th class="bg-lightprimary p-1" style="width: 200px">
                          Region<span class="required_star">*</span>
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 200px">
                          Release Date<span class="required_star">*</span>
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 190px">
                          Ratings<span class="required_star">*</span>
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 110px">
                          Runtime<span class="required_star">*</span>
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 110px">
                          Intermission<span class="required_star">*</span>
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 110px">
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      v-if="
                        MovieContainer.movieRatings &&
                          MovieContainer.movieRatings.length > 0
                      "
                    >
                      <template
                        v-for="(Rating,
                        RatingIndex) in MovieContainer.movieRatings"
                      >
                        <tr :key="RatingIndex">
                          <td class="text-left p-0 manual_bill_item">
                            <multiselect
                              v-model="Rating.region_obj"
                              placeholder="Region"
                              @select="
                                onSelectRatingRegionHandler($event, RatingIndex)
                              "
                              :options="Regions"
                              label="region_name"
                              track-by="region_id"
                              :multiple="false"
                              name="selectregion"
                              id="selectregion"
                              select-label="Select"
                              deselect-label="Remove"
                            />
                          </td>
                          <td class="text-left p-0 manual_bill_item">
                            <div class="manual_bill_input">
                              <input
                                type="date"
                                min="1900-01-01"
                                max="2099-12-31"
                                placeholder="Release Date"
                                v-model="Rating.releaseDate"
                                :name="'releasedate' + RatingIndex"
                                :id="'releasedate' + RatingIndex"
                                @keypress.enter.prevent
                              />
                            </div>
                          </td>
                          <td class="text-left p-0 manual_bill_item">
                            <multiselect
                              style="text-align: left"
                              v-model="Rating.selectedRating"
                              @select="
                                onSelectMovieRatingHandler($event, RatingIndex)
                              "
                              @remove="
                                onRemoveMovieRatingHandler($event, RatingIndex)
                              "
                              placeholder="Rating"
                              :options="Ratings"
                              label="rating"
                              track-by="rating_id"
                              :multiple="false"
                              name="selectrating"
                              id="selectrating"
                              select-label="Select"
                              deselect-label="Remove"
                              selectLabel=""
                            />
                          </td>
                          <td class="text-left p-0 manual_bill_item">
                            <div class="manual_bill_input">
                              <input
                                style="text-align: right"
                                v-model="Rating.runTime"
                                type="text"
                                name="runtime"
                                id="runtime"
                                placeholder="."
                                @keypress.enter.prevent
                                @input="onChangeRuntime($event, RatingIndex)"
                              />
                            </div>
                          </td>
                          <td class="text-left p-0 manual_bill_item">
                            <div class="manual_bill_input">
                              <input
                                style="text-align: right"
                                v-model="Rating.intervalTime"
                                type="text"
                                name="intervaltime"
                                id="intervaltime"
                                placeholder="."
                                @keypress.enter.prevent
                              />
                            </div>
                          </td>
                          <td>
                            <div
                              class="icon-sm-minus blue-icon ml-2 btn"
                              @click.prevent.stop="
                                removeRating($event, RatingIndex)
                              "
                            ></div>
                          </td>
                        </tr>
                      </template>
                      <tr class="">
                        <td colspan="12">
                          <div
                            class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                          >
                            <button
                              v-if="checkAddMoreRatings"
                              @click.prevent.stop="addMoreRating($event)"
                              class="btn-transparent add-more-button addBtn_multi"
                            >
                              <img
                                src="@/assets/img/icons/plus.svg"
                                height="24"
                                width="24"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="">
                        <td colspan="12">
                          <div
                            class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                          >
                            <button
                              v-if="checkAddMoreRatings"
                              @click.prevent.stop="addMoreRating($event)"
                              class="btn-transparent add-more-button addBtn_multi"
                            >
                              <img
                                src="@/assets/img/icons/plus.svg"
                                height="24"
                                width="24"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </b-collapse>
          <div
            class="px-2 py-2"
            v-if="
              errorHandlerObj['errMsg'] &&
                errorHandlerObj['errorSectionIndex'] == 1
            "
          >
            <div class="error_message">{{ errorHandlerObj["errMsg"] }}</div>
          </div>
        </section>

        <!-- MOVIE CONTENT SECTIONS START -->
        <section
          class="mb-3"
          :class="
            errorHandlerObj['errorSectionIndex'] == 2 ? 'sectionError' : ''
          "
        >
          <div
            class="section-title mb-1 d-flex justify-content-between section-border section-border"
            style="padding: 6px; align-items: center"
            v-b-toggle.movieContent
          >
            <span class="fs"
              >{{ $tc("movie", 1) }} {{ $tc("Information", 2) }}
              <!-- {{ $t("Synopsis") }} -->
              {{ !moviecontentexists ? ` - TBA` : "" }}</span
            >

            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>

          <b-collapse
            id="movieContent"
            class="mt-2"
            v-model="sectionCollapse.movieContent"
          >
            <div class="bn-tabs-nav" v-if="!showContentListView">
              <button
                v-for="(MovieContent,
                MovieContentIndex) in MovieContentContainer"
                :key="MovieContentIndex"
                :class="[
                  'btn-tab-title ',
                  { active: MovieContentIndex == activeClass },
                ]"
                @click.prevent.stop="
                  onChangeTabHandler($event, MovieContentIndex)
                "
              >
                <strong>
                  <span
                    :class="
                      MovieContent.langauge.toLowerCase() !== 'english'
                        ? MovieContent.movieShortDescription &&
                          MovieContent.movieDescription
                          ? ''
                          : 'text-danger'
                        : ''
                    "
                    >{{ MovieContent.langauge }}</span
                  >

                  <button
                    @click.prevent.stop="
                      translateToOtherLangs(MovieContent, MovieContentIndex)
                    "
                    class="btn-blue btn-blue-sm"
                  >
                    Translate &nbsp;
                    <b-spinner
                      v-if="translationLoading[MovieContentIndex] == true"
                      small
                      variant="light"
                      label="Spinning"
                      class="translate-spinner"
                    ></b-spinner>
                  </button>
                </strong>
              </button>
            </div>

            <div
              class="bn-tabs-content border pt-4 back"
              v-if="!showContentListView"
            >
              <div
                v-for="(MovieContent,
                MovieContentIndex) in MovieContentContainer"
                :key="MovieContentIndex"
              >
                <div v-if="MovieContentIndex === activeClass">
                  <div class="row px-3">
                    <div class="col-md-2 align-items-center d-flex">
                      Short Description ({{ MovieContent.langauge }})
                    </div>
                    <div class="col-md-10">
                      <div class="d-flex align-items-center">
                        <div class="input-material-textarea">
                          <textarea
                            v-model="MovieContent.movieShortDescription"
                            rows="2"
                            placeholder="Movie Plot (Short Description)"
                            :name="
                              `short_movie_description_${MovieContentIndex}`
                            "
                            :id="`short_movie_description_${MovieContentIndex}`"
                          ></textarea>
                        </div>
                      </div>
                      <p class="error_message"></p>
                    </div>

                    <div class="col-md-2 align-items-center d-flex">
                      Long Description ({{ MovieContent.langauge }})<span
                        class="required_star"
                        >*</span
                      >
                    </div>
                    <div class="col-md-10 mt-2">
                      <div class="d-flex align-items-center">
                        <div class="input-material-textarea">
                          <textarea
                            v-model="MovieContent.movieDescription"
                            rows="2"
                            placeholder="Movie Plot (Long Description)"
                            :name="
                              `long_movie_description_${MovieContentIndex}`
                            "
                            :id="`long_movie_description_${MovieContentIndex}`"
                          ></textarea>
                        </div>
                      </div>
                      <p class="error_message"></p>
                    </div>
                  </div>
                </div>

                <div v-if="MovieContentIndex === activeClass">
                  <h6 class="text-uppercase my-3 mx-2">
                    {{ $t("cast") }} & {{ $tc("crew", 1) }} ({{
                      MovieContent.langauge
                    }})
                  </h6>
                  <table
                    class="swc-report-table"
                    border="1"
                    style="table-layout: auto; background: white; zoom: 0.9"
                  >
                    <thead>
                      <tr>
                        <th class="bg-lightprimary p-1" style="width: 160px">
                          Crew Type
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 620px">
                          Cast Name
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 80px">
                        </th>
                      </tr>
                    </thead>
                    <tbody v-if="cast_and_crew && cast_and_crew.length > 0">
                      <template
                        v-for="(CastAndCrewItem,
                        CastAndCrewIndex) in cast_and_crew[englishContentIndex].movieCastAndCrewList"
                      >
                        <tr :key="MovieContentIndex + '_' + CastAndCrewIndex">
                          <td class="text-left p-0 manual_bill_item">
                            <multiselect
                              v-model="CastAndCrewItem.selectedCastAndCrew"
                              @select="
                                onSelectCrewHandler(
                                  $event,
                                  CastAndCrewItem,
                                  CastAndCrewIndex,
                                  englishContentIndex
                                )
                              "
                              placeholder="Select Cast And Crew"
                              :options="Crews"
                              label="crew_title"
                              track-by="crew_id"
                              :multiple="false"
                              select-label="Select"
                              deselect-label="Remove"
                            />
                          </td>
                          <td class="text-left p-0 manual_bill_item">
                            <multiselect
                              v-model="CastAndCrewItem.selectedCastMembers"
                              @select="
                                onAddCastCrewOption($event, CastAndCrewItem)
                              "
                              @remove="
                                onRemoveCastCrewOption($event, CastAndCrewItem)
                              "
                              placeholder="Select Cast And Crew"
                              :options="CastMasters"
                              label="cast_name"
                              track-by="mcm_id"
                              :multiple="true"
                              select-label="Select"
                              deselect-label="Remove"
                            >
                            <span slot="noResult">Oops! No Results found.</span>
                            <div slot="option" slot-scope="props">
                              <span class="d-flex align-items-center">
                                 <CastIcon :name="props.option.cast_name" :image_url="props.option.cast_image_url" :width="40" :height="40" :classes="''" /> <p>{{ props.option.cast_name }}</p>
                              </span>
                            </div>
                            </multiselect>
                            <!-- <div class="">
                              <EditablePills
                                :elements="CastAndCrewItem.members"
                                input_prop_name="person_name"
                                :addElement="
                                  () => addCastCrewMember(CastAndCrewItem)
                                "
                                :removeElement="
                                  (itemIndex) =>
                                    removeCastCrewMember(
                                      CastAndCrewItem,
                                      itemIndex
                                    )
                                "
                              />
                            </div> -->
                          </td>
                          <td>
                            <div
                              class="icon-sm-minus blue-icon ml-2 btn"
                              @click.prevent.stop="
                                removeCastAndCrew(
                                  $event,
                                  CastAndCrewIndex,
                                  englishContentIndex
                                )
                              "
                            ></div>
                          </td>
                        </tr>
                      </template>
                      <tr class="">
                        <td colspan="12">
                          <div
                            class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                          >
                            <button
                              @click.prevent.stop="
                                addCastAndCrew($event, englishContentIndex)
                              "
                              class="btn-transparent add-more-button addBtn_multi"
                            >
                              <img
                                src="@/assets/img/icons/plus.svg"
                                height="24"
                                width="24"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="">
                        <td colspan="12">
                          <div
                            class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                          >
                            <button
                              @click.prevent.stop="
                                addCastAndCrew($event, englishContentIndex)
                              "
                              class="btn-transparent add-more-button addBtn_multi"
                            >
                              <img
                                src="@/assets/img/icons/plus.svg"
                                height="24"
                                width="24"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </b-collapse>

          <div
            class="px-2 py-2"
            v-if="
              errorHandlerObj['errMsg'] &&
                errorHandlerObj['errorSectionIndex'] == 2
            "
          >
            <div class="error_message">{{ errorHandlerObj["errMsg"] }}</div>
          </div>
        </section>

        <!-- Artwork -->
        <section
          class="mb-3"
          :class="
            errorHandlerObj['errorSectionIndex'] == 3 ? 'sectionError' : ''
          "
        >
          <div
            class="section-title mb-1 d-flex justify-content-between section-border section-border"
            style="padding: 6px; align-items: center"
            v-b-toggle.images
          >
            <span class="fs">Artwork & Images</span>

            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>

          <b-collapse id="images" class="mt-2" v-model="sectionCollapse.images">
            <div class="row" v-if="false">
              <!-- Movie Copyright -->
              <div class="col-md-5">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <label>{{ $tc("movie", 1) }} Copyright</label>
                    <input
                      v-model="MovieContainer.copyright"
                      type="text"
                      name="moviecopyright"
                      id="moviecopyright"
                      placeholder="Copyright"
                    />
                  </div>
                </div>
              </div>
              <p class="error_message">
                <span
                  v-if="
                    submitted &&
                      showErrorMessages &&
                      (errors.has('moviecopyright') ||
                        !MovieContainer.moviecopyright)
                  "
                  >{{ errors.first("moviecopyright") }}</span
                >
              </p>
            </div>

            <!-- Language Specific Artwork -->
            <div
              class="col-md-12 mt-1 p-0 rounded-10 mb-2"
              v-if="MovieContentContainer && MovieContentContainer.length > 0"
            >
              <div class="row">
                <div
                  class="col-md-12 heading d-none"
                  v-if="
                    MovieContentContainer && MovieContentContainer.length > 0
                  "
                >
                  <h5>Artwork</h5>
                </div>
                <div class="col-md-8 my-2">
                  <table
                    class="swc-report-table"
                    border="1"
                    style="table-layout: auto; background: white; zoom: 0.9"
                  >
                    <thead>
                      <tr>
                        <th
                          class="bg-lightprimary p-1"
                          style="width: 250px"
                        ></th>
                        <th class="bg-lightprimary p-1" style="width: 302px">
                          Upload
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 620px">
                          URL
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 200px">
                          Preview
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      v-if="
                        MovieContentContainer &&
                          MovieContentContainer.length > 0
                      "
                    >
                      <template
                        v-for="(MovieContent,
                        MovieContentIndex) in MovieContentContainer"
                      >
                        <tr :key="MovieContentIndex">
                          <td
                            class="text-left p-0 manual_bill_item text-center"
                          >
                            <div
                              class=""
                              style="margin-bottom: 15px; margin-top: 15px"
                            >
                              Artwork ({{ MovieContent.langauge }})
                            </div>
                          </td>
                          <td>
                            <div
                              class="d-flex justify-content-center align-items-center"
                              @click.prevent.stop="
                                setModalData(
                                  PosterIndex,
                                  artwork_image_height,
                                  artwork_image_width,
                                  5,
                                  MovieContentIndex,
                                  'Movie Poster',
                                  {
                                    lang_id: MovieContent.langaugeId,
                                    lang_name: MovieContent.langauge,
                                  }
                                )
                              "
                            >
                              <span
                                class="uploadposterBtn fa fa-upload"
                                style="font-size: 22px"
                              ></span>
                            </div>
                          </td>
                          <td>
                            {{ MovieContent.artwork }}
                          </td>
                          <td>
                            <ImagePreviewer
                              v-if="
                                MovieContent.artwork &&
                                  MovieContent.artwork.length > 0
                              "
                              :img="_GetImagePath(MovieContent.artwork)"
                              :clickFunc="
                                () => {
                                  openImageModal(
                                    'Artwork' + `(${MovieContent.langauge})`,
                                    MovieContent.artwork
                                  );
                                }
                              "
                            />
                            <img
                              v-if="MovieContent.artwork"
                              src="@/assets/img/icons/trash.svg"
                              height="25"
                              width="25"
                              class="rounded cursor-pointer"
                              @click="removeImageHandler(MovieContent, 1)"
                            />
                          </td>
                        </tr>
                      </template>
                      <tr>
                        <td>Movie Copyright</td>
                        <td class="" colspan="3">
                          <div class="manual_bill_input">
                            <input
                              v-model="MovieContainer.copyright"
                              type="text"
                              name="moviecopyright"
                              id="moviecopyright"
                              placeholder="Copyright"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="col-md-12 my-2 p-0">
              <button
                type="button"
                class="btn-outline-blue-sm ml-auto mr-15px collapsed"
                v-b-toggle.images_sub_section
              >
                Show
                {{ !sectionCollapse.images_sub_section ? "More" : "Less" }}
                <button type="button" class="btn-transparent chevron">
                  <chevron />
                </button>
              </button>
            </div>
            <b-collapse
              id="images_sub_section"
              class="col-md-12 mt-2 px-0"
              v-model="sectionCollapse.images_sub_section"
            >
              <div class="new-border rounded-10 py-2">
                <!-- Original Artwork -->
                <!-- <div class="col-md-12">
                  <h5>Original Artwork</h5>
                </div> -->

                <div class="col-md-12 mb-2">
                  <div class="row">
                    <div class="col-3 pr-0">
                      <div
                        class="d-flex justify-content-center align-item-center"
                      >
                        <label
                          class="material-file-upload"
                          @click.prevent.stop="
                            setModalData(
                              null,
                              artwork_image_height,
                              artwork_image_width,
                              4,
                              undefined,
                              'Movie Poster',
                              MovieContainer.original_lang_name
                            )
                          "
                        >
                          <div
                            class="label"
                            v-bind:class="{
                              'shift-up':
                                MovieContainer.original_artwork &&
                                MovieContainer.original_artwork.length > 0,
                            }"
                          >
                            Original Artwork
                          </div>
                          <div class="uploaded-file-name">
                            <div class="text-truncate pt-2">
                              {{ MovieContainer.original_artwork }}
                            </div>
                          </div>
                        </label>
                      </div>
                      <p class="error_message">
                        <!-- <span
                            v-if="
                              submitted &&
                                showErrorMessages &&
                                (!MovieContainer.original_artwork ||
                                  MovieContainer.original_artwork.length == 0)
                            "
                            >{{ messagepimage }}</span
                          > -->
                      </p>
                    </div>

                    <div class="col-2 pt-1 position-relative">
                      <ImagePreviewer
                        v-if="
                          MovieContainer.original_artwork &&
                            MovieContainer.original_artwork.length > 0
                        "
                        :img="_GetImagePath(MovieContainer.original_artwork)"
                        :clickFunc="
                          () => {
                            openImageModal(
                              'Original Artwork',
                              MovieContainer.original_artwork
                            );
                          }
                        "
                      />
                      <img
                        v-else
                        src="@/assets/img/icons/empty-image.svg"
                        alt="Empty Image"
                        height="35"
                        width="35"
                        class="rounded"
                      />
                      <img
                        v-if="MovieContainer.original_artwork !== ''"
                        src="@/assets/img/icons/trash.svg"
                        height="25"
                        width="25"
                        class="rounded cursor-pointer"
                        @click="removeImageHandler(MovieContainer, 5)"
                      />
                    </div>
                  </div>
                </div>

                <!-- Language Specific Other Images -->
                <div
                  class="col-md-12 mt-2"
                  v-if="
                    MovieContentContainer[0] &&
                      MovieContentContainer[0].moviePosters &&
                      MovieContentContainer[0].moviePosters.length > 0
                  "
                >
                  <h6 class="font-weight-bold">
                    Language Specific Other Images (optional)
                  </h6>
                </div>

                <div
                  class="col-md-12 mt-1"
                  v-if="
                    MovieContentContainer[0] &&
                      MovieContentContainer[0].moviePosters &&
                      MovieContentContainer[0].moviePosters.length > 0
                  "
                >
                  <div class="row">
                    <div
                      class="col-md-4"
                      v-for="(MovieContent,
                      MovieContentIndex) in MovieContentContainer"
                      :key="MovieContentIndex"
                    >
                      <h6 class="my-2">{{ MovieContent.langauge }}</h6>
                      <div class="row">
                        <div
                          v-for="(PosterItem,
                          PosterIndex) in MovieContent.moviePosters"
                          :key="PosterIndex + PosterItem.image_setting_name"
                          class="col-md-12 mb-3"
                        >
                          <div class="row">
                            <div class="col-8 pr-0">
                              <label
                                class="material-file-upload c-pointer"
                                @click.prevent.stop="
                                  setModalData(
                                    PosterIndex,
                                    PosterItem.image_setting_height,
                                    PosterItem.image_setting_width,
                                    2,
                                    MovieContentIndex,
                                    'Movie Poster',
                                    {
                                      lang_id: MovieContent.langaugeId,
                                      lang_name: MovieContent.langauge,
                                    }
                                  )
                                "
                              >
                                <div
                                  class="label"
                                  v-bind:class="{
                                    'shift-up':
                                      PosterItem.image_setting_path &&
                                      PosterItem.image_setting_path.length > 0,
                                  }"
                                >
                                  <div class="text-truncate">
                                    {{
                                      PosterItem.image_setting_name +
                                        " - " +
                                        PosterItem.image_setting_width +
                                        " X " +
                                        PosterItem.image_setting_height
                                    }}
                                  </div>
                                </div>
                                <div class="uploaded-file-name">
                                  <div class="text-truncate pt-2">
                                    {{ PosterItem.image_setting_path }}
                                  </div>
                                </div>
                              </label>
                            </div>
                            <div
                              class="col-4 align-self-start position-relative"
                            >
                              <ImagePreviewer
                                v-if="
                                  PosterItem.image_setting_path &&
                                    PosterItem.image_setting_path.length > 0
                                "
                                :img="
                                  _GetImagePath(PosterItem.image_setting_path)
                                "
                                :clickFunc="
                                  () => {
                                    openImageModal(
                                      PosterItem.image_setting_name,
                                      PosterItem.image_setting_path
                                    );
                                  }
                                "
                              />
                              <img
                                v-else
                                src="@/assets/img/icons/empty-image.svg"
                                height="35"
                                width="35"
                                class="rounded"
                              />
                              <img
                                v-if="PosterItem.image_setting_path !== ''"
                                src="@/assets/img/icons/trash.svg"
                                height="25"
                                width="25"
                                class="rounded cursor-pointer"
                                @click="removeImageHandler(PosterItem, 2)"
                              />
                              <!-- <img
                                  src="@/assets/img/icons/question.svg"
                                  height="20"
                                  width="20"
                                  class="ml-2"
                                  v-b-tooltip.hover
                                  :title="PosterItem.image_setting_desciption"
                                /> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Movie Scenes -->
                <div class="col-md-12 rounded-10">
                  <div class="col-md-12 heading pl-0">
                    <h5>Movie Scenes</h5>
                  </div>

                  <div class="col-md-12 mb-2">
                    <div class="row">
                      <div
                        v-for="(movieScenesItem,
                        movieScenesIndex) in movieScenes"
                        :key="movieScenesIndex"
                        class="col-md-1 mb-2 maxW85"
                      >
                        <div
                          class="movieSceneImageIcon"
                          v-if="movieScenesItem.image_path"
                        >
                          <img
                            :src="_GetImagePath(movieScenesItem.image_path)"
                            class="image-circle"
                            @click.prevent.stop="
                              setModalData(
                                movieScenesIndex,
                                NaN,
                                NaN,
                                3,
                                undefined,
                                'Movie Scene'
                              )
                            "
                          />
                          <div class="movieSceneImageoptions">
                            <div class="col-6 borderRight">
                              <span
                                class="icon-eye"
                                @click="
                                  openImageModal(
                                    'Scene Image',
                                    movieScenesItem.image_path
                                  )
                                "
                              ></span>
                            </div>
                            <div class="col-6">
                              <span
                                class="icon-delete-red"
                                @click="
                                  removeSceneImage($event, movieScenesIndex)
                                "
                              ></span>
                            </div>
                          </div>
                        </div>

                        <div class="row" v-if="false">
                          <div class="col-6 p-0">
                            <label
                              class="material-file-upload c-pointer"
                              @click.prevent.stop="
                                setModalData(
                                  movieScenesIndex,
                                  NaN,
                                  NaN,
                                  3,
                                  undefined,
                                  'Movie Scene'
                                )
                              "
                            >
                              <div
                                class="label"
                                v-bind:class="{
                                  'shift-up':
                                    movieScenesItem.image_path &&
                                    movieScenesItem.image_path.length > 0,
                                }"
                              >
                                <div class="text-truncate">
                                  Scene Image {{ movieScenesIndex + 1 }}
                                </div>
                              </div>
                              <div class="uploaded-file-name">
                                <div class="text-truncate pt-2">
                                  {{ movieScenesItem.image_path }}
                                </div>
                              </div>
                            </label>
                          </div>
                          <div class="col-6 align-self-start position-relative">
                            <ImagePreviewer
                              v-if="
                                movieScenesItem.image_path &&
                                  movieScenesItem.image_path.length > 0
                              "
                              :img="_GetImagePath(movieScenesItem.image_path)"
                              :clickFunc="
                                () => {
                                  openImageModal(
                                    'Scene Image',
                                    movieScenesItem.image_path
                                  );
                                }
                              "
                            />
                            <img
                              v-else
                              src="@/assets/img/icons/empty-image.svg"
                              height="35"
                              width="35"
                              class="rounded"
                            />
                            <img
                              v-if="movieScenesItem.image_path !== ''"
                              src="@/assets/img/icons/trash.svg"
                              height="25"
                              width="25"
                              class="rounded cursor-pointer"
                              @click="removeImageHandler(movieScenesItem, 3)"
                            />
                            <button
                              @click.prevent.stop="
                                removeSceneImage($event, movieScenesIndex)
                              "
                              class="btn-transparent"
                            >
                              <img
                                src="@/assets/img/icons/minus.svg"
                                height="30"
                                width="30"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="movieSceneImage">
                        <div
                          class="plusScenes"
                          @click.prevent.stop="
                            setModalData(
                              null,
                              NaN,
                              NaN,
                              6,
                              undefined,
                              'Movie Scene'
                            )
                          "
                        >
                          &#x254b;
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </b-collapse>
        </section>

        <!-- Trailers -->
        <section
          class="mb-3"
          :class="
            errorHandlerObj['errorSectionIndex'] == 4 ? 'sectionError' : ''
          "
        >
          <div
            class="section-title mb-1 d-flex justify-content-between section-border section-border"
            style="padding: 6px; align-items: center"
            v-b-toggle.trailers
          >
            <span class="fs">Trailers</span>

            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>

          <b-collapse
            id="trailers"
            class="mt-2"
            v-model="sectionCollapse.trailers"
          >
            <section class="row">
              <div class="w-100 mx-3 mb-3">
                <table
                  class="swc-report-table"
                  border="1"
                  style="table-layout: auto; background: white; zoom: 0.9"
                >
                  <thead>
                    <tr>
                      <th class="bg-lightprimary p-1" style="width: 160px">
                        Language
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 620px">
                        Trailer Link
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 110px">
                        Preview
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 110px">
                        Subtitle 1
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 110px">
                        Subtitle 2
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 80px"> </th>
                    </tr>
                  </thead>
                  <tbody v-if="movie_trailers && movie_trailers.length > 0">
                    <template
                      v-for="(movieTrailer,
                      movieTrailerIndex) in movie_trailers"
                    >
                      <tr :key="movieTrailerIndex">
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="movieTrailer.language"
                            @select="
                              onSelectLanguageHandler(
                                $event,
                                movieTrailerIndex,
                                1
                              )
                            "
                            placeholder="Language"
                            :options="Languages"
                            label="lang_name"
                            track-by="lang_id"
                            :multiple="false"
                            :name="`trailerlang${movieTrailerIndex}`"
                            :id="`trailerlang${movieTrailerIndex}`"
                            select-label="Select"
                            deselect-label="Remove"
                          />
                        </td>
                        <td class="text-left p-0">
                          <div class="manual_bill_input">
                            <input
                              v-model="movieTrailer.trailer_link"
                              type="text"
                              :name="'langtrailer' + movieTrailerIndex"
                              id="'langtrailer' + movieTrailerIndex"
                              placeholder="Trailer Link"
                            />
                          </div>
                        </td>
                        <td>
                          <a
                            v-if="movieTrailer.trailer_link"
                            :href="movieTrailer.trailer_link"
                            @click.prevent="
                              openTrailerPopup(movieTrailer.trailer_link)
                            "
                            class="video-btn-play"
                          ></a>
                          <!-- <a
                                v-if="movieTrailer.trailer_link"
                                data-v-1c16c5c0=""
                                :href="movieTrailer.trailer_link"
                                data-fancybox=""
                                class="video-btn-play"
                              ></a> -->
                          <div class="" v-else>NA</div>
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="movieTrailer.subtitle_lang_1"
                            @select="
                              onSelectSubtitleLanguageHandler(
                                $event,
                                movieTrailerIndex,
                                1,
                                1
                              )
                            "
                            placeholder="Subtitles"
                            :options="Languages"
                            label="lang_name"
                            track-by="lang_id"
                            :multiple="false"
                            :name="`trailersublang1${movieTrailerIndex}`"
                            :id="`trailersublang1${movieTrailerIndex}`"
                            select-label="Select"
                            deselect-label="Remove"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="movieTrailer.subtitle_lang_2"
                            @select="
                              onSelectSubtitleLanguageHandler(
                                $event,
                                movieTrailerIndex,
                                2,
                                1
                              )
                            "
                            placeholder="Subtitles"
                            :options="Languages"
                            label="lang_name"
                            track-by="lang_id"
                            :multiple="false"
                            :name="`trailersublang2${movieTrailerIndex}`"
                            :id="`trailersublang2${movieTrailerIndex}`"
                            selectLabel=""
                            select-label="Select"
                            deselect-label="Remove"
                          />
                        </td>
                        <td>
                          <div
                            class="icon-sm-minus blue-icon ml-2 btn"
                            @click.prevent.stop="
                              removeMovieTrailer(movieTrailerIndex)
                            "
                          ></div>
                        </td>
                      </tr>
                    </template>
                    <tr class="">
                      <td colspan="12">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click.prevent.stop="addMovieTrailer()"
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="">
                      <td colspan="12">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click.prevent.stop="addMovieTrailer()"
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </b-collapse>
        </section>
        <!-- MOVIE DETAILS - MOVIE FORMAT - MOVIE LANGUAGES - MOVIE DISTRIBUTOR -->
        <section class="mb-3">
          <div
            class="section-title mb-1 d-flex justify-content-between section-border section-border"
            style="padding: 6px; align-items: center"
            v-b-toggle.movieDetails
          >
            <div>
              <span class="fs"> Feature {{ $tc("Versions", 2) }} </span>
              <span class="font-weight-normal fs">
                {{ featureVersionsText }}
              </span>
            </div>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>

          <b-collapse
            id="movieDetails"
            class="mt-2"
            v-model="sectionCollapse.detailsAndDistributors"
          >
            <section class="row">
              <div class="w-100 mx-3 mb-3">
                <table
                  class="swc-report-table"
                  border="1"
                  style="table-layout: auto; background: white; zoom: 0.9"
                >
                  <thead>
                    <tr>
                      <th class="bg-lightprimary p-1" style="width: 160px">
                        Content Type<span class="required_star">*</span>
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 180px">
                        Language<span class="required_star">*</span>
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 145px">
                        Subtitle 1
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 145px">
                        Subtitle 2
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 200px">
                        Exp Format
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 160px">
                        Distributor<span class="required_star">*</span>
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 190px">
                        Sound Format
                      </th>
                      <!-- <th class="bg-lightprimary p-1" style="width: 190px">
                        Resolution
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 190px">
                        Aspect Ratio
                      </th> -->
                      <th class="bg-lightprimary p-1" style="width: 125px">
                        Update Poster
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 80px">
                        More
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 80px"> </th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="
                      MovieContainer.movieLangaugeFormatDistributor.length > 0
                    "
                  >
                    <template
                      v-for="(LangaugeFormatDistributor,
                      LangaugeFormatDistributorIndex) in MovieContainer.movieLangaugeFormatDistributor"
                    >
                      <tr
                        :key="`fv_` + LangaugeFormatDistributorIndex"
                        :class="
                          errorHandlerObj['errorSectionIndex'] == 5 &&
                          errorHandlerObj['errorArrayIndex'] ==
                            LangaugeFormatDistributorIndex
                            ? 'sectionError'
                            : ''
                        "
                      >
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="LangaugeFormatDistributor.mf_name"
                            @select="
                              onSelectFormatHandler(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            placeholder="Content Type"
                            :options="Formats"
                            label="mf_name"
                            track-by="mf_id"
                            :multiple="false"
                            name="selectformat"
                            id="selectformat"
                            select-label="Select"
                            deselect-label="Remove"
                            :allow-empty="false"
                            v-validate="'required'"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="
                              LangaugeFormatDistributor.searchable_language
                            "
                            @select="
                              onSelectLanguageHandler(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            @remove="
                              onRemoveLanguageHandler(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            :placeholder="$tc('language', 1)"
                            :options="Languages"
                            label="lang_name"
                            track-by="lang_id"
                            :multiple="false"
                            name="selectlanguage"
                            id="selectlanguage"
                            select-label="Select"
                            deselect-label="Remove"
                            v-validate="'required'"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="
                              LangaugeFormatDistributor.selected_subtitle_1
                            "
                            @select="
                              onSelectSubtitleLanguageHandler(
                                $event,
                                LangaugeFormatDistributorIndex,
                                1
                              )
                            "
                            @remove="
                              onRemoveSubtitleLanguageHandler(
                                $event,
                                LangaugeFormatDistributorIndex,
                                1
                              )
                            "
                            placeholder="Sub Title 1"
                            :options="LanguagesCopy"
                            label="iso_3"
                            track-by="lang_id"
                            :multiple="false"
                            name="selectsubtitlelanguage1"
                            id="selectsubtitlelanguage1"
                            :internalSearch="false"
                            @search-change="onSearchLanguage"
                            select-label="Select"
                            deselect-label="Remove"
                            :allow-empty="true"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="
                              LangaugeFormatDistributor.selected_subtitle_2
                            "
                            @select="
                              onSelectSubtitleLanguageHandler(
                                $event,
                                LangaugeFormatDistributorIndex,
                                2
                              )
                            "
                            placeholder="Sub Title 2"
                            :options="LanguagesCopy"
                            label="iso_3"
                            track-by="lang_id"
                            :allow-empty="true"
                            :multiple="false"
                            name="selectsubtitlelanguage2"
                            id="selectsubtitlelanguage2"
                            :internalSearch="false"
                            @search-change="onSearchLanguage"
                            select-label="Select"
                            deselect-label="Remove"
                            @remove="
                              onRemoveSubtitleLanguageHandler(
                                $event,
                                LangaugeFormatDistributorIndex,
                                2
                              )
                            "
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="
                              LangaugeFormatDistributor.selected_experience
                            "
                            @select="
                              onSelectExperienceHandler(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            @remove="
                              onRemoveExperienceHandler(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            placeholder="Experience Format"
                            :options="Experiences"
                            label="movie_experience"
                            track-by="movie_experience_id"
                            :multiple="false"
                            name="selectExperience"
                            id="selectExperience"
                            select-label="Select"
                            deselect-label="Remove"
                          />
                        </td>
                        <td
                          class="text-left p-0 manual_bill_item"
                          v-for="(DistributorItem,
                          DistributorIndex) in LangaugeFormatDistributor.movieDistributors"
                          :key="
                            LangaugeFormatDistributorIndex +
                              '_' +
                              DistributorIndex
                          "
                        >
                          <multiselect
                            v-model="DistributorItem.d_company_name"
                            @select="
                              onSelectDistributorHandler(
                                $event,
                                DistributorIndex,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            @remove="
                              onRemoveDistributorHandler(
                                $event,
                                DistributorIndex,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            :options="Distributors"
                            label="d_company_name"
                            track-by="d_id"
                            :multiple="false"
                            placeholder="Distributor"
                            name="selectdistributor-1"
                            id="selectdistributor-1"
                            class="text-wrap-multiselect"
                            select-label=""
                            deselect-label="Remove"
                            v-validate="'required'"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="LangaugeFormatDistributor.sound_format"
                            @select="
                              onSelectSoundFormatHandler(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            :multiple="false"
                            :options="soundFormatList"
                            :searchable="true"
                            label="sound_format_name"
                            track-by="sound_format_name"
                            placeholder="Sound Format"
                            select-label="Select"
                            deselect-label="Remove"
                          ></multiselect>
                        </td>
                        <!-- HIDE RESOLUTION AND ASPECT RATIO -->
                        <td class="text-left p-0 manual_bill_item" v-if="false">
                          <multiselect
                            v-model="
                              LangaugeFormatDistributor.movie_resolution_name
                            "
                            @select="
                              onSelectMovieResolution(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            :placeholder="$tc('Resolution', 1)"
                            :options="Resolutions"
                            label="resolution_short_code"
                            track-by="resolution_id"
                            :multiple="false"
                            name="selectResolution"
                            id="selectResolution"
                            select-label="Select"
                            deselect-label="Remove"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item" v-if="false">
                          <multiselect
                            v-model="
                              LangaugeFormatDistributor.movie_aspect_ratio_name
                            "
                            @select="
                              onSelectAspectRatio(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            placeholder="Aspect Ratio"
                            :options="AspectRatios"
                            label="aspect_ratio_name"
                            track-by="aspect_ratio_id"
                            :multiple="false"
                            name="selectAspectRatio"
                            id="selectAspectRatio"
                            select-label="Select"
                            deselect-label="Remove"
                          />
                        </td>
                        <!-- HIDE RESOLUTION AND ASPECT RATIO -->

                        <td>
                          <div
                            class=""
                            v-if="LangaugeFormatDistributor.md_thumbnail_url"
                          >
                            <ImagePreviewer
                              :img="
                                _GetImagePath(
                                  LangaugeFormatDistributor.md_thumbnail_url
                                )
                              "
                              :clickFunc="
                                () => {
                                  openImageModal(
                                    LangaugeFormatDistributor.md_thumbnail_name,
                                    LangaugeFormatDistributor.md_thumbnail_url
                                  );
                                }
                              "
                            />
                            <img
                              v-if="!LangaugeFormatDistributor.md_thumbnail_url"
                              src="@/assets/img/icons/trash.svg"
                              height="20"
                              width="20"
                              class="rounded cursor-pointer"
                              @click="
                                removeImageHandler(LangaugeFormatDistributor, 4)
                              "
                            />
                            <img
                              v-if="LangaugeFormatDistributor.md_thumbnail_url"
                              src="@/assets/img/icons/trash.svg"
                              height="25"
                              width="25"
                              class="rounded cursor-pointer"
                              @click="deleteImageUrl(LangaugeFormatDistributor)"
                            />
                          </div>
                          <div
                            v-else
                            class="d-flex justify-content-center align-items-center"
                            @click.prevent.stop="
                              setModalData(
                                LangaugeFormatDistributorIndex,
                                artwork_image_height,
                                artwork_image_width,
                                1,
                                undefined,
                                'Movie Poster',
                                LangaugeFormatDistributor.lang_name
                              )
                            "
                          >
                            <span
                              class="uploadposterBtn fa fa-upload"
                              style="font-size: 22px"
                            ></span>
                          </div>
                        </td>
                        <td>
                          <div
                            v-b-toggle="
                              `fv_collapse_${LangaugeFormatDistributorIndex}`
                            "
                          >
                            <button
                              type="button"
                              class="btn-transparent chevron"
                            >
                              <img
                                src="@/assets/img/icons/primary/chevron-down.svg"
                                height="24"
                                width="24"
                              />
                            </button>
                          </div>
                        </td>
                        <td>
                          <div
                            class="icon-sm-minus blue-icon ml-2 btn"
                            @click.prevent.stop="
                              removeLangaugeFormatDistributor(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                          ></div>
                        </td>
                      </tr>
                      <b-collapse
                        v-model="LangaugeFormatDistributor['showMore']"
                        :key="`collpase_` + LangaugeFormatDistributorIndex"
                        :id="`fv_collapse_${LangaugeFormatDistributorIndex}`"
                        class="mt-2"
                        tag="tr"
                      >
                        <td class="fv_collapse_inner" colspan="10">
                          <div class="row fv_collapse_inner_container">
                            <!-- Cinema Selection -->
                            <div class="col-3 mb-2">
                              <div class="row">
                                <div class="col-12 d-block align-items-center">
                                  <div class="dropdown-curve-container">
                                    <label>
                                      Cinema Code
                                      <span class="required_star"
                                        >*</span
                                      ></label
                                    >
                                    <multiselect
                                      v-model="
                                        LangaugeFormatDistributor.selected_cinema
                                      "
                                      track-by="cine_id"
                                      label="cine_code"
                                      :close-on-select="false"
                                      :options="newgroupRegionCinema"
                                      :multiple="true"
                                      group-values="Cinemas"
                                      group-label="label"
                                      :group-select="true"
                                      :limit="2"
                                      :limit-text="
                                        (count) => `& +${count} More`
                                      "
                                    >
                                      <span
                                        v-if="
                                          scope.option &&
                                            scope.option.hasOwnProperty(
                                              '$isLabel'
                                            ) &&
                                            scope.option['$isLabel']
                                        "
                                        class="checkbox-label"
                                        slot="option"
                                        slot-scope="scope"
                                      >
                                        {{ scope.option["$groupLabel"] }}
                                      </span>

                                      <span
                                        v-else
                                        class="checkbox-label"
                                        slot="option"
                                        slot-scope="scope"
                                      >
                                        <input
                                          class="test"
                                          type="checkbox"
                                          :checked="
                                            LangaugeFormatDistributor.selected_cinema.some(
                                              (x) =>
                                                scope.option.cine_id ==
                                                x.cine_id
                                            )
                                          "
                                          @focus.prevent
                                        />
                                        {{ scope.option.cine_name }}
                                      </span>
                                    </multiselect>
                                  </div>

                                  <p class="error_message"></p>
                                </div>
                              </div>
                            </div>
                            <div class="col-3 mb-2">
                              <div class="row">
                                <div class="col-12 d-block align-items-center">
                                  <div class="dropdown-curve-container">
                                    <label> Sales Channel </label>
                                    <multiselect
                                      v-model="
                                        LangaugeFormatDistributor.sales_channel
                                      "
                                      track-by="user_id"
                                      label="username"
                                      :options="aggregatorUsersList"
                                      :multiple="true"
                                      :limit="2"
                                      :limit-text="
                                        (count) => `& +${count} More`
                                      "
                                    >
                                      <span
                                        class="checkbox-label"
                                        slot="option"
                                        slot-scope="scope"
                                      >
                                        <input
                                          class="test"
                                          type="checkbox"
                                          :checked="
                                            LangaugeFormatDistributor.sales_channel &&
                                              LangaugeFormatDistributor.sales_channel.some(
                                                (x) =>
                                                  scope.option.user_id ==
                                                  x.user_id
                                              )
                                          "
                                          @focus.prevent
                                        />
                                        {{ scope.option.username }}
                                      </span>
                                    </multiselect>
                                  </div>

                                  <p class="error_message">
                                    <span
                                      v-if="
                                        submitted &&
                                          showErrorMessages &&
                                          LangaugeFormatDistributor.sales_channel &&
                                          LangaugeFormatDistributor
                                            .sales_channel.length == 0
                                      "
                                      >{{ messagesaleschannel }}</span
                                    >
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2 mb-2">
                              <label>{{ $tc("trailer", 2) }}</label>
                              <div class="d-flex align-items-center">
                                <div class="input-material">
                                  <input
                                    v-model="LangaugeFormatDistributor.trailer"
                                    type="text"
                                    name="trailers"
                                    id="trailers"
                                    placeholder="Trailer Link"
                                  />
                                </div>
                                <!-- <Tooltip :title="$t('movietrailer_tooltip')" /> -->
                                <a
                                  v-if="LangaugeFormatDistributor.trailer"
                                  data-v-1c16c5c0=""
                                  :href="LangaugeFormatDistributor.trailer"
                                  data-fancybox=""
                                  class="video-btn-play"
                                  @click.prevent="
                                    openTrailerPopup(
                                      LangaugeFormatDistributor.trailer
                                    )
                                  "
                                ></a>
                              </div>
                              <p class="error_message">
                                <span></span>
                              </p>
                            </div>
                            <div class="col-md-3 d-flex align-items-center">
                              <div
                                class="d-flex justify-content-center align-items-center"
                              >
                                <b-form-checkbox
                                  v-model="
                                    LangaugeFormatDistributor.macs_status
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                  class="j-checkbox mx-3"
                                >
                                  <div class="text-capitalize">
                                    {{ $t("send_to_maccs") }}
                                  </div>
                                </b-form-checkbox>
                                <b-form-checkbox
                                  v-if="QFX_CLIENT || showForeignMovieSection"
                                  v-model="
                                    LangaugeFormatDistributor.is_foreign_movie
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                  class="j-checkbox mx-3"
                                >
                                  <div class="text-capitalize">
                                    {{
                                      !showForeignMovieSection
                                        ? "Foreign Movie"
                                        : "Indian Movie"
                                    }}
                                  </div>
                                </b-form-checkbox>
                              </div>
                            </div>
                          </div>
                        </td>
                      </b-collapse>
                    </template>
                    <tr class="">
                      <td colspan="12">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click.prevent.stop="
                              addLangaugeFormatDistributor($event)
                            "
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="">
                      <td colspan="12">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click.prevent.stop="
                              addLangaugeFormatDistributor($event)
                            "
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </b-collapse>

          <div
            class="px-2 py-2"
            v-if="
              errorHandlerObj['errMsg'] &&
                errorHandlerObj['errorSectionIndex'] == 5
            "
          >
            <div class="error_message">{{ errorHandlerObj["errMsg"] }}</div>
          </div>
        </section>

        <!-- CUSTOM FIELDS SECTION -->
        <section class="mb-3">
          <div
            class="section-title mb-1 d-flex justify-content-between section-border section-border"
            style="padding: 6px; align-items: center"
            v-b-toggle.customFields
          >
            <span class="fs"
              >Additional Information
              {{ !additionalContentExists && !EPIX_CLIENT ? " - TBA" : "" }}</span
            >

            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>

          <b-collapse
            id="customFields"
            class="mt-2"
            v-model="sectionCollapse.customFields"
          >
            <div class="col-md-12 mb-2 mt-4 px-0">
              <!-- Remarks -->
              <div class="row">
                <div
                  class="col-md-3 mb-5"
                  v-for="(MovieContent,
                  MovieContentIndex) in MovieContentContainer"
                  :key="MovieContentIndex"
                  v-if="EPIX_CLIENT && MovieContentIndex == 0"
                >
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <label>{{ "WhatsApp Movie Title" }}</label
                      ><span class="required_star" v-if="EPIX_CLIENT">*</span>
                      <!-- <label>Movie Title ({{ MovieContent.langauge }})</label> -->
                      <input
                        v-model="MovieContent.movieContentTitle"
                        type="text"
                        :name="'movietitle' + MovieContentIndex"
                        id="'movietitle'+MovieContentIndex"
                        :placeholder="`WhatsApp Movie Title`"
                      />
                    </div>
                  </div>
                  <p class="error_message">
                    <span
                      v-if="
                        EPIX_CLIENT &&
                          submitted &&
                          MovieContent.movieContentTitle.length > 24
                      "
                      >Please Enter Movie Title For WhatsApp less then 24
                      characters {{ MovieContent.langauge }} Language</span
                    >
                  </p>
                </div>
                <div class="col-md-12 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="input-material-textarea">
                      <label>{{ $t("Remarks") }}</label>
                      <textarea
                        v-model="MovieContainer.remarks"
                        type="text"
                        rows="3"
                        name="remarks"
                        id="remarks"
                        placeholder="."
                      ></textarea>
                    </div>
                    <!-- <Tooltip :title="`Remarks`" /> -->
                  </div>
                  <p class="error_message"></p>
                </div>
              </div>
              <!-- <div class="section-title mb-4">Custom Field</div> -->
              <form v-if="custom_fields_list" class="row">
                <div
                  v-for="(field, fieldKey) in custom_fields_list"
                  :key="fieldKey"
                  class="col-lg-6 col-xl-4 mb-4"
                >
                  <div v-if="field.custom_field_type == 'text'">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          :minlength="field.min_length"
                          :maxlength="field.max_length"
                          type="text"
                          name="text_input"
                          v-model="input_data[fieldKey]"
                          placeholder="."
                        />
                        <label
                          :class="
                            input_data[fieldKey] !== undefined &&
                            input_data[fieldKey].length > 0
                              ? 'shift-up'
                              : ''
                          "
                          >{{ field.custom_field_name }}</label
                        >
                      </div>
                    </div>
                    <p class="error_message">
                      <span
                        v-if="
                          submitted &&
                            showErrorMessages &&
                            (input_data[fieldKey] === undefined ||
                              input_data[fieldKey] == '') &&
                            field.field_is_required == 'Y'
                        "
                        >Please Select {{ field.custom_field_name }}</span
                      >
                    </p>
                  </div>
                  <div v-if="field.custom_field_type == 'textarea'">
                    <div class="d-flex align-items-center">
                      <div class="input-material-textarea">
                        <textarea
                          :minlength="field.min_length"
                          :maxlength="field.max_length"
                          name="text_area"
                          v-model="input_data[fieldKey]"
                        ></textarea>
                        <label
                          :class="
                            input_data[fieldKey] != undefined &&
                            input_data[fieldKey].length > 0
                              ? 'shift-up'
                              : ''
                          "
                          >{{ field.custom_field_name }}</label
                        >
                      </div>
                    </div>
                    <p class="error_message">
                      <span
                        v-if="
                          submitted &&
                            showErrorMessages &&
                            (input_data[fieldKey] === undefined ||
                              input_data[fieldKey] == '') &&
                            field.field_is_required == 'Y'
                        "
                        >Please Select {{ field.custom_field_name }}</span
                      >
                    </p>
                  </div>
                  <div v-if="field.custom_field_type == 'number'">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          type="number"
                          :minlength="field.min_length"
                          :maxlength="field.max_length"
                          name="number"
                          :placeholder="field.custom_field_name"
                          v-model="input_data[fieldKey]"
                        />
                        <label
                          :class="
                            input_data[fieldKey] != undefined &&
                            input_data[fieldKey].length > 0
                              ? 'shift-up'
                              : ''
                          "
                          >{{ field.custom_field_name }}</label
                        >
                      </div>
                    </div>
                    <p class="error_message">
                      <span
                        v-if="
                          submitted &&
                            showErrorMessages &&
                            (input_data[fieldKey] === undefined ||
                              input_data[fieldKey] == '') &&
                            field.field_is_required == 'Y'
                        "
                        >Please Select {{ field.custom_field_name }}</span
                      >
                    </p>
                  </div>
                  <div
                    v-if="field.custom_field_type == 'checkbox'"
                    class="d-flex align-items-center"
                  >
                    <label class="mr-2">{{ field.custom_field_name }}</label>
                    <b-form-checkbox
                      name="check-button"
                      :value="true"
                      :unchecked-value="false"
                      class="j-checkbox"
                      v-model="input_data[fieldKey]"
                    ></b-form-checkbox>
                  </div>

                  <div
                    v-if="field.custom_field_type == 'rating'"
                    class="d-flex align-items-center"
                  >
                    <label class="mr-2">{{ field.custom_field_name }}</label>
                    <star-rating v-model="rating"></star-rating>
                  </div>

                  <!-- <p class="error_message">{{errorMessage}}</p> -->
                </div>

                <!-- <div class="col-md-12 text-center">
              <button @click.prevent.stop="submit" class="btn-blue">{{ $t('submit') }}</button>
            </div>-->
              </form>
            </div>
          </b-collapse>
        </section>

        <section class="mb-4">
          <div class="row">
            <!-- <div class="col-1 ml-2">
              <label>{{ $t("Upcoming") }}</label>
            </div>
            <div class="col-2">
              <b-form-checkbox
              class="d-none"
                v-model="MovieContainer.is_upcoming"
                unchecked-value="N"
                value="Y"
                name="check-button"
                switch
              />
            </div> -->
          </div>
        </section>

        <!-- MOVIE ACTION BUTTONS -->
        <section>
          <div class="col-md-12 text-center">
            <button
              :disabled="btenable"
              @click.prevent.stop="OnFinalSubmit(true)"
              class="btn-blue"
            >
              {{ $t("save") }}
            </button>
            <button
              :disabled="btenable"
              @click.prevent.stop="onSaveAsDraft(true)"
              class="btn-blue"
            >
              {{ $t("save") }} As Draft
            </button>
            <button
              :disabled="btenable"
              @click.prevent.stop="OnFinalSubmit(false)"
              class="btn-blue"
            >
              {{ $t("saveaddmore") }}
            </button>
            <button @click.prevent.stop="resetHandler" class="btn-black">
              {{ $t("reset") }}
            </button>
            <b-button class="btn-outline-grey" variant="default" to="movies">{{
              $t("cancel")
            }}</b-button>
          </div>
        </section>
      </form>
    </div>

    <!-- MOVIE POSTER IMAGE MODAL -->
    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      :title="tempModalImageName"
      hide-footer
    >
      <img :src="_GetImagePath(tempModalImagePath)" class="img-fluid" />
    </b-modal>

    <!-- View All Movie Details -->
    <b-modal title="All Movie Content" hide-footer ref="viewallmodal">
      <div
        v-for="(MovieContent, MovieContentIndex) in MovieContentContainer"
        :key="MovieContentIndex"
        class="mb-3"
      >
        <h4 class="mb-2">{{ MovieContent.langauge }}</h4>

        <div class="d-flex">
          <h6 class="pr-2">{{ $t("title") }}:</h6>
          <p>{{ MovieContent.movieContentTitle }}</p>
        </div>

        <h6>
          {{ $t("Short") }} {{ $tc("movie", 1) }} {{ $t("description") }}:
        </h6>
        <p>{{ MovieContent.movieShortDescription }}</p>

        <h6>{{ $t("Long") }} {{ $tc("movie", 1) }} {{ $t("description") }}:</h6>
        <p>{{ MovieContent.movieDescription }}</p>
        <hr />
      </div>
    </b-modal>

    <!-- Thumbnail IMAGE Crop MODAL -->
    <!-- <b-modal id="imagecropper" hide-header hide-footer no-close-on-backdrop>
      <button class="btn-clearDate text-right" v-on:click="hideCropperModal('imagecropper')">✖</button>

      <label class="h4 mt-2 mb-4 text-center">Crop Image</label>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :aspect-ratio="width / height"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <br />
      <button class="btn-blue" @click.prevent.stop="cropImage">Save</button>
    </b-modal>-->

    <!-- 129*192 -->
    <!-- Thumbnail IMAGE Crop MODAL -->
    <!-- <b-modal id="imagecropperposters" hide-header hide-footer no-close-on-backdrop>
      <button
        class="btn-clearDate text-right"
        v-on:click="hideCropperModal('imagecropperposters')"
      >✖</button>

      <label class="h4 mt-2 mb-4 text-center">Crop Image</label>
      <vue-cropper
        ref="cropperposters"
        :src="imgSrc"
        :viewMode="1"
        :aspect-ratio="width / height"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <br />
      <button class="btn-blue" @click.prevent.stop="cropImagePoster">Save</button>
    </b-modal>-->
    <ImageGallery
      v-bind:propImageName="MovieContainer.movieTitle"
      :img_desc="`${MovieContainer.movieTitle} Poster`"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
      :showPercentageLoader="true"
      menu="B"
      :category="image_category"
      :language="image_language"
      :resetImgData="false"
    ></ImageGallery>
  </div>
</template>

<script>
  import { debounce } from "vue-debounce";
  import { generateRandomCode } from "@/helper/collection";
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import Vue from "vue";
  import _ from "lodash";
  import VueCropper from "vue-cropperjs";
  import "cropperjs/dist/cropper.css";
  import moment from "moment";
  import ImageGallery from "../../ImageGallery/imageGalleryModal";
  import EditablePills from "@/components/Partials/EditablePills.vue";
  import chevron from "@/components/Partials/Chevron.vue";
  import { mapGetters } from "vuex";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import ImagePreviewer from "@/components/Partials/ImagePreviewer.vue";
  import xml2js from "xml2js";
  import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";
  import CastIcon from "@/components/Partials/CastIcon.vue";

  export default {
    components: {
      VueCropper,
      ImageGallery,
      VueTimepicker,
      EditablePills,
      chevron,
      ImagePreviewer,
      CastIcon
    },
    data() {
      return {
        CastMasters: [],
        whatsAppMovieTitleForEpix: {},
        newgroupRegionCinema: [],
        errorHandlerObj: {
          errMsg: ``,
          errorSectionIndex: null,
          errorArrayIndex: null,
        },
        aggregatorUsersList: [],
        artwork_image_height: 3050,
        artwork_image_width: 2160,
        event_identifier: generateRandomCode(3),
        searchValue: "",
        isSearchLoading: false,
        movieSearchKeys:
          "movie_title,movie_unique_identifier,alternate_movie_name_language,g_name,d_company_name,mcc_cast_name",
        kdmArray: [
          {
            kdm_id: 1,
            kdm_title: "No KDM",
          },
          {
            kdm_id: 2,
            kdm_title: "KDM myCinema",
          },
          {
            kdm_id: 3,
            kdm_title: "KDM Studio",
          },
        ],
        versionArray: [],
        featureVersionsArray: [],
        movieEventData: null,
        uuidErrorMessage: "",
        ErrorIndex: [],
        Movies: [],
        parentVersions: [],
        movieContentIndex: null,
        calledby: null,
        set_width: null,
        set_height: null,
        finalIndex: null,
        showModal: false,
        showContentListView: false,
        original_distributor: null,
        productionCompany:[],
        original_language: null,
        // Movies Search
        searchDebounce: null,
        searchMovies: [],
        selectedSearchMovies: null,
        isSearchLoading: false,
        ShowTypeArray: [
          {
            booking_type_id: "4",
            screening_name: "Classic",
            column_name: "is_classic_show",
          },
          {
            booking_type_id: "3",
            screening_name: "Private",
            column_name: "is_private_show",
          },
          {
            booking_type_id: "1",
            screening_name: "Confirmed",
            column_name: "is_confirmed_show",
          },
          {
            booking_type_id: "2",
            screening_name: "Crowd Source",
            column_name: "is_crowd_show",
          },
          {
            booking_type_id: "5",
            screening_name: "Movie Club",
            column_name: "is_movie_club",
          },
        ],

        //
        selected_country_rating: null,
        selected_country: null,
        btenable: false,
        movieindex: "",
        width: null,
        height: null,
        file: "",
        imgSrc: "",
        cropImg: "",
        filename: "",
        indexofthubmnail: "",
        messagegenre: "Please Select Genre.",
        messageproduction: "Please Select Production Company.",
        messagecinema: "Please Select Cinema.",
        messageprating: "Please Select Ratings",
        messagedistributor: "Please Select Distributor",
        messagesaleschannel: "Please Select Sales Channel.",
        messagepimage: "Please Upload Thumbnail Image.",
        messagepgenre: "Please Select Genre.",
        messagecountry: "Please Select Country.",
        messagestate: "Please Select State.",
        messagecity: "Please Select City.",
        messagerole: "Please Select Role.",
        messagepcompany: "Please Select Production Company.",
        messageformat: "Please Select Format.",
        messageExperience: "Please Select Experience Format.",
        messageAspectRatio: "Please Select Aspect Ratio.",
        messageResolution: "Please Select Movie Resolution.",
        messagesoundformat: "Please Select Sound Format.",
        messagelanguage: "Please Select Language.",
        messageoriginallanguage: "Please Select Original Language.",
        messageoriginalDistributor: "Please Select Default Distributor.",
        messagetrailers: "Please Select Trailers.",
        submitted: false,
        showErrorMessages: true,
        productioncompany: "Production Company",
        selectgenre: "Select Genre",
        // JAY
        tempModalImageName: null,
        tempModalImagePath: null,
        translationLoading: [false, false, false, false, false, false],
        translated: [false, false, false, false, false, false],
        // JAY
        /**
         * Saif
         */
        CinemasGroupedByRegion: [],
        activeClass: 0,
        selectedNewDate: "",
        ContentLanguages: [],
        ContentLanguagesMethod: {
          GET: "/admin/",
          tableName: "global_options",
          urlKey: "",
        },
        Countries: [],
        Genres: [],
        Productions: [],
        Languages: [],
        LanguagesCopy: [],
        Regions: [],
        LanguagesMethod: {
          GET: "/admin/",
          tableName: "ms_language",
          urlKey: "languages",
        },
        Formats: [],
        // The preferred initial value for the Formats selector dropdown
        initialPreferredFormat: "2D",
        Ratings: [],
        // The preferred initial value for the Ratings selector dropdown
        initialPreferredRating: "TBA",
        Crews: [],
        Cities: [],
        States: [],
        Distributors: [],
        productionCompanyList:[],
        Cinemas: [],
        Posters: [],
        SceneImages: [],
        Experiences: [],
        AspectRatios: [],
        Resolutions: [],
        PostersMethod: {
          GET: "/admin/",
          tableName: "ms_image_settings",
          urlKey: "",
        },
        showViewAllPopup: false,
        subdistributor: [],
        filterdata: [],
        //
        EachFormat_SelectedDistri_Cinema: [],
        image_category: "",
        image_language: {},
        MovieContainer: {
          movieTitle: "",
          movieAlternateLangTitle: "",
          movie_isActive: "Y",
          ms_foreign_movie: "Y",
          movie_is_draft: "N",
          is_upcoming: "N",
          country_name: "",
          imdb_link: "",
          country_id: null,
          productionCompany: [],
          // production_company_id:null,
          genres: [],
          labels: [],
          sound_formats: [],
          original_lang_id: null,
          original_lang_name: "",
          selected_original_language: "",
          original_distributor_id: null,
          original_distributor_name: "",
          selected_og_distributor: "",
          original_artwork: "",
          original_trailer: {
            language_id: null,
            language: null,
            trailer_link: "",
            subtitle_lang_id_1: null,
            subtitle_lang_1: null,
            subtitle_lang_id_2: null,
            subtitle_lang_2: null,
          },
          original_release_date: "",
          copyright: "",
          movie_unique_identifier: "",
          external_code: "",
          ho_film_code: "",
          is_classic_show: false,
          is_confirmed_show: false,
          is_private_show: false,
          is_crowd_show: false,
          is_movie_club: false,
          is_event: false,
          selected_version: [],
          selected_parent_movie: null,
          parent_movie_id: null,
          parent_md_id: null,
          remarks: "",
          movieLangaugeFormatDistributor: [
            // {
            //   id: "",
            //   lang_name: "",
            //   lang_id: null,
            //   format_id: null,
            //   format_name: "",
            //   // sound_format_id: null,
            //   // sound_format_name: "",
            //   trailer: "",
            //   md_thumbnail_url: "",
            //   md_thumbnail_path: "/uploads/moviethumbnail/",
            //   md_thumbnail_name: "Upload Poster Artwork",
            //   md_thumbnail_size: "",
            //   subtitle_language_id_1: null,
            //   subtitle_language_name_1: "",
            //   subtitle_language_id_2: null,
            //   subtitle_language_name_2: "",
            //   sound_format_id: null,
            //   sound_format_name: "",
            //   sound_format: "",
            //   tms_id: "",
            //   uuid: "",
            //   movie_tms_length: "",
            //   movie_tms_intermission_time: "",
            //   movie_tms_credits_time: "",
            //   movie_aspect_ratio_id: null,
            //   movie_aspect_ratio_name: "",
            //   movie_experience_format_id: null,
            //   movie_experience_format_name: null,
            //   movie_resolution_id: null,
            //   movie_resolution_name: "",
            //   is_classic_show: false,
            //   is_confirmed_show: false,
            //   is_private_show: false,
            //   is_crowd_show: false,
            //   movieDistributors: [
            //     {
            //       id: "",
            //       distributor_name: "",
            //       distributor_id: null,
            //       sub_distributor_name: "",
            //       sub_distributor_id: null,
            //       city_name: "",
            //       city_id: null,
            //       state_name: "",
            //       state_id: null,
            //       country_name: "",
            //       country_id: null,
            //       fromdate: new Date(),
            //       todate: new Date(),
            //       // NEW
            //       selected_cinema: []
            //       // cinema_id: null,
            //       // cinema_name: ""
            //     }
            //   ],
            //   selected_cinema: [],
            //   licence_start_date: "",
            //   licence_end_date: "",
            //   selectShowType: [],
            //   interval_time: ""
            // }
          ],
          movieRatings: [
            {
              id: "",
              country_name: "",
              country_id: null,
              rating: "",
              rating_id: null,
              releaseDate: null,
              intervalTime: "0",
              // date: new Date(2016, 9, 16),
              runTime: "0",
              region_id: null,
              region_obj: null,
              region_name: "",
            },
          ],
        },
        MovieContentContainer: [],
        isRoleID: true,
        // Scenes: [{
        //   SceneImageUrl: "",
        //   SceneImageName: ""
        // }],
        //
        MovieDetailsCityAndStatesHandler: [
          [
            {
              country_id: null,
              stateList: [],
              cityList: [],
            },
          ],
        ],
        custom_fields_list: [],
        input_data: [],
        soundFormatList: [],
        sectionCollapse: {
          basicInfo: true,
          filmInfo: false,
          detailsAndDistributors: false,
          censorRatings: false,
          movieContent: false,
          images: false,
          scenes: false,
          customFields: false,
          trailers: false,
          images_sub_section: false,
          trailers_sub_section: false,
          other_cast_crew: false,
        },
        // movieScenes: [
        //   {
        //     image_path: "",
        //   },
        // ],
        movieScenes: [],
        movie_trailers: [],
        cast_and_crew: [],
        defaultCountry: {},
        dummy: 5,
        fpsOptions: [24, 25],
        leadTimes: [
          {
            leadTimeHH: "00",
            leadTimeMM: "00",
          },
        ],
        originalReleaseDate: null,
        Labels: [],
        fv_errorMessage: "",
        fv_errorMessage_index: null,
        /**
         * END
         */
      };
    },
    created() {
      this.getMovieContentLangauge();
    },
    beforeMount() {
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
        this.getCinemasList(obj);
      } else {
        this.getCinemasList();
      }
      let obj = this.secureStore.get("USINFO").cinema_id;
      this.getCountriesList();
      this.getGenreList();
      this.getProductionList();
      this.getFormatsList();
      this.getRatingsList();
      this.getCrewsList();
      this.getDistributorsList();
      this.getCustomFields();
      this.getSoundFormats();
      this.getResolutionsList();
      this.getAspectRatiosList();
      this.getMovieExperiencesList();
      this.getRegions();
      this.getLabelList();
      this.getDefaultScreeningType();
      this.getPosAggregatorUsers();
      this.getCastMasters();
      this.MovieContainer.movie_unique_identifier = this.getuniqueSuissaid();
      // this.getAllActiveMovies();
    },
    mounted() {
      setTimeout(() => {
        this.autoGenerateFeatureVersions();
      }, 3000);
    },
    // watch: {
    //   MovieContainer: function(newVal) {
    //     if (newVal) {
    //       console.log("MovieContainer :", this.MovieContainer);
    //     }
    //   }
    // },
    watch: {
      finalImagePath(newval) {
        if (newval) {
          if (this.calledby == 1) {
            this.MovieContainer.movieLangaugeFormatDistributor[
              this.finalIndex
            ].md_thumbnail_url = newval;
          } else if (this.calledby == 2) {
            console.log("this.movieContentIndex :>> ", this.movieContentIndex);
            console.log("this.finalIndex :>> ", this.finalIndex);
            this.MovieContentContainer[this.movieContentIndex].moviePosters[
              this.finalIndex
            ].image_setting_path = newval;
            //     this.MovieContentContainer[MovieContentIndex].moviePosters[
            //   PosterIndex
            // ];
          } else if (this.calledby == 3) {
            this.movieScenes[this.finalIndex].image_path = newval;
          } else if (this.calledby == 4) {
            this.MovieContainer.original_artwork = newval;
          } else if (this.calledby == 5) {
            this.MovieContentContainer[this.movieContentIndex].artwork = newval;
          } else if (this.calledby == 6) {
            this.movieScenes.push({
              image_path: newval,
            });
          }
        }
        this.$forceUpdate();
      },
    },
    computed: {
      ...mapGetters(["finalImagePath"]),
      englishContentIndex() {
        let index = 0;
        index = this.MovieContentContainer.findIndex((i) => (i.langaugeId == 1))
        console.log('index', index);

        return index < 0 ? 0 : index
      },
      QFX_CLIENT() {
        return CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME;
      },
      EPIX_CLIENT() {
        return CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME;
      },
      showForeignMovieSection() {
        return CLIENT_NAMES_OBJ.has_foreign_movie_options.includes(
          String(this.CLIENT_SETUP_NAME)
        );
      },
      checkAddMoreRatings() {
        let count = 0;
        this.MovieContainer.movieRatings.forEach((x) => {
          if (x.region_id == 0) {
            count++;
          }
        });
        if (count > 0) {
          return false;
        } else {
          return true;
        }
      },
      autoGenerateFV() {
        let globalOptions = this.$store.getters.getGlobalOptions;
        let settings = [];
        let status = false;
        if (globalOptions.length > 0) {
          settings = globalOptions.filter(
            (x) => x.go_key == "AUTO_CREATE_MOVIE_VERSIONS"
          );
          if (settings.length > 0) {
            status = settings[0].go_value == "Y" ? true : false;
          }
        }
        return status;
      },
      ShowTypeArrayNew() {
        let tempArray = [];
        if (this.getMyCinemaStatusNew() == "N") {
          tempArray = this.ShowTypeArray.filter((x) => x.booking_type_id == 4);
        } else {
          tempArray = this.ShowTypeArray;
        }

        return tempArray;
      },
      disableFeatureVersion() {
        if (this.MovieContainer.is_event) {
          return true;
        } else {
          return false;
        }
      },
      basicinfotext: function() {
        let textarr = [];
        if (this.MovieContainer.movie_unique_identifier) {
          textarr.push(this.MovieContainer.movie_unique_identifier);
        }
        if (this.MovieContainer.movieTitle) {
          let title = this.MovieContainer.movieTitle;

          if (
            this.MovieContainer.movieRatings &&
            this.MovieContainer.movieRatings[0] &&
            this.MovieContainer.movieRatings[0].releaseDate
          ) {
            let year = this.MovieContainer.movieRatings[0].releaseDate.substr(
              0,
              4
            );

            title += ` (${year})`;
          }
          textarr.push(title);
        }
        if (this.MovieContainer.is_classic_show) {
          textarr.push("CLAS");
        }
        if (this.MovieContainer.is_private_show) {
          textarr.push("PRIV");
        }
        if (this.MovieContainer.is_confirmed_show) {
          textarr.push("CONF");
        }
        if (this.MovieContainer.is_crowd_show) {
          textarr.push("CROWD,");
        }

        if (textarr.length > 0) {
          return ` - ${textarr.join(", ")}`;
        }

        return "";
      },
      moviecontentexists: function() {
        if (
          this.MovieContentContainer &&
          this.MovieContentContainer.length > 0
        ) {
          return this.MovieContentContainer.some((x) => {
            return x.movieShortDescription || x.movieDescription;
          });
        } else {
          return false;
        }
      },
      additionalContentExists: function() {
        if (this.MovieContainer.remarks) {
          return true;
        } else if (
          this.custom_fields_list &&
          this.custom_fields_list.some((x, i) => this.input_data[i])
        ) {
          return true;
        } else {
          return false;
        }
      },
      featureVersionsText: function() {
        let dummy = this.dummy;
        if (this.MovieContainer.movieLangaugeFormatDistributor.length > 0) {
          let main_text_arr = [];
          for (let x of this.MovieContainer.movieLangaugeFormatDistributor) {
            let temp_arr = [];
            if (x.searchable_language && x.searchable_language.iso_3)
              temp_arr.push(x.searchable_language.iso_3);
            if (x.subtitle_language_name_1 && x.subtitle_language_name_1.iso_3)
              temp_arr.push(x.subtitle_language_name_1.iso_3);
            if (x.subtitle_language_name_2 && x.subtitle_language_name_2.iso_3)
              temp_arr.push(x.subtitle_language_name_2.iso_3);
            if (x.format_name) temp_arr.push(x.format_name);

            if (temp_arr.length > 0) {
              main_text_arr.push(temp_arr.join("-"));
            }
          }

          if (main_text_arr.length > 0) {
            return ` - (${
              this.MovieContainer.movieLangaugeFormatDistributor.length
            }) (${main_text_arr.join(", ")})`;
          } else {
            return ` - (${this.MovieContainer.movieLangaugeFormatDistributor.length})`;
          }
        } else {
          return "";
        }
      },
    },
    methods: {
      moment,
      onChangeMovieTitle(event) {
        let movieTitle = this.MovieContainer.movieTitle || "";
        let englishIndex = this.MovieContentContainer.findIndex(
          (MovieContent) => MovieContent.langauge.toLowerCase() === "english"
        );
        if (englishIndex > -1) {
          this.MovieContentContainer[englishIndex][
            "movieContentTitle"
          ] = movieTitle;
        }
      },
      openTrailerPopup(url) {
        const width = 800; // Set the desired width of the popup window
        const height = 600; // Set the desired height of the popup window
        const left = screen.width / 2 - width / 2; // Center the popup horizontally
        const top = screen.height / 2 - height / 2; // Center the popup vertically
        window.open(
          url,
          "_blank",
          `width=${width},height=${height},top=${top},left=${left},resizable=yes`
        );
      },
      changeOriginalFvdata(obj, type) {
        if (this.autoGenerateFV) {
          this.MovieContainer.movieLangaugeFormatDistributor.forEach((x) => {
            if (type == "lang") {
              x["searchable_language"] = obj;
              x["lang_id"] = obj.lang_id;
              x["lang_name"] = obj.lang_name;
            }
          });
        }
      },
      autoGenerateFeatureVersions() {
        if (this.autoGenerateFV) {
          let temp_Formats =
            this.Formats.length > 0
              ? _.cloneDeep(this.Formats)
              : [...{ mf_id: null, mf_name: "" }];
          let temp_soundFormatList =
            this.soundFormatList.length > 0
              ? _.cloneDeep(this.soundFormatList)
              : [{ sound_format_id: null, sound_format_name: "" }];
          let temp_Experiences =
            this.Experiences.length > 0
              ? _.cloneDeep(this.Experiences)
              : [{ movie_experience_id: null, movie_experience: "" }];
          let temp_AspectRatios =
            this.AspectRatios.length > 0
              ? _.cloneDeep(this.AspectRatios)
              : [{ aspect_ratio_id: null, aspect_ratio_name: "" }];
          let temp_Resolutions =
            this.Resolutions.length > 0
              ? _.cloneDeep(this.Resolutions)
              : [{ resolution_id: null, resolution_short_code: "" }];

          let finalArray = [];
          let leadTimeArray = [];

          console.log("temp_Formats", temp_Formats);
          console.log("temp_soundFormatList", temp_soundFormatList);
          console.log("temp_Experiences", temp_Experiences);
          console.log("temp_AspectRatios", temp_AspectRatios);
          console.log("temp_Resolutions", temp_Resolutions);

          console.log("running loop");

          // temp_Formats.forEach((format) => {
          //   temp_soundFormatList.forEach((soundFormat) => {
          //     temp_Experiences.forEach((experience) => {
          //       temp_AspectRatios.forEach((aspectRatio) => {
          //         temp_Resolutions.forEach((resolution) => {
          //           console.log('inside obj');
          //           let obj = {
          //             id: "",
          //             lang_name: "",
          //             lang_id: null,
          //             format_id: format.mf_id,
          //             format_name: format.mf_name,
          //             searchable_language: {},
          //             trailer: "",
          //             md_thumbnail_url: "",
          //             md_thumbnail_path: "/uploads/moviethumbnail/",
          //             md_thumbnail_name: "Upload Poster",
          //             md_thumbnail_size: "",
          //             subtitle_language_id_1: null,
          //             subtitle_language_name_1: null, //obj
          //             subtitle_language_id_2: null,
          //             subtitle_language_name_2: "", //obj
          //             sales_channel: _.cloneDeep(this.aggregatorUsersList),
          //             dcp_available: "N",
          //             tms_id: "",
          //             macs_status: "Y",
          //             uuid: "",
          //             kdm: null,
          //             kdm_id: null,
          //             selected_kdm: "",
          //             key_valid_from: "",
          //             key_valid_to: "",
          //             movie_tms_length: this.MovieContainer.movieRatings && this.MovieContainer.movieRatings.length > 0 &&
          //             this.MovieContainer.movieRatings[0].runTime ? this.getTimeString(this.MovieContainer.movieRatings[0].runTime) : "",
          //             movie_tms_intermission_time: "",
          //             movie_tms_credits_time: "",
          //             movie_fps: 24,
          //             movie_length_in_frames: null,
          //             movie_intermission_time_in_frames: null,
          //             movie_credits_time_in_frames: null,
          //             sound_format_id: soundFormat.sound_format_id,
          //             movie_aspect_ratio_id: aspectRatio.aspect_ratio_id,
          //             movie_aspect_ratio_name: aspectRatio,
          //             movie_experience_format_id: experience.movie_experience_id,
          //             movie_experience_format_name: experience,
          //             movie_resolution_id: resolution.resolution_id,
          //             movie_resolution_name: resolution,
          //             is_classic_show: this.MovieContainer.is_classic_show,
          //             is_confirmed_show: this.MovieContainer.is_confirmed_show,
          //             is_private_show: this.MovieContainer.is_private_show,
          //             is_crowd_show: this.MovieContainer.is_crowd_show,
          //             is_movie_club: this.MovieContainer.is_movie_club,
          //             movieDistributors: [
          //               {
          //                 id: "",
          //                 distributor_name: this.MovieContainer.original_distributor_name?this.MovieContainer.original_distributor_name: "",
          //                 distributor_id: this.MovieContainer.original_distributor_id ?this.MovieContainer.original_distributor_id : null,
          //                 d_company_name: this.MovieContainer.original_distributor_name ? _.cloneDeep(this.MovieContainer.original_distributor_name) : "", //obj
          //                 city_name: "",
          //                 city_id: null,
          //                 state_name: "",
          //                 state_id: null,
          //                 country_name: "",
          //                 country_id: null,
          //                 fromdate: new Date(),
          //                 todate: new Date(),
          //                 selected_cinema: [],
          //                 sub_distributor_name: "",
          //                 sub_distributor_id: null
          //               }
          //             ],
          //             selected_cinema: this.Cinemas || [],
          //             licence_start_date: this.originalReleaseDate ? moment(this.originalReleaseDate).format("YYYY-MM-DD") : "",
          //             licence_end_date: this.originalReleaseDate ? moment(this.originalReleaseDate).add(365, "days").format("YYYY-MM-DD") : "",
          //             selectShowType: [],
          //             interval_time: "",
          //             mf_name: format,
          //             sound_format_name: soundFormat.sound_format_name,
          //             sound_format: soundFormat
          //           }

          //           let leadtime = {
          //             leadTimeHH: "00",
          //             leadTimeMM: "00",
          //           };
          //           leadTimeArray.push(leadtime);
          //           finalArray.push(obj);
          //         })
          //       })
          //     })
          //   })
          // })

          // temp_Formats.forEach((format) => {
          //   temp_soundFormatList.forEach((soundFormat) => {
          //     temp_Experiences.forEach((experience, expIndex) => {
          //       if(expIndex == 0) {
          //         temp_AspectRatios.forEach((aspectRatio, aspectRatioIndex) => {
          //           if(aspectRatioIndex == 0) {
          //             temp_Resolutions.forEach((resolution, resolutionIndex) => {
          //               if(resolutionIndex == 0) {
          //                 console.log('inside obj');
          //                 let obj = {
          //                   id: "",
          //                   lang_name: "",
          //                   lang_id: null,
          //                   format_id: format.mf_id,
          //                   format_name: format.mf_name,
          //                   searchable_language: {},
          //                   trailer: "",
          //                   md_thumbnail_url: "",
          //                   md_thumbnail_path: "/uploads/moviethumbnail/",
          //                   md_thumbnail_name: "Upload Poster",
          //                   md_thumbnail_size: "",
          //                   subtitle_language_id_1: null,
          //                   subtitle_language_name_1: null, //obj
          //                   subtitle_language_id_2: null,
          //                   subtitle_language_name_2: "", //obj
          //                   sales_channel: _.cloneDeep(this.aggregatorUsersList),
          //                   dcp_available: "N",
          //                   tms_id: "",
          //                   macs_status: "Y",
          //                   uuid: "",
          //                   kdm: null,
          //                   kdm_id: null,
          //                   selected_kdm: "",
          //                   key_valid_from: "",
          //                   key_valid_to: "",
          //                   movie_tms_length: this.MovieContainer.movieRatings && this.MovieContainer.movieRatings.length > 0 &&
          //                   this.MovieContainer.movieRatings[0].runTime ? this.getTimeString(this.MovieContainer.movieRatings[0].runTime) : "",
          //                   movie_tms_intermission_time: "",
          //                   movie_tms_credits_time: "",
          //                   movie_fps: 24,
          //                   movie_length_in_frames: null,
          //                   movie_intermission_time_in_frames: null,
          //                   movie_credits_time_in_frames: null,
          //                   sound_format_id: soundFormat.sound_format_id,
          //                   movie_aspect_ratio_id: aspectRatio.aspect_ratio_id,
          //                   movie_aspect_ratio_name: aspectRatio,
          //                   movie_experience_format_id: experience.movie_experience_id,
          //                   movie_experience_format_name: experience,
          //                   movie_resolution_id: resolution.resolution_id,
          //                   movie_resolution_name: resolution,
          //                   is_classic_show: this.MovieContainer.is_classic_show,
          //                   is_confirmed_show: this.MovieContainer.is_confirmed_show,
          //                   is_private_show: this.MovieContainer.is_private_show,
          //                   is_crowd_show: this.MovieContainer.is_crowd_show,
          //                   is_movie_club: this.MovieContainer.is_movie_club,
          //                   movieDistributors: [
          //                     {
          //                       id: "",
          //                       distributor_name: this.MovieContainer.original_distributor_name?this.MovieContainer.original_distributor_name: "",
          //                       distributor_id: this.MovieContainer.original_distributor_id ?this.MovieContainer.original_distributor_id : null,
          //                       d_company_name: this.MovieContainer.original_distributor_name ? _.cloneDeep(this.MovieContainer.original_distributor_name) : "", //obj
          //                       city_name: "",
          //                       city_id: null,
          //                       state_name: "",
          //                       state_id: null,
          //                       country_name: "",
          //                       country_id: null,
          //                       fromdate: new Date(),
          //                       todate: new Date(),
          //                       selected_cinema: [],
          //                       sub_distributor_name: "",
          //                       sub_distributor_id: null
          //                     }
          //                   ],
          //                   selected_cinema: this.Cinemas || [],
          //                   licence_start_date: this.originalReleaseDate ? moment(this.originalReleaseDate).format("YYYY-MM-DD") : "",
          //                   licence_end_date: this.originalReleaseDate ? moment(this.originalReleaseDate).add(365, "days").format("YYYY-MM-DD") : "",
          //                   selectShowType: [],
          //                   interval_time: "",
          //                   mf_name: format,
          //                   sound_format_name: soundFormat.sound_format_name,
          //                   sound_format: soundFormat
          //                 }

          //                 let leadtime = {
          //                   leadTimeHH: "00",
          //                   leadTimeMM: "00",
          //                 };
          //                 leadTimeArray.push(leadtime);
          //                 finalArray.push(obj);
          //               }
          //             })
          //           }
          //        })
          //       }
          //     })
          //   })
          // })

          temp_Formats.forEach((format) => {
            temp_soundFormatList.forEach((soundFormat) => {
              console.log("inside obj");
              let obj = {
                id: "",
                lang_name: "",
                lang_id: null,
                format_id: format.mf_id,
                format_name: format.mf_name,
                searchable_language: {},
                trailer: "",
                md_thumbnail_url: "",
                md_thumbnail_path: "/uploads/moviethumbnail/",
                md_thumbnail_name: "Upload Poster",
                md_thumbnail_size: "",
                selected_subtitle_1: null,
                selected_subtitle_2: null,
                subtitle_language_id_1: null,
                subtitle_language_name_1: null, //obj
                subtitle_language_id_2: null,
                subtitle_language_name_2: "", //obj
                sales_channel: _.cloneDeep(this.aggregatorUsersList),
                dist_share_threshold: null,
                dcp_available: "N",
                tms_id: "",
                macs_status: "Y",
                is_foreign_movie: "N",
                uuid: "",
                kdm: null,
                kdm_id: null,
                selected_kdm: "",
                key_valid_from: "",
                key_valid_to: "",
                movie_tms_length:
                  this.MovieContainer.movieRatings &&
                  this.MovieContainer.movieRatings.length > 0 &&
                  this.MovieContainer.movieRatings[0].runTime
                    ? this.getTimeString(
                        this.MovieContainer.movieRatings[0].runTime
                      )
                    : "",
                movie_tms_intermission_time: "",
                movie_tms_credits_time: "",
                movie_fps: 24,
                movie_length_in_frames: null,
                movie_intermission_time_in_frames: null,
                movie_credits_time_in_frames: null,
                sound_format_id: soundFormat.sound_format_id,
                movie_aspect_ratio_id: null,
                movie_aspect_ratio_name: "",
                movie_experience_format_id: null,
                movie_experience_format_name: "",
                selected_experience: "",
                movie_resolution_id: null,
                movie_resolution_name: "",
                is_classic_show: this.MovieContainer.is_classic_show,
                is_confirmed_show: this.MovieContainer.is_confirmed_show,
                is_private_show: this.MovieContainer.is_private_show,
                is_crowd_show: this.MovieContainer.is_crowd_show,
                is_movie_club: this.MovieContainer.is_movie_club,
                movieDistributors: [
                  {
                    id: "",
                    distributor_name: this.MovieContainer
                      .original_distributor_name
                      ? this.MovieContainer.original_distributor_name
                      : "",
                    distributor_id: this.MovieContainer.original_distributor_id
                      ? this.MovieContainer.original_distributor_id
                      : null,
                    d_company_name: this.MovieContainer
                      .original_distributor_name
                      ? _.cloneDeep(
                          this.MovieContainer.original_distributor_name
                        )
                      : "", //obj
                    city_name: "",
                    city_id: null,
                    state_name: "",
                    state_id: null,
                    country_name: "",
                    country_id: null,
                    fromdate: new Date(),
                    todate: new Date(),
                    selected_cinema: [],
                    sub_distributor_name: "",
                    sub_distributor_id: null,
                  },
                ],
                selected_cinema: this.Cinemas || [],
                licence_start_date: this.originalReleaseDate
                  ? moment(this.originalReleaseDate).format("YYYY-MM-DD")
                  : "",
                licence_end_date: this.originalReleaseDate
                  ? moment(this.originalReleaseDate)
                      .add(365, "days")
                      .format("YYYY-MM-DD")
                  : "",
                selectShowType: [],
                interval_time: "",
                mf_name: format,
                sound_format_name: soundFormat.sound_format_name,
                sound_format: soundFormat,
              };

              let leadtime = {
                leadTimeHH: "00",
                leadTimeMM: "00",
              };
              leadTimeArray.push(leadtime);
              finalArray.push(obj);
            });
          });

          this.leadTimes = _.cloneDeep(leadTimeArray);
          this.MovieContainer.movieLangaugeFormatDistributor = _.cloneDeep(
            finalArray
          );

          console.log("finalArray", finalArray);
        }
      },
      getPosAggregatorUsers: function() {
        MasterService.GetPosAggregatorUsers()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.aggregatorUsersList = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show(err);
          });
      },
      uploadXmlfile(event, fvIndex, LangaugeFormatDistributor) {
        let file = event.target.files[0];
        let ContentKeysNotValidAfter = "";
        let ContentKeysNotValidBefore = "";
        if (file.type.indexOf("text/xml") === -1) {
          this.$toasted.show("Please select an XML file");
          return;
        } else {
          let self = this;
          const reader = new FileReader();
          reader.onload = (event) => {
            let parser = new xml2js.Parser({
              trim: true,
              explicitArray: true,
            });

            parser.parseString(event.target.result, function(err, result) {
              if (result && result.hasOwnProperty("DCinemaSecurityMessage")) {
                if (
                  result.DCinemaSecurityMessage &&
                  result.DCinemaSecurityMessage.hasOwnProperty(
                    "AuthenticatedPublic"
                  ) &&
                  result.DCinemaSecurityMessage.AuthenticatedPublic.length > 0
                ) {
                  let AuthenticatedPublic =
                    result.DCinemaSecurityMessage.AuthenticatedPublic[0];
                  if (
                    AuthenticatedPublic.hasOwnProperty("RequiredExtensions") &&
                    AuthenticatedPublic.RequiredExtensions.length > 0
                  ) {
                    let RequiredExtensions =
                      AuthenticatedPublic.RequiredExtensions[0];
                    if (
                      RequiredExtensions.hasOwnProperty(
                        "KDMRequiredExtensions"
                      ) &&
                      RequiredExtensions.KDMRequiredExtensions.length > 0
                    ) {
                      let KDMRequiredExtensions =
                        RequiredExtensions.KDMRequiredExtensions[0];
                      if (
                        KDMRequiredExtensions &&
                        KDMRequiredExtensions.hasOwnProperty(
                          "ContentKeysNotValidAfter"
                        ) &&
                        KDMRequiredExtensions.ContentKeysNotValidAfter.length >
                          0
                      ) {
                        ContentKeysNotValidAfter =
                          KDMRequiredExtensions.ContentKeysNotValidAfter[0];
                      }

                      if (
                        KDMRequiredExtensions &&
                        KDMRequiredExtensions.hasOwnProperty(
                          "ContentKeysNotValidBefore"
                        ) &&
                        KDMRequiredExtensions.ContentKeysNotValidBefore.length >
                          0
                      ) {
                        ContentKeysNotValidBefore =
                          KDMRequiredExtensions.ContentKeysNotValidBefore[0];
                      }
                    } else {
                      self.$toasted.show("KDM keys info not available!");
                    }
                  } else {
                    self.$toasted.show("KDM keys info not available!");
                  }
                } else {
                  self.$toasted.show("KDM keys info not available!");
                }
              } else {
                self.$toasted.show("KDM keys info not available!");
              }

              if (!ContentKeysNotValidAfter && !ContentKeysNotValidBefore) {
                self.$toasted.show("KDM keys info not available!");
              }
              console.log("ContentKeysNotValidAfter", ContentKeysNotValidAfter);
              console.log(
                "ContentKeysNotValidBefore",
                ContentKeysNotValidBefore
              );

              self.MovieContainer.movieLangaugeFormatDistributor[
                fvIndex
              ].key_valid_from = ContentKeysNotValidAfter;
              self.MovieContainer.movieLangaugeFormatDistributor[
                fvIndex
              ].key_valid_to = ContentKeysNotValidBefore;

              // self.MovieContainer.movieLangaugeFormatDistributor[LangaugeFormatDistributorIndex].key_valid_from = ContentKeysNotValidAfter;
              // self.MovieContainer.movieLangaugeFormatDistributor[LangaugeFormatDistributorIndex].key_valid_to = ContentKeysNotValidBefore;
              // LangaugeFormatDistributor.key_valid_from = ContentKeysNotValidAfter;
              // LangaugeFormatDistributor.key_valid_to = ContentKeysNotValidBefore;
            });
          };
          reader.readAsText(file);
        }
      },

      getuniqueSuissaid() {
        let uniqueNumber = generateRandomCode(7);
        let suissaId = parseFloat(uniqueNumber / 1000);
        return suissaId;
      },
      getUniqueSpecialEventIdentifier(Identifier) {
        return Identifier + "." + generateRandomCode(3);
      },
      onAsyncSearchParentMovie: _.debounce(function(query) {
        if (query) {
          this.searchValue = query;
          this.getAllActiveMovies();
        } else {
          this.Movies = [];
        }
      }, 1 * 1000),
      onSelectKDM(kdm, fvIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[fvIndex].kdm =
          kdm.kdm_title;
        this.MovieContainer.movieLangaugeFormatDistributor[fvIndex].kdm_id =
          kdm.kdm_id;
      },
      checkDisable() {
        if (this.MovieContainer.is_event) {
          this.$toasted.show("Edit not Allowed for Event Movies!");
          return false;
        } else {
          return true;
        }
      },
      onClickEvent(event) {
        console.log("event", event);
        this.MovieContainer.is_classic_show = true;
        this.MovieContainer.is_confirmed_show = false;
        this.MovieContainer.is_private_show = false;
        this.MovieContainer.is_crowd_show = false;
        this.MovieContainer.is_movie_club = false;
        if (!this.MovieContainer.is_event) {
          this.resetHandler();
        }
        console.log("is Event", this.MovieContainer.is_event);
      },
      onRemoveParentVersion(parentVersion) {
        this.MovieContainer.movieLangaugeFormatDistributor = this.featureVersionsArray.filter(
          (el) => {
            return this.MovieContainer.selected_version.some((v) => {
              return v.md_id == el.parent_version_id;
            });
          }
        );
        console.log(
          "onRemoveParentVersion this.MovieContainer.movieLangaugeFormatDistributor",
          this.MovieContainer.movieLangaugeFormatDistributor
        );
      },
      onSelectParentVersion(parentVersion) {
        console.log(
          "onSelectParentVersion",
          this.MovieContainer.selected_version
        );
        this.MovieContainer.movieLangaugeFormatDistributor = this.featureVersionsArray.filter(
          (el) => {
            return this.MovieContainer.selected_version.some((v) => {
              return v.md_id == el.parent_version_id;
            });
          }
        );
        console.log(
          "onSelectParentVersion this.MovieContainer.movieLangaugeFormatDistributor",
          this.MovieContainer.movieLangaugeFormatDistributor
        );
      },
      onSelectParentMovie(parentMovie) {
        console.log("onSelectParentMovie", parentMovie);
        this.versionArray = [];
        this.MovieContainer.selected_version = [];
        this.MovieContainer.movieLangaugeFormatDistributor = [];
        this.MovieContainer.selected_parent_movie = parentMovie;
        this.MovieContainer.parent_movie_id = parentMovie.movie_id;
        console.log(
          "this.MovieContainer.parent_movie_id",
          this.MovieContainer.parent_movie_id
        );
        this.getMoviesDetails(parentMovie.movie_id);
      },
      getMovieVersionText(movie) {
        let temp_arr = [];
        if (movie.mf_name) temp_arr.push(movie.mf_name.mf_name);
        if (movie.iso_2) temp_arr.push(movie.iso_2);
        if (movie.sound_format_name) temp_arr.push(movie.sound_format_name);
        if (movie.resolution_short_code)
          temp_arr.push(movie.resolution_short_code);
        if (movie.aspect_ratio_name) temp_arr.push(movie.aspect_ratio_name);
        if (movie.movie_experience) temp_arr.push(movie.movie_experience);
        if (movie.sub_lang_1_iso_2) temp_arr.push(movie.sub_lang_1_iso_2);
        if (movie.sub_lang_2_iso_2) temp_arr.push(movie.sub_lang_2_iso_2);

        if (temp_arr.length > 0) {
          return temp_arr.join("-").toUpperCase();
        } else {
          return "";
        }
      },
      getMoviesDetails(movie_id) {
        let loader = this.$loading.show();
        let payload = {
          movie_id,
        };
        MovieService.GetEditMoviesDetails(payload)
          .then((response) => {
            const { data } = response;
            console.log("data :", data);
            if (data && data.status) {
              this.movieEventData = data;
              this.MovieDetailsCityAndStatesHandler = [];
              this.movie_trailers = data.movieTrailers;
              this.MovieContentContainer = data.MovieContentContainer;
              if (data.movieScenes && data.movieScenes.length > 0) {
                this.movieScenes = data.movieScenes;
              }

              let TempArray = [];

              this.MovieContentContainer.map((x, i) => {
                if (x.langauge.toLowerCase() == "english") {
                  let obj = {
                    language_id: x.langaugeId,
                    langauge: x.langauge,
                    selectedLanguage: {
                      lang_id: x.langaugeId,
                      lang_name: x.langauge,
                    },
                    movieCastAndCrewList: [
                      {
                        id: "",
                        crew_title: "select crew",
                        selectedCastAndCrew: {
                          crew_id: null,
                          crew_title: "select crew",
                        },
                        crew_id: null,
                        selectedCastMembers: [],
                        members: [],
                      },
                    ],
                  };
                  TempArray.push(obj);
                } else {
                  let obj = {
                    language_id: x.langaugeId,
                    langauge: x.langauge,
                    selectedLanguage: {
                      lang_id: x.langaugeId,
                      lang_name: x.langauge,
                    },
                    movieCastAndCrewList: [
                      {
                        id: "",
                        crew_title: "select crew",
                        selectedCastAndCrew: {
                          crew_id: null,
                          crew_title: "select crew",
                        },
                        crew_id: null,
                        selectedCastMembers: [],
                        members: [],
                      },
                    ],
                  };
                  TempArray.push(obj);
                }
              });

              if (data.CastAndCrew && data.CastAndCrew.length > 0) {
                console.log(" data.CastAndCrew", data.CastAndCrew);
                this.cast_and_crew = TempArray.filter(
                  (aitem) =>
                    !data.CastAndCrew.find(
                      (bitem) => aitem["language_id"] === bitem["language_id"]
                    )
                ).concat(data.CastAndCrew);
              } else {
                this.cast_and_crew = TempArray;
              }
              if (this.cast_and_crew.length > 0) {
                this.cast_and_crew.forEach((x) => {
                  if (x.movieCastAndCrewList.length > 0) {
                    x.movieCastAndCrewList.forEach((y) => {
                      y["selectedCastAndCrew"] = {
                        crew_id: y.crew_id,
                        crew_title: y.crew_title,
                      };
                    });
                  }
                });
              }

              this.MovieContentContainer.map((x, i) => {
                if (x.movieCastAndCrewList.length === 0) {
                  x.movieCastAndCrewList.push({
                    id: "",
                    crew_title: "Select Crew",
                    crew_id: null,
                    selectedCastMembers: [],
                    members: [],
                  });
                }
                if (x.movieScenes.length == 0) {
                  x.movieScenes.push({
                    image_path: "",
                  });
                }
                if (
                  x.langauge.toLowerCase() !== "english" &&
                  x.movieContentTitle
                ) {
                  this.translated[i] = true;
                }

                if (x.moviePosters && x.moviePosters.length > 0) {
                  let imageSettings = _.cloneDeep(x.moviePosters);
                  let artworkSettings = imageSettings.filter(
                    (x) =>
                      x.image_setting_name.toLowerCase().trim() ==
                      "movie artwork"
                  );
                  if (artworkSettings && artworkSettings.length > 0) {
                    this.artwork_image_height =
                      artworkSettings[0].image_setting_height || 3050;
                    this.artwork_image_width =
                      artworkSettings[0].image_setting_width || 2160;
                  }
                  x.moviePosters = x.moviePosters.filter((x) => {
                    if (
                      (x.image_setting_name &&
                        x.image_setting_name.toLowerCase().trim() ===
                          "web banner") ||
                      (x.image_setting_desciption &&
                        x.image_setting_desciption.toLowerCase().trim() ===
                          "web banner") ||
                      (x.image_setting_desciption &&
                        x.image_setting_desciption.toLowerCase().trim() ==
                          "movie artwork") ||
                      (x.image_setting_name &&
                        x.image_setting_name.toLowerCase().trim() ==
                          "movie artwork")
                    ) {
                      return false;
                    }
                    return true;
                  });
                }
              });
            } else {
              // Show Message Here
              console.log("data.message :", data.message);
            }
            return data;
          })
          .then((data) => {
            if (data && data.status) {
              this.selected_country = data.MovieContainer.country_name
                ? {
                    country_name: data.MovieContainer.country_name,
                  }
                : null;
              if (data.MovieContainer.movieRatings[0]) {
                this.selected_country_rating = {
                  country_name: data.MovieContainer.movieRatings[0]
                    ? data.MovieContainer.movieRatings[0].country_name
                    : "",
                };
              }
              if (
                data.MovieContainer.original_distributor_id &&
                data.MovieContainer.original_distributor_name
              ) {
                this.original_distributor = {
                  d_id: data.MovieContainer.original_distributor_id,
                  d_company_name: data.MovieContainer.original_distributor_name,
                };
              }
              if (
                data.MovieContainer.original_lang_id &&
                data.MovieContainer.original_language_name
              ) {
                this.MovieContainer.original_lang_name = {
                  lang_id: data.MovieContainer.original_lang_id,
                  lang_name: data.MovieContainer.original_language_name,
                };
              }
              this.MovieContainer.original_release_date = data.MovieContainer
                .original_release_date
                ? data.MovieContainer.original_release_date
                : "";
              this.originalReleaseDate = data.MovieContainer
                .original_release_date
                ? data.MovieContainer.original_release_date
                : "";
              if (
                data.MovieContainer &&
                data.MovieContainer.movieRatings.length == 0
              ) {
                data.MovieContainer.movieRatings = this.MovieContainer.movieRatings;
              } else {
                data.MovieContainer.movieRatings.map((x, i) => {
                  x.country_name = {
                    country_id: x.country_id,
                    country_name: x.country_name,
                  };
                  x.rating =
                    x.rating && x.rating_id
                      ? {
                          rating: x.rating,
                          rating_id: x.rating_id,
                        }
                      : "";

                  if (x.region_id && x.region_name) {
                    x.region_obj = {
                      region_id: x.region_id,
                      region_name: x.region_name,
                    };
                  }
                });
              }
              if (
                data.MovieContainer &&
                data.MovieContainer.movieLangaugeFormatDistributor.length == 0
              ) {
                data.MovieContainer.movieLangaugeFormatDistributor = this.MovieContainer.movieLangaugeFormatDistributor;
              }
              if (data.MovieContainer.movieLangaugeFormatDistributor) {
                console.log(
                  "🚀 ~ file: editMovies.vue ~ line 6380 ~ getMoviesDetails ~ data.MovieContainer.movieLangaugeFormatDistributor",
                  data.MovieContainer.movieLangaugeFormatDistributor
                );

                this.leadTimes = [];
                data.MovieContainer.movieLangaugeFormatDistributor.map(
                  (x, i) => {
                    if (x.lead_time_in_hours) {
                      let split = x.lead_time_in_hours.split(":");
                      console.log({ i, split, x });
                      this.leadTimes[i] = {};
                      if (split.length) {
                        this.leadTimes[i].leadTimeHH = split[0];
                        this.leadTimes[i].leadTimeMM = split[1];
                      }
                    } else {
                      this.leadTimes[i].leadTimeHH = "";
                      this.leadTimes[i].leadTimeMM = "";
                    }

                    if (x.sound_format_id && x.sound_format_name) {
                      x["sound_format"] = {
                        sound_format_id: x.sound_format_id,
                        sound_format_name: x.sound_format_name,
                      };
                    } else {
                      x["sound_format"] = {};
                    }

                    if (!x.subtitle_language_id_1) {
                      x.subtitle_language_name_1 = "";
                    }
                    if (!x.subtitle_language_id_2) {
                      x.subtitle_language_name_2 = "";
                    }
                    if (x.movieDistributors.length == 0) {
                      x.movieDistributors = _.cloneDeep(this.movieDistributors);
                    } else {
                      x.movieDistributors.map((y) => {
                        console.log("Y", y);
                        y.d_company_name = {
                          d_id: y.distributor_id,
                          d_company_name: y.distributor_name,
                        };
                      });
                    }
                  }
                );

                // }
              }

              if (
                data.MovieContainer &&
                data.MovieContainer.movieLangaugeFormatDistributor
              ) {
                data.MovieContainer.movieLangaugeFormatDistributor = data.MovieContainer.movieLangaugeFormatDistributor.map(
                  (lfd) => {
                    const {
                      is_classic_show,
                      is_confirmed_show,
                      is_private_show,
                      is_crowd_show,
                      is_movie_club,
                    } = lfd;

                    if (this.MovieContainer.is_event) {
                      return {
                        ...lfd,
                        is_classic_show: true,
                        is_confirmed_show: false,
                        is_private_show: false,
                        is_crowd_show: false,
                        is_movie_club: false,
                      };
                    } else {
                      return {
                        ...lfd,
                        is_classic_show: is_classic_show === "Y" ? true : false,
                        is_confirmed_show:
                          is_confirmed_show === "Y" ? true : false,
                        is_private_show: is_private_show === "Y" ? true : false,
                        is_crowd_show: is_crowd_show === "Y" ? true : false,
                        is_movie_club: is_movie_club === "Y" ? true : false,
                      };
                    }
                  }
                );
              }

              data.MovieContainer = {
                ...data.MovieContainer,
                is_classic_show:
                  data.MovieContainer.is_classic_show === "Y" ? true : false,
                is_confirmed_show:
                  data.MovieContainer.is_confirmed_show === "Y" ? true : false,
                is_private_show:
                  data.MovieContainer.is_private_show === "Y" ? true : false,
                is_crowd_show:
                  data.MovieContainer.is_crowd_show === "Y" ? true : false,
                is_movie_club:
                  data.MovieContainer.is_movie_club === "Y" ? true : false,
              };

              this.MovieContainer = {
                ...this.MovieContainer,
                ...data.MovieContainer,
              };

              if (
                data.MovieContainer.movieLangaugeFormatDistributor[0] &&
                data.MovieContainer.movieLangaugeFormatDistributor[0]
                  .original_lang_name
              ) {
                this.MovieContainer.original_lang[0].lang_name =
                  data.MovieContainer.movieLangaugeFormatDistributor[0].original_lang_name;
              }

              if (
                data.MovieContainer.movieLangaugeFormatDistributor[0] &&
                data.MovieContainer.movieLangaugeFormatDistributor[0]
                  .original_lang_id
              ) {
                this.MovieContainer.original_lang[0].lang_id =
                  data.MovieContainer.movieLangaugeFormatDistributor[0].original_lang_id;
              }

              if (
                data.MovieContainer.movieLangaugeFormatDistributor[0] &&
                data.MovieContainer.movieLangaugeFormatDistributor[0]
                  .original_distributor_name
              ) {
                this.MovieContainer.original_lang[0].d_company_name =
                  data.MovieContainer.movieLangaugeFormatDistributor[0].original_distributor_name;
              }

              if (
                data.MovieContainer.movieLangaugeFormatDistributor[0] &&
                data.MovieContainer.movieLangaugeFormatDistributor[0]
                  .original_distributor_id
              ) {
                this.MovieContainer.original_lang[0].d_id =
                  data.MovieContainer.movieLangaugeFormatDistributor[0].original_distributor_id;
              }

              console.log(" this.MovieContainer :", this.MovieContainer);
              this.movie_id = this.MovieContainer.movie_id;
              console.log("this.movie_id :>> ", this.movie_id);
              console.log(
                "this.MovieContentContainer :>> ",
                this.MovieContentContainer
              );
            }

            this.MovieContainer.movieLangaugeFormatDistributor.map((x) => {
              x["selectShowType"] = [];
              x["mf_name"] = x.searchable_format;
              x["parent_movie_id"] = this.MovieContainer.movie_id;
              x["parent_version_id"] = x.md_id;
              x["md_id"] = null;
              let obj = {
                md_id: x.parent_version_id,
                version_id: x.parent_version_id,
                version_name: this.getMovieVersionText(x),
              };
              this.versionArray.push(obj);
              this.MovieContainer.selected_version.push(obj);

              let findIndex = -1;

              if (x.is_classic_show) {
                findIndex = x["selectShowType"].findIndex((y) => {
                  return y.column_name == "is_classic_show";
                });

                if (findIndex < 0) {
                  x["selectShowType"].push(this.ShowTypeArray[0]);
                }
              }
              if (x.is_confirmed_show) {
                findIndex = x["selectShowType"].findIndex((y) => {
                  return y.column_name == "is_confirmed_show";
                });

                if (findIndex < 0) {
                  x["selectShowType"].push(this.ShowTypeArray[2]);
                }
              }
              if (x.is_private_show) {
                findIndex = x["selectShowType"].findIndex((y) => {
                  return y.column_name == "is_private_show";
                });

                if (findIndex < 0) {
                  x["selectShowType"].push(this.ShowTypeArray[1]);
                }
              }
              if (x.is_crowd_show) {
                findIndex = x["selectShowType"].findIndex((y) => {
                  return y.column_name == "is_crowd_show";
                });

                if (findIndex < 0) {
                  x["selectShowType"].push(this.ShowTypeArray[3]);
                }
              }
              if (x.is_movie_club) {
                findIndex = x["selectShowType"].findIndex((y) => {
                  return y.column_name == "is_movie_club";
                });

                if (findIndex < 0) {
                  x["selectShowType"].push(this.ShowTypeArray[4]);
                }
              }
            });

            // movie_unique_identifier

            if (this.MovieContainer.is_event) {
              this.MovieContainer.is_classic_show = true;
              this.MovieContainer.is_confirmed_show = false;
              this.MovieContainer.is_private_show = false;
              this.MovieContainer.is_crowd_show = false;
              this.MovieContainer.is_movie_club = false;
            }

            if (this.MovieContainer.movieLangaugeFormatDistributor.length > 0) {
              this.featureVersionsArray = this.MovieContainer.movieLangaugeFormatDistributor;
            }
            this.MovieContainer.parent_movie_id = movie_id;
            console.log("this.MovieContainer", this.MovieContainer);
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      getAllActiveMovies: function() {
        this.Movies = [];
        this.isSearchLoading = true;
        MovieService.GetMovies2({
          limit: 500,
          currentPage: 1,
          searchValue: this.searchValue,
          searchKey: this.movieSearchKeys,
          columnName: "created_at",
          orderBy: "desc",
          status: "active",
          region_id: null,
        })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.Movies = data.Records.filter((x) => x.is_event == "N");
            } else {
              this.Movies = [];
              console.log("data Error:", data.message);
            }
          })
          .catch((error) => {
            console.log("data Error:", error);
          })
          .finally(() => {
            this.isSearchLoading = false;
          });
      },
      getDefaultScreeningType() {
        MovieService.GetDefaultScreeingTypes().then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.MovieContainer
            let screeningTypes = data.Records[0];
            Object.keys(screeningTypes).map((x) => {
              if (this.getMyCinemaStatusNew() == "Y") {
                this.MovieContainer[x] =
                  screeningTypes[x] == "Y" ? true : false;
              } else {
                if (x == "is_classic_show") {
                  this.MovieContainer[x] =
                    screeningTypes[x] == "Y" ? true : false;
                } else {
                  this.MovieContainer[x] = false;
                }
              }
            });
          } else {
            console.log("No Default Screening types", data);
          }
        });
      },
      copyPreviousFeatureData(obj) {
        if (this.MovieContainer.movieLangaugeFormatDistributor.length > 0) {
          let LastIndex =
            this.MovieContainer.movieLangaugeFormatDistributor.length - 1;
          // obj = Object.assign(
          //   {},
          //   this.MovieContainer.movieLangaugeFormatDistributor[LastIndex]
          // );
          obj = _.cloneDeep(
            this.MovieContainer.movieLangaugeFormatDistributor[LastIndex]
          );
          obj.tms_id = "";
          obj.uuid = "";
          obj["showMore"] = false;
        } else {
          if (this.MovieContainer["original_lang_id"]) {
            let selectedOgLang = this.Languages.filter(
              (x) => x.lang_id == this.MovieContainer["original_lang_id"]
            );
            obj["searchable_language"] =
              selectedOgLang && selectedOgLang.length
                ? selectedOgLang[0]
                : null;
            obj["lang_id"] = this.MovieContainer["original_lang_id"]
              ? this.MovieContainer["original_lang_id"]
              : null;
            obj["lang_name"] =
              selectedOgLang && selectedOgLang.length
                ? selectedOgLang[0].lang_name
                : null;
          }
        }
        return obj;
      },
      onChangeEvent(index) {
        if (index == this.fv_errorMessage_index) {
          this.fv_errorMessage = "";
          this.fv_errorMessage_index = null;
        }
      },
      checkFeatureVersionValidation() {
        this.fv_errorMessage = "";
        this.fv_errorMessage_index = null;
        let count = 0;
        if (
          this.MovieContainer.movieLangaugeFormatDistributor &&
          this.MovieContainer.movieLangaugeFormatDistributor.length > 0
        ) {
          this.MovieContainer.movieLangaugeFormatDistributor.forEach(
            (x, index) => {
              if (x.selected_cinema && x.selected_cinema.length == 0) {
                this.fv_errorMessage = "Please Select Atleast One Cinema";
                this.fv_errorMessage_index = index;
                count++;
                return false;
              } else if (x.licence_start_date && !x.licence_end_date) {
                this.fv_errorMessage = "Please Select End Date";
                this.fv_errorMessage_index = index;
                count++;
              } else if (!x.licence_start_date && x.licence_end_date) {
                this.fv_errorMessage = "Please Select Start Date";
                this.fv_errorMessage_index = index;
                count++;
              } else if (
                !x.is_classic_show &&
                !x.is_confirmed_show &&
                !x.is_private_show &&
                !x.is_crowd_show &&
                !x.is_movie_club
              ) {
                this.fv_errorMessage =
                  "Please Select Atleast One Screening Type";
                this.fv_errorMessage_index = index;
                count++;
              }
            }
          );

          if (count > 0) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      removeCastLanguage(event, index) {
        this.cast_and_crew.splice(index, 1);
      },
      addCastLang() {
        this.cast_and_crew.push({
          language_id: null,
          langauge: "",
          selectedLanguage: {
            lang_id: null,
            lang_name: "",
          },
          movieCastAndCrewList: [
            {
              id: "",
              crew_title: "",
              crew_id: null,
              selectedCastMembers: [],
              members: [],
            },
          ],
        });
      },
      saveShowType(item, movieItem, index) {
        let findIndeNew = movieItem["selectShowType"].findIndex((x) => {
          return x.booking_type_id == item.booking_type_id;
        });
        if (findIndeNew >= 0) {
          movieItem["selectShowType"].splice(findIndeNew, 1);
        } else {
          movieItem["selectShowType"].push(item);
        }
        this.onChangeEvent(index);
        console.log(movieItem["selectShowType"], "fdfsdfsd");
      },
      getImageUploadProgressEventHandler: function(obj, key) {
        return (event) => {
          console.log("event fired...", event);
          const { loaded, total } = event;
          const percent = Math.floor((loaded / total) * 100);
          obj[key] = percent;
          console.log("tracker", obj[key]);
          console.log(this.upload_percentage_tracker[key]);
        };
      },
      onSearchLanguage: function(query, id) {
        if (!query) {
          this.LanguagesCopy = [...this.Languages];
        } else {
          this.LanguagesCopy = this.Languages.filter((lang) => {
            if (
              (lang.lang_name &&
                lang.lang_name.toLowerCase().includes(query)) ||
              (lang.iso_3 && lang.iso_3.toLowerCase().includes(query)) ||
              (lang.iso_2 && lang.iso_2.toLowerCase().includes(query))
            ) {
              return true;
            } else {
              return false;
            }
          });
        }
      },
      setModalData(
        index,
        height,
        width,
        calledby,
        index2,
        category = "",
        langauge = {}
      ) {
        this.finalIndex = index;
        this.set_height = height;
        this.set_width = width;
        this.showModal = !this.showModal;
        this.calledby = calledby;
        this.movieContentIndex = index2;
        this.image_category = category;
        this.image_language = langauge;
        console.log("this.finalIndex :>> ", this.finalIndex);
        console.log("this.movieContentIndex :>> ", this.movieContentIndex);
      },

      callFetchExternalMovies(suisa_id) {
        let loader = this.$loading.show();
        setTimeout(() => {
          this.fetchCinePoolMovie(suisa_id);
          loader.hide();
        }, 5000);
      },

      fetchCinePoolMovie(suisa_id) {
        let loader = this.$loading.show();
        MovieService.FetchCinePoolMovie({ suisa_id: suisa_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.responseStatus) {
                this.onHandleMapExternalMovie(data.Results);
              } else {
                this.callFetchExternalMovies(suisa_id);
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("on Handle Select Search Movies Show Error:", err);
          })
          .finally(() => {
            loader.hide();
          });
      },
      onHandleSelectSearchMovies(movie) {
        if (movie.suisa_id) {
          let loader = this.$loading.show();
          MovieService.GetSingleExternalMovie({ suisa_id: movie.suisa_id })
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.resetHandler(true);
                this.callFetchExternalMovies(movie.suisa_id);
                // this.onHandleMapExternalMovie(data);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("on Handle Select Search Movies Show Error:", err);
            })
            .finally(() => {
              loader.hide();
            });
        } else {
          MovieService.GetsearchMovieDetails(movie)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.onHandleMapSearchMovieData(data.Records);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("on Handle Select Search Movies Show Error:", err);
            });
        }
      },
      getExternalMovies(query) {
        MovieService.GetExternalMovies({ search: query }).then((response) => {
          const { data } = response;
          if (data && data.status) {
            console.log("data GetExternalMovies", data);
            data.Records.map((x) => {
              this.searchMovies.push(x);
            });
          } else {
          }
        });
      },
      onAsyncSearchMovies: _.debounce(function(query) {
        if (query) {
          this.isSearchLoading = true;
          this.searchMovies = [];
          this.getExternalMovies(query);
          MovieService.SearchMovie({ search: query })
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                data.Records.map((x) => {
                  this.searchMovies.push(x);
                });
                // this.searchMovies = data.Records;
              } else {
                // this.$toasted.show(data.message);
              }
            })
            .catch((error) => {
              console.log("on Async Search Movies Show Error:", error);
            })
            .finally(() => {
              this.isSearchLoading = false;
            });
        }
        // clearTimeout(this.searchDebounce);
        // this.searchDebounce = setTimeout(() => {
        // }, 1000);
        //
        // debounce(() => {
        // }, 300);
      }, 1 * 1000),
      onHandleMapSearchMovieData(movieData) {
        //  : description
        // Runtime :
        //
        // Genre
        // Rated
        this.MovieContainer.movieTitle = movieData.Title;
        // Map Genres Here
        if (movieData.Genre && movieData.Genre !== "N/A") {
          this.MovieContainer.genres = [];
          let GenresArray = movieData.Genre.split(", ");
          this.Genres.map((x) => {
            if (
              GenresArray.some(
                (element) => x.g_name.toLowerCase() === element.toLowerCase()
              )
            ) {
              this.MovieContainer.genres.push(x);
            }
          });
        }
        if (movieData.Rated && movieData.Rated !== "N/A") {
          this.Ratings.map((x) => {
            if (x.rating.toLowerCase() === movieData.Rated.toLowerCase()) {
              this.MovieContainer.movieRatings[0].rating = x.rating;
              this.MovieContainer.movieRatings[0].rating_id = x.rating_id;
            }
          });
        }
        if (movieData.Runtime && movieData.Runtime !== "N/A") {
          let Onlymins = movieData.Runtime.split(" min");
          this.MovieContainer.movieRatings[0].runTime = Onlymins[0];
          let timestring = this.getTimeString(Onlymins);
          if (timestring) {
            this.setDefaultMovieLength(timestring);
          }
        }
        if (movieData.Released && movieData.Released !== "N/A") {
          let date = moment(movieData.Released, "DD MMM YYYY").isValid()
            ? moment(movieData.Released, "DD MMM YYYY").format("YYYY-MM-DD")
            : null;
          if (date) {
            this.MovieContainer.movieRatings[0].releaseDate = date;
            this.setDefaultLicenceStartDate(date);
          }
        }
        this.MovieContentContainer.map((x) => {
          // if (x.langauge === "English") {
          //   x.movieContentTitle = movieData.Title;
          //   x.movieDescription = movieData.Plot;
          //   x.movieShortDescription = movieData.Plot;
          //   if (movieData.Actors && movieData.Actors !== "N/A") {
          //     x.movieCastAndCrewList = [];
          //     let directorArray = movieData.Director.split(", ");
          //     let crewArray = movieData.Actors.split(", ");

          //     let NewArray = [];
          //     let newCastCrewObj = {};

          //     let actiorId = _.cloneDeep(
          //       this.Crews.filter(
          //         ({ crew_title }) =>
          //           crew_title.toLowerCase() === "actor" ||
          //           crew_title.toLowerCase() === "director"
          //       )
          //     );

          //     console.log('cloneDeep', actiorId);

          //     actiorId.map(x => {
          //       if (!newCastCrewObj[x.crew_id]) {
          //         newCastCrewObj[x.crew_id] = {
          //           id: "",
          //           selectedCastAndCrew: {
          //             crew_title: x.crew_title,
          //             crew_id: x.crew_id
          //           },
          //           crew_title: x.crew_title,
          //           crew_id: x.crew_id,
          //           members: []
          //         };
          //       }
          //       if (x.crew_title.toLowerCase() === "actor") {
          //         crewArray.map(y => {
          //           newCastCrewObj[x.crew_id].members.push({
          //             person_name: y || "",
          //             order_no: 1
          //           });
          //         });
          //       } else if (x.crew_title.toLowerCase() === "director") {
          //         directorArray.map(y => {
          //           newCastCrewObj[x.crew_id].members.push({
          //             person_name: y || "",
          //             order_no: 1
          //           });
          //         });
          //       }
          //       return x;
          //     });

          //     let finalCrewArray = Object.values(newCastCrewObj) || [];

          //     finalCrewArray.map(x => {
          //       this.recomputeOrder(x.members, "order_no");
          //     });

          //     x.movieCastAndCrewList = finalCrewArray;

          //     console.log(
          //       "this.moviecontentcontainer",
          //       this.MovieContentContainer
          //     );

          //     if (actiorId.length > 0) {
          //       // NewArray.map((crewData, index) => {
          //       //   // TODO: update this
          //       //   x.movieCastAndCrewList.push({
          //       //     id: "",
          //       //     selectedCastAndCrew: {
          //       //       crew_title: crewData.crew_title,
          //       //       crew_id: crewData.crew_id
          //       //     },
          //       //     crew_title: crewData.crew_title,
          //       //     crew_id: crewData.crew_id,
          //       //     person_name: crewData.person_name,
          //       //     order_no: index + 1
          //       //   });
          //       // });
          //       // actiorId.map((y, index) => {
          //       //   y.Details.map((z, zindex) => {
          //       //     x.movieCastAndCrewList.push({
          //       //       id: "",
          //       //       crew_title: y.crew_title,
          //       //       crew_id: y.crew_id,
          //       //       person_name: z,
          //       //       order_no: zindex + 1
          //       //     });
          //       //   });
          //       // });
          //       // crewArray.map((crewName, orderindex) => {
          //       //   x.movieCastAndCrewList.push({
          //       //     id: "",
          //       //     crew_title: actiorId[0].crew_title,
          //       //     crew_id: actiorId[0].crew_id,
          //       //     person_name: crewName,
          //       //     order_no: orderindex + 1
          //       //   });
          //       // });
          //     }
          //   }
          // }
          if (x.langauge.toLowerCase() == "english") {
            x.movieContentTitle = movieData.Title;
            x.movieDescription = movieData.Plot;
            x.movieShortDescription = movieData.Plot;
            if (movieData.Actors && movieData.Actors !== "N/A") {
              x.movieCastAndCrewList = [];
              let DirectorArray = movieData.Director.split(", ");
              let castArray = movieData.Actors.split(", ");
              let crewID = this.Crews.filter(
                (x) =>
                  x.crew_title.toLowerCase() == "actor" ||
                  x.crew_title.toLowerCase() == "director"
              );
              let ActorsmembersArray = [];
              let DirectormembersArray = [];
              castArray.map((z) => {
                let obj = {
                  person_name: z,
                  order_no: 1,
                };
                ActorsmembersArray.push(obj);
              });

              DirectorArray.map((z) => {
                let obj = {
                  person_name: z,
                  order_no: 1,
                };
                DirectormembersArray.push(obj);
              });

              let TempmovieCastAndCrew = [];

              crewID.map((y) => {
                let obj = {
                  id: "",
                  selectedCastAndCrew: {
                    crew_title: y.crew_title,
                    crew_id: y.crew_id,
                  },
                  crew_title: y.crew_title,
                  crew_id: y.crew_id,
                  selectedCastMembers: [],
                  members:
                    y.crew_title.toLowerCase() == "actor"
                      ? ActorsmembersArray
                      : DirectormembersArray,
                };
                TempmovieCastAndCrew.push(obj);
              });
              this.cast_and_crew.map((z) => {
                if (z.langauge.toLowerCase() == "english") {
                  z.movieCastAndCrewList = TempmovieCastAndCrew;
                }
              });
            }
          }
        });
      },
      onHandleMapExternalMovie(Data) {
        let moviesData = Data.Records.movies;
        let movieData = moviesData[Object.keys(moviesData)[0]];
        let artWork = Data.ArtWorksImages;
        let sceneImages = Data.SceneImages;
        let originalLangName = "English";
        this.MovieContainer.movieTitle = movieData.title_ov;
        if (movieData.trailers) {
          this.movie_trailers = [];
        }
        this.MovieContainer.movie_unique_identifier = movieData.suisa;
        let imdbUrl = `https://www.imdb.com/title/tt${movieData.imdb}/`;
        this.MovieContainer.imdb_link = imdbUrl;

        Object.keys(movieData.genres).map((key, value) => {
          let GenresArray = [];
          GenresArray.push(key);
          this.Genres.map((x) => {
            if (
              GenresArray.some(
                (element) => x.g_name.toLowerCase() === element.toLowerCase()
              )
            ) {
              this.MovieContainer.genres.push(x);
            }
          });
        });
        if (movieData.lang_ov) {
          this.Languages.map((x) => {
            if (
              x.iso_2 &&
              movieData.lang_ov.toLowerCase() == x.iso_2.toLowerCase()
            ) {
              this.onSelectOriginalLanguageHandler(x);
              this.MovieContainer.original_lang_name = x;
              originalLangName = x.lang_name;
            }
          });
        } else {
          movieData["lang_ov"] = "en";
        }
        if (movieData.distributor) {
          this.Distributors.map((x) => {
            if (
              movieData.distributor.toLowerCase() ==
              x.d_company_name.toLowerCase()
            ) {
              this.onSelectOriginalDistributorHandler(x);
              this.MovieContainer.original_distributor_name = x;
              this.original_distributor = x;
            }
          });
        }
        this.MovieContentContainer.map((x) => {
          Object.keys(movieData).map((key, value) => {
            if (key.includes("synopsis")) {
              let synopsis_iso2 = key.replace("synopsis_", "");
              if (synopsis_iso2.toLowerCase() == x.iso_2.toLowerCase()) {
                x.movieDescription = movieData[key];
              }
            }
          });

          Object.keys(movieData).map((key, value) => {
            if (key.includes("oneline")) {
              let oneline_iso2 = key.replace("oneline_", "");
              if (oneline_iso2.toLowerCase() == x.iso_2.toLowerCase()) {
                x.movieShortDescription = movieData[key];
              }
            }
          });

          Object.keys(movieData).map((key, value) => {
            if (key.includes("title")) {
              let title_iso2 = key.replace("title_", "");
              if (title_iso2.toLowerCase() == x.iso_2.toLowerCase()) {
                console.log("x.iso_2.toLowerCase()", x.iso_2.toLowerCase());
                console.log("movieData[key]", movieData[key]);
                x.movieContentTitle = movieData[key];
              }
              if (x.iso_2.toLowerCase() == movieData.lang_ov.toLowerCase()) {
                x.movieContentTitle = movieData.title_ov;
              }
            }
          });

          artWork.map((y) => {
            if (y.iso_2.toLowerCase() == x.iso_2.toLowerCase()) {
              x.artwork = y.path;
            } else if (
              x.iso_2.toLowerCase() == movieData.lang_ov.toLowerCase() &&
              y.iso_2.toLowerCase() == "ov"
            ) {
              x.artwork = y.path;
            } else if (y.iso_2.toLowerCase() == "ov") {
              this.MovieContainer.original_artwork = y.path;
            }
          });
          if (movieData.trailers) {
            Object.keys(movieData.trailers).map((key, value) => {
              let trailer_iso2 = key.replace("ch_", "");
              if (
                trailer_iso2.toLowerCase() == x.iso_2.toLowerCase() &&
                x.iso_2.toLowerCase() !== movieData.lang_ov.toLowerCase()
              ) {
                let subtitle_1 = null;
                let subtitle_1_id = null;
                let subtitle_2 = null;
                let subtitle_2_id = null;
                if (
                  movieData.trailers[key] &&
                  movieData.trailers[key].hasOwnProperty("subtitles") &&
                  movieData.trailers[key]["subtitles"].length > 0
                ) {
                  console.log("I am inside trailers subtitles");
                  let tempArray = [];
                  movieData.trailers[key]["subtitles"].map((s) => {
                    console.log("S subtitles", s);
                    let obj = this.Languages.find(
                      (a) => a.iso_3.toLowerCase() == s.toLowerCase()
                    );
                    if (obj) {
                      tempArray.push(obj);
                    }
                  });
                  console.log("subtitles tempArray", tempArray);
                  if (tempArray.length > 0) {
                    subtitle_1 = tempArray[0];
                    subtitle_1_id = tempArray[0].lang_id
                      ? tempArray[0].lang_id
                      : null;
                  }
                  if (tempArray.length > 1) {
                    subtitle_2 = tempArray[1];
                    subtitle_2_id = tempArray[1].lang_id
                      ? tempArray[1].lang_id
                      : null;
                  }
                }
                this.movie_trailers.push({
                  language_id: x.langaugeId,
                  language: {
                    lang_id: x.langaugeId,
                    lang_name: x.langauge,
                  },
                  trailer_link:
                    movieData.trailers[key] &&
                    movieData.trailers[key].direct &&
                    movieData.trailers[key].direct.hd
                      ? movieData.trailers[key].direct.hd
                      : movieData.trailers[key] && movieData.trailers[key].vimeo
                      ? this.createVimeoLink(movieData.trailers[key].vimeo)
                      : "",
                  subtitle_lang_id_1: subtitle_1_id,
                  subtitle_lang_1: subtitle_1,
                  subtitle_lang_id_2: subtitle_2_id,
                  subtitle_lang_2: subtitle_2,
                });
              }
            });
            if (x.iso_2.toLowerCase() == movieData.lang_ov.toLowerCase()) {
              let subtitle_1 = null;
              let subtitle_1_id = null;
              let subtitle_2 = null;
              let subtitle_2_id = null;
              if (
                movieData.trailers["ov"] &&
                movieData.trailers["ov"].hasOwnProperty("subtitles") &&
                movieData.trailers["ov"]["subtitles"].length > 0
              ) {
                console.log("I am inside trailers subtitles");
                let tempArray = [];
                movieData.trailers["ov"]["subtitles"].map((s) => {
                  console.log("S subtitles", s);
                  let obj = this.Languages.find(
                    (a) => a.iso_3.toLowerCase() == s.toLowerCase()
                  );
                  if (obj) {
                    tempArray.push(obj);
                  }
                });
                console.log("subtitles tempArray", tempArray);
                if (tempArray.length > 0) {
                  subtitle_1 = tempArray[0];
                  subtitle_1_id = tempArray[0].lang_id
                    ? tempArray[0].lang_id
                    : null;
                }
                if (tempArray.length > 1) {
                  subtitle_2 = tempArray[1];
                  subtitle_2_id = tempArray[1].lang_id
                    ? tempArray[1].lang_id
                    : null;
                }
              }
              let originalTrailer = {
                language_id: x.langaugeId,
                language: {
                  lang_id: x.langaugeId,
                  lang_name: x.langauge,
                },
                trailer_link:
                  movieData.trailers["ov"] &&
                  movieData.trailers["ov"].direct &&
                  movieData.trailers["ov"].direct.hd
                    ? movieData.trailers["ov"].direct.hd
                    : movieData.trailers["ov"] && movieData.trailers["ov"].vimeo
                    ? this.createVimeoLink(movieData.trailers["ov"].vimeo)
                    : "",
                subtitle_lang_id_1: subtitle_1_id,
                subtitle_lang_1: subtitle_1,
                subtitle_lang_id_2: subtitle_2_id,
                subtitle_lang_2: subtitle_2,
              };
              this.movie_trailers.push(originalTrailer);
              this.MovieContainer.original_trailer = originalTrailer;
            }
          }
          console.log(
            "x.langauge.toLowerCase() movieData.lang_ov",
            movieData.lang_ov
          );
          if (x.iso_2.toLowerCase() == movieData.lang_ov.toLowerCase()) {
            if (movieData.cast || movieData.director) {
              let castArray = movieData.cast ? movieData.cast : [];
              let DirectorArray = movieData.director ? movieData.director : [];
              let crewID = [];
              crewID = this.Crews.filter(
                (x) =>
                  x.crew_title.toLowerCase() == "actor" ||
                  x.crew_title.toLowerCase() == "director"
              );
              let ActorsmembersArray = [];
              let DirectormembersArray = [];
              if (castArray && castArray.length > 0) {
                castArray.map((z) => {
                  let obj = {
                    person_name: z,
                    order_no: 1,
                  };
                  ActorsmembersArray.push(obj);
                });
              }
              if (DirectorArray && DirectorArray.length > 0) {
                DirectorArray.map((z) => {
                  let obj = {
                    person_name: z,
                    order_no: 1,
                  };
                  DirectormembersArray.push(obj);
                });
              }

              let TempmovieCastAndCrew = [];
              if (crewID && crewID.length > 0) {
                crewID.map((y) => {
                  let obj = {
                    id: "",
                    selectedCastAndCrew: {
                      crew_title: y.crew_title,
                      crew_id: y.crew_id,
                    },
                    crew_title: y.crew_title,
                    crew_id: y.crew_id,
                    selectedCastMembers: [],
                    members:
                      y.crew_title.toLowerCase() == "actor"
                        ? ActorsmembersArray
                        : DirectormembersArray,
                  };
                  TempmovieCastAndCrew.push(obj);
                });
              }
              // this.cast_and_crew.map((z) => {
              //   if (z.langauge.toLowerCase() == "english") {
              //     z.movieCastAndCrewList = TempmovieCastAndCrew;
              //   }
              // });
              let castNcrew = [
                {
                  language_id: x.langaugeId,
                  langauge: x.langauge,
                  selectedLanguage: {
                    lang_id: x.langaugeId,
                    lang_name: x.langauge,
                  },
                  movieCastAndCrewList: TempmovieCastAndCrew,
                },
              ];
              this.cast_and_crew = castNcrew;
            }
          }

          if (movieData.voices) {
            Object.keys(movieData.voices).map((key, value) => {
              let voices_iso2 = key.replace("ch_", "");
              if (
                voices_iso2.toLowerCase() == x.iso_2.toLowerCase() &&
                voices_iso2.toLowerCase() !== movieData.lang_ov.toLowerCase()
              ) {
                let VoiceActors = movieData.voices[key]
                  ? movieData.voices[key]
                  : [];
                let crewID = [];
                crewID = this.Crews.filter(
                  (x) => x.crew_title.toLowerCase() == "voice actor"
                );
                let membersArray = [];
                VoiceActors.map((z) => {
                  let obj = {
                    person_name: z,
                    order_no: 1,
                  };
                  membersArray.push(obj);
                });

                let obj = {
                  language_id: x.langaugeId,
                  langauge: x.langauge,
                  selectedLanguage: {
                    lang_id: x.langaugeId,
                    lang_name: x.langauge,
                  },
                  movieCastAndCrewList: [
                    {
                      id: "",
                      selectedCastAndCrew: {
                        crew_title: crewID[0].crew_title,
                        crew_id: crewID[0].crew_id,
                      },
                      crew_title: crewID[0].crew_title,
                      crew_id: crewID[0].crew_id,
                      selectedCastMembers: [],
                      members: membersArray,
                    },
                  ],
                };
                this.cast_and_crew.push(obj);
              } else if (
                voices_iso2.toLowerCase() == movieData.lang_ov.toLowerCase()
              ) {
                let VoiceActors = movieData.voices[key]
                  ? movieData.voices[key]
                  : [];
                let crewID = [];
                crewID = this.Crews.filter(
                  (x) => x.crew_title.toLowerCase() == "voice actor"
                );
                let membersArray = [];
                VoiceActors.map((z) => {
                  let obj = {
                    person_name: z,
                    order_no: 1,
                  };
                  membersArray.push(obj);
                });

                crewID.map((y) => {
                  let obj = {
                    id: "",
                    selectedCastAndCrew: {
                      crew_title: y.crew_title,
                      crew_id: y.crew_id,
                    },
                    crew_title: y.crew_title,
                    crew_id: y.crew_id,
                    selectedCastMembers: [],
                    members: membersArray,
                  };
                  let voiceCast = [];
                  this.cast_and_crew.map((z) => {
                    if (
                      z.langauge.toLowerCase() == originalLangName.toLowerCase()
                    ) {
                      z.movieCastAndCrewList.push(obj);
                    } else {
                      voiceCast.push({
                        language_id: x.langaugeId,
                        langauge: x.langauge,
                        selectedLanguage: {
                          lang_id: x.langaugeId,
                          lang_name: x.langauge,
                        },
                        movieCastAndCrewList: TempmovieCastAndCrew,
                      });
                    }
                  });
                  if (voiceCast.length > 0) {
                    this.cast_and_crew = voiceCast;
                  }
                });
              }
            });
          }
        });
        if (sceneImages && sceneImages.length > 0) {
          this.movieScenes = [];
          sceneImages.map((y) => {
            this.movieScenes.push({ image_path: y.path });
          });
        }
        if (movieData.releases || movieData.ratings) {
          let runtime = movieData.duration;
          let TempArray = [];
          let MovieObjrating = "";
          this.MovieContainer.movieRatings = [];
          if (movieData.ratings) {
            MovieObjrating =
              movieData.ratings[Object.keys(movieData.ratings)[0]];
          }
          let selectedrating = [];
          let _rating_id = null;
          let _rating = null;
          console.log(MovieObjrating);
          if (MovieObjrating) {
            selectedrating = this.Ratings.filter(
              (z) => z.rating.toLowerCase() == MovieObjrating.toLowerCase()
            );
          }
          console.log(MovieObjrating, selectedrating);
          if (selectedrating.length > 0) {
            _rating_id = selectedrating[0].rating_id || null;
            _rating = selectedrating[0].rating || null;
          }
          console.log("rating jsdks", selectedrating);
          if (movieData.releases) {
            Object.keys(movieData.releases).map((key, value) => {
              let release_iso2 = key.replace("ch_", "");
              this.Regions.map((z) => {
                if (release_iso2.toLowerCase() == z.region_name.toLowerCase()) {
                  let date = moment(
                    movieData.releases[key],
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(movieData.releases[key], "YYYY-MM-DD").format(
                        "YYYY-MM-DD"
                      )
                    : null;

                  let obj = {
                    id: "",
                    country_name: this.defaultCountry
                      ? { ...this.defaultCountry }
                      : "",
                    country_id: this.defaultCountry
                      ? this.defaultCountry.country_id
                      : null,
                    rating: _rating_id
                      ? {
                          rating: _rating,
                          rating_id: _rating_id,
                        }
                      : "",
                    rating_id: _rating_id,
                    releaseDate: date,
                    runTime: runtime,
                    region_id: z.region_id,
                    region_obj: {
                      region_id: z.region_id,
                      region_name: z.region_name,
                    },
                    region_name: z.region_name,
                    intervalTime: null,
                  };
                  // this.setInitialValuesToRating(obj);
                  this.MovieContainer.movieRatings.push(obj);
                  console.log(
                    "this.MovieContainer.movieRatings",
                    this.MovieContainer.movieRatings
                  );
                }
              });
            });
          }
          this.getReleaseDate();
        }
      },
      createVimeoLink(vimeoId) {
        let link = ``;
        if (vimeoId) {
          link = `https://player.vimeo.com/video/` + vimeoId;
        } else {
          link = ``;
        }
        return link;
      },
      setDefaultMovieLength: function(timestring) {
        this.MovieContainer.movieLangaugeFormatDistributor.forEach((mlfd) => {
          if (mlfd.movie_tms_length === "") {
            mlfd.movie_tms_length = timestring || "";
          }
        });
      },
      checkEmptyField: function() {},
      //
      getSoundFormats: function() {
        let payload = {
          tableName: "ms_sound_formats",
          sound_format_is_active: "Y",
          orderBy: "asc",
          columnName: "sf_order",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.soundFormatList = data.Records;
              console.log(" this.soundFormatList :>> ", this.soundFormatList);
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getRegions: function() {
        let payload = {
          tableName: "ms_regions",
          region_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Regions = data.Records;
              let tempobj = {
                region_name: "All",
                region_id: 0,
              };
              this.Regions.unshift(tempobj);
              console.log(" this.Regions :>> ", this.Regions);
            } else {
              // Show Errors
              // console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getCastMasters: function() {
        let payload = {
          tableName: "ms_cast_master",
          cast_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.CastMasters = data.Records;
            } else {
              this.CastMasters = []
            }
          })
          .catch((error) => {
            console.log("show error :", error);
          });
      },
      getCustomFields: function() {
        let payload = {
          table_name: "ms_movies",
        };
        MasterService.getCustomFields(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.custom_fields_list = _.sortBy(data.Records, ["order_id"]);
              this.custom_fields_list.map((field, index) => {
                if (field.custom_field_type == "checkbox") {
                  this.input_data[index] =
                    this.input_data[index] == undefined
                      ? false
                      : this.input_data[index];
                }
              });
              console.log("this.input_data :>> ", this.input_data);
            } else {
              // Show Errors
              // this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      selectCountry(Country) {
        console.log("Country :", Country);
        this.MovieContainer.country_name = Country.country_name;
        this.MovieContainer.country_id = Country.country_id;
        console.log("this.MovieContainer :", this.MovieContainer);
      },
      removeCountry() {
        this.MovieContainer.country_name = "";
        this.MovieContainer.country_id = null;
        console.log("this.MovieContainer :", this.MovieContainer);
      },
      selectCountryRating(Country) {
        this.MovieContainer.movieRatings[0].country_name = Country.country_name;
        this.MovieContainer.movieRatings[0].country_id = Country.country_id;
        console.log(
          "this.MovieContainer.movieRatings[0] :",
          this.MovieContainer.movieRatings[0]
        );
      },
      removeCountryRating() {
        this.MovieContainer.movieRatings[0].country_name = "";
        this.MovieContainer.movieRatings[0].country_id = null;
        console.log(
          "this.MovieContainer.movieRatings[0] :",
          this.MovieContainer.movieRatings[0]
        );
      },
      // hideCropperModal: function(modal) {
      //   if (modal == "imagecropperposters") {
      //     this.$bvModal.hide("imagecropperposters");
      //   } else {
      //     this.$bvModal.hide("imagecropper");
      //   }
      // },
      openImageModal: function(image_name, image_path) {
        this.tempModalImagePath = image_path;
        this.tempModalImageName = image_name;
        this.$refs["preview-modal"].show();
      },
      /**
       * Saif
       */
      resetHandler: function(callExternal = false) {
        this.submitted = false;
        (this.MovieContainer = {
          movieTitle: "",
          movieAlternateLangTitle: "",
          movie_isActive: "Y",
          ms_foreign_movie: "Y",
          movie_is_draft: "N",
          is_upcoming: "N",
          country_name: "",
          imdb_link: "",
          country_id: null,
          productionCompany: [],
          genres: [],
          labels: [],
          sound_formats: [],
          original_lang_id: null,
          original_lang_name: "",
          original_distributor_id: null,
          original_distributor_name: "",
          original_artwork: "",
          original_trailer: {
            language_id: null,
            language: null,
            trailer_link: "",
            subtitle_lang_id_1: null,
            subtitle_lang_1: null,
            subtitle_lang_id_2: null,
            subtitle_lang_2: null,
          },
          original_release_date: "",
          copyright: "",
          movie_unique_identifier: this.getuniqueSuissaid(),
          is_classic_show: true,
          is_confirmed_show: true,
          is_private_show: true,
          is_crowd_show: true,
          is_movie_club: true,
          remarks: "",
          movieLangaugeFormatDistributor: [],
          movieRatings: [
            {
              id: "",
              country_name: "",
              country_id: null,
              rating: "",
              rating_id: null,
              releaseDate: null,
              intervalTime: "0",
              // date: new Date(2016, 9, 16),
              runTime: "0",
              region_id: null,
              region_obj: null,
              region_name: "",
            },
          ],
        }),
          (this.MovieContentContainer = []);
        this.versionArray = [];
        this.movie_trailers = [];
        this.cast_and_crew = [];
        this.custom_fields_list.map((field, index) => {
          this.input_data[index] = "";
        });

        //
        this.MovieDetailsCityAndStatesHandler = [
          [
            {
              country_id: null,
              stateList: [],
              cityList: [],
            },
          ],
        ];
        if (!callExternal) {
          this.selectedSearchMovies = null;
        }
        this.getMovieContentLangauge();
        // this.movieScenes = [
        //   {
        //     image_path: "",
        //   },
        // ];
        this.movieScenes = [];
      },
      // Other Actions Handler
      getMovieContentLangauge: function() {
        this.MovieContentContainer = [];
        this.LanguagesCopy = [];
        let loader = this.$loading.show();
        MovieService.GetMovieContentLanguages()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.ActiveLanguages.length > 0) {
                this.Languages = data.ActiveLanguages;
                this.LanguagesCopy = [...data.ActiveLanguages];
              }
              if (data.ContentLanguages.length > 0) {
                this.ContentLanguages = _.sortBy(data.ContentLanguages, [
                  "langauge",
                ]);
                this.ContentLanguages = data.ContentLanguages;
              }
              if (data.MoviePosters.length > 0) {
                let imageSettings = _.cloneDeep(data.MoviePosters);
                let artworkSettings = imageSettings.filter(
                  (x) =>
                    x.image_setting_name.toLowerCase().trim() == "movie artwork"
                );
                if (artworkSettings && artworkSettings.length > 0) {
                  this.artwork_image_height =
                    artworkSettings[0].image_setting_height || 3050;
                  this.artwork_image_width =
                    artworkSettings[0].image_setting_width || 2160;
                }
                data.MoviePosters = data.MoviePosters.filter((x) => {
                  if (
                    (x.image_setting_name &&
                      x.image_setting_name.toLowerCase().trim() ===
                        "web banner") ||
                    (x.image_setting_desciption &&
                      x.image_setting_desciption.toLowerCase().trim() ===
                        "web banner") ||
                    (x.image_setting_desciption &&
                      x.image_setting_desciption.toLowerCase().trim() ==
                        "movie artwork") ||
                    (x.image_setting_name &&
                      x.image_setting_name.toLowerCase().trim() ==
                        "movie artwork")
                  ) {
                    return false;
                  }
                  return true;
                });
                this.Posters = data.MoviePosters;
              }
            } else {
              // Show Error:
              console.log("data.message :", data.message);
            }
            return;
          })
          .then(() => {
            this.makeMovieContainers();
            setTimeout(() => loader.hide(), 1000);
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error On getMovieContentLangauge :", error);
          });
      },
      onChangeTabHandler: function(event, index) {
        this.activeClass = index;
      },
      makeMovieContainers: function() {
        const array = this.Posters;
        this.ContentLanguages.map((x) => {
          // const array = this.Posters;
          // let post = new Array(...this.Posters);
          let post = _.cloneDeep(this.Posters);
          let Obj = {
            ...x,
            selectedLanguage: {
              lang_id: x.langaugeId,
              lang_name: x.langauge,
            },
            content_lang_id: null,
            movieContentId: null,
            movieContentTitle: "",
            movieDescription: "",
            movieShortDescription: "",
            artwork: "",
            trailer_url: "",
            movieCastAndCrewList: [
              {
                id: "",
                crew_title: "",
                crew_id: null,
                selectedCastMembers: [],
                members: [],
              },
            ],
            // movieCastAndCrewList: [
            //   {
            //     id: "",
            //     crew_title: "",
            //     crew_id: null,
            //     person_name: "",
            //     order_no: ""
            //   }
            // ],
            moviePosters: post, // this.Posters,
            // movieScenes: [
            //   {
            //     image_path: "",
            //   },
            // ],
            movieScenes: [],
            // [
            //   {
            //     image_setting_name: "Name 1",
            //     image_setting_path: ""
            //   }
            // ],
            isActive: true,
          };
          this.MovieContentContainer.push(Obj);

          this.movie_trailers.push({
            language_id: x.langaugeId,
            language: {
              lang_id: x.langaugeId,
              lang_name: x.langauge,
            },
            trailer_link: "",
            subtitle_lang_id_1: null,
            subtitle_lang_1: null,
            subtitle_lang_id_2: null,
            subtitle_lang_2: null,
          });
          //CHANGE FOR CONTENT LANG CAST AND CREW
          // if (x.langauge.toLowerCase() == "english") {
          //   this.cast_and_crew.push({
          //     language_id: x.langaugeId,
          //     langauge: x.langauge,
          //     selectedLanguage: {
          //       lang_id: x.langaugeId,
          //       lang_name: x.langauge,
          //     },
          //     movieCastAndCrewList: [
          //       {
          //         id: "",
          //         crew_title: "",
          //         crew_id: null,
          //         members: [],
          //       },
          //     ],
          //   });
          // }

          this.cast_and_crew.push({
            language_id: x.langaugeId,
            langauge: x.langauge,
            selectedLanguage: {
              lang_id: x.langaugeId,
              lang_name: x.langauge,
            },
            movieCastAndCrewList: [
              {
                id: "",
                crew_title: "",
                crew_id: null,
                selectedCastMembers: [],
                members: [],
              },
            ],
          });
        });
      },
      /**
       * GET REQUEST LIST START
       */
      getCinemasList: function(cine_id) {
        this.Cinemas = [];
        let body = {
          tableName: "ms_cinemas",
          cine_is_active: "Y",
        };
        // MasterService.GetActiveList(body)
        //   .then(response => {
        //     const { data } = response;
        //     if (data && data.status && data.Records.length > 0) {
        //       this.Cinemas = data.Records;
        //       this.Cinemas.map(x => {
        //         if (String(cine_id) === String(x.cine_id)) {
        //           // this.DistributorItem.cinema_name = x.cine_name;
        //           console.log("this.movieLangaugeFormatDistributor :", x.cine_id);
        //           this.MovieContainer.movieLangaugeFormatDistributor = this.MovieContainer.movieLangaugeFormatDistributor.map(
        //             singleMovieFormat => {
        //               // // console.log("singleMovieFormat :", singleMovieFormat);
        //               singleMovieFormat.movieDistributors.map(
        //                 singleMovieDistributor => {
        //                   singleMovieDistributor.cinema_name = x.cine_name;
        //                   singleMovieDistributor.cinema_id = x.cine_id;
        //                 }
        //               );
        //               return singleMovieFormat;
        //             }
        //           );
        //         }
        //       });
        //     } else {
        //       this.$toasted.show(data.message || "Opps! Something went wrong");
        //     }
        //   })
        //   .catch(this._CatchError);

        MasterService.GetCinemasMovieLicence()
          .then((resp) => {
            const { data } = resp;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // this.DistributorItem.cinema_name = x.cine_name;
                  console.log(
                    "this.movieLangaugeFormatDistributor :",
                    x.cine_id
                  );
                  this.MovieContainer.movieLangaugeFormatDistributor = this.MovieContainer.movieLangaugeFormatDistributor.map(
                    (singleMovieFormat) => {
                      // // console.log("singleMovieFormat :", singleMovieFormat);
                      singleMovieFormat.movieDistributors.map(
                        (singleMovieDistributor) => {
                          singleMovieDistributor.cinema_name = x.cine_name;
                          singleMovieDistributor.cinema_id = x.cine_id;
                        }
                      );
                      return singleMovieFormat;
                    }
                  );
                }
              });

              this.CinemasGroupedByRegion = _.toPairs(
                _.groupBy(
                  data.Records.filter((x) => x.region_id),
                  "region_id"
                )
              );

              let tempTerittoryGrp = _.toPairs(
                _.groupBy(data.Records, "territory_id")
              );

              this.newgroupRegionCinema = [];

              // this.CinemasGroupedByRegion.forEach((_group) => {
              //   this.newgroupRegionCinema.push({
              //     label: _group[1][0]["region_name"],
              //     Cinemas: _group[1],
              //   });
              // });
              tempTerittoryGrp.forEach((_group) => {
                this.newgroupRegionCinema.push({
                  label:
                    _group[1][0]["territory_name"] ||
                    _group[1][0]["region_name"] ||
                    "All",
                  Cinemas: _group[1],
                });
              });

              console.log(
                "this.CinemasGroupedByRegion",
                this.CinemasGroupedByRegion,
                this.newgroupRegionCinema
              );
            } else {
              this.$toasted.show(data.message || "Opps! Something went wrong");
            }
          })
          .catch(this._CatchError);
      },
      onClickCinemaPill: function(
        event,
        cinema,
        DistributorItem,
        DistributorIndex
      ) {
        this.onChangeEvent(DistributorIndex);
        console.log("onClickCinemaPill called");
        let selected_cinemas = DistributorItem.selected_cinema;
        let doesExist = selected_cinemas.findIndex(
          (x) => x.cine_id == cinema.cine_id
        );
        if (doesExist !== -1) {
          selected_cinemas.splice(doesExist, 1);
          this.setLeadTime(null, DistributorIndex, "reset");
        } else {
          selected_cinemas.push(cinema);
          this.setLeadTime(selected_cinemas, DistributorIndex, "set");
        }

        console.log(
          "DistributorItem.selected_cinema",
          DistributorItem.selected_cinema
        );

        if (event && event.target) {
          event.target.blur();
        }
      },
      setLeadTime(cinema, index, type) {
        if (type == "reset") {
          this.leadTimes[index].leadTimeHH = "00";
          this.leadTimes[index].leadTimeMM = "00";
        } else if (type == "set" && cinema[0]) {
          let split = cinema[0].lead_time_in_hours.split(":");
          if (split && split.length > 0) {
            this.leadTimes[index].leadTimeHH = split[0];
            this.leadTimes[index].leadTimeMM = split[1];
          }
        } else {
          console.log("Error: please provide proper data");
        }
      },
      onClickCinemaRegion: function(cinemas, DistributorItem) {
        let selected_cinemas = DistributorItem.selected_cinema;
        const doesAllExist = cinemas.every((c) => {
          if (selected_cinemas.findIndex((x) => x.cine_id == c.cine_id) > -1) {
            return true;
          }
          return false;
        });

        if (doesAllExist) {
          DistributorItem.selected_cinema = selected_cinemas.filter((x) => {
            if (cinemas.findIndex((c) => c.cine_id == x.cine_id) > -1) {
              return false;
            }
            return true;
          });
        } else {
          cinemas.forEach((c) => {
            if (
              selected_cinemas.findIndex((x) => x.cine_id == c.cine_id) === -1
            ) {
              selected_cinemas.push(c);
            }
          });
        }
      },
      getCountriesList: function() {
        this.Countries = [];
        let payload = {
          tableName: "ms_countries",
          country_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Countries = data.Records;

              let globalOptions = this.$store.getters.getGlobalOptions;
              if (this.Countries.length > 0 && globalOptions.length > 0) {
                let operationCountryId = globalOptions.find((data) => {
                  return data.go_key === "OPERATION_COUNTRY";
                });
                let countryInfo = this.Countries.find((data) => {
                  return data.country_id == operationCountryId.go_value;
                });
                this.defaultCountry = { ...countryInfo };
              }

              this.MovieContainer.movieRatings.forEach((x) => {
                if (!x.country_name) {
                  x.country_name = { ...this.defaultCountry };
                  x.country_id = this.defaultCountry.country_id;
                }
              });

              this.selected_country = { ...this.defaultCountry };
              this.MovieContainer.country_name = this.defaultCountry.country_name;
              this.MovieContainer.country_id = this.defaultCountry.country_id;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getGenreList: function() {
        this.Genre = [];
        let payload = {
          tableName: "ms_genre",
          g_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Genres = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getLabelList: function() {
        this.Labels = [];
        let payload = {
          tableName: "ms_movie_labels",
          label_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Labels = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getResolutionsList: function() {
        this.Genre = [];
        let payload = {
          tableName: "ms_movie_resolutions",
          resolution_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Resolutions = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getAspectRatiosList: function() {
        this.Genre = [];
        let payload = {
          tableName: "ms_aspect_ratios",
          aspect_ratio_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.AspectRatios = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getMovieExperiencesList: function() {
        this.Genre = [];
        let payload = {
          tableName: "ms_movie_experiences",
          movie_experience_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Experiences = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getProductionList: function() {
        this.Production = [];
        let payload = {
          tableName: "ms_production_companies",
          production_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Productions = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getLanguagesList: function() {
        return new Promise((resolve, reject) => {
          this.Languages = [];
          this.LanguagesCopy = [];
          // let body = this.getRequestBody("GET", undefined, this.LanguagesMethod);
          // MasterService.GlobalRequest(body)
          let payload = {
            tableName: "ms_language",
            lang_is_active: "Y",
          };
          MasterService.GetActiveList(payload)
            .then((response) => {
              const { data } = response;
              if (data.status && data.Records.length > 0) {
                this.Languages = data.Records;
                this.LanguagesCopy = [...data.Records];
                resolve(this.Languages);
              } else {
                // Show Errors
                console.log("show error :", data.message);
              }
            })
            .catch((error) => {
              // Show Catch Error
              console.log("show error :", error);
              reject(error);
            });
        });
      },
      getFormatsList: function() {
        this.Formats = [];
        let payload = {
          tableName: "ms_movie_formats",
          mf_is_active: "Y",
          orderBy: "asc",
          columnName: "mf_order",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Formats = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getRatingsList: function() {
        this.Ratings = [];
        let payload = {
          tableName: "ms_ratings",
          rating_is_active: "Y",
          orderBy: "asc",
          columnName: "r_order",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Ratings = data.Records;
              this.setInitialValuesToAllRatings();
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getCrewsList: function() {
        this.Crews = [];
        let payload = {
          tableName: "ms_crew",
          crew_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Crews = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getCitiesList: function(state_id, mainIndex, arrayIndex) {
        // this.Cities = [];
        let payload = {
          tableName: "ms_cities",
          city_is_active: "Y",
          state_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              // this.Cities = data.Records;
              this.MovieDetailsCityAndStatesHandler[mainIndex][
                arrayIndex
              ].cityList = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getStatesList: function(country_id, mainIndex, arrayIndex) {
        let payload = {
          tableName: "ms_states",
          state_is_active: "Y",
          country_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              // this.States = data.Records;
              this.MovieDetailsCityAndStatesHandler[mainIndex][
                arrayIndex
              ].stateList = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getDistributorsList: function() {
        this.Distributors = [];
        let payload = {
          tableName: "ms_distributors",
          d_is_active: "Y",
          parent_distributor_id: 0,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Distributors = data.Records;
              this.Distributors = this.Distributors.filter((x) => {
                return x.parent_distributor_id == 0;
              });

              this.subdistributor = data.Records.filter((x) => {
                return x.parent_distributor_id != 0;
              });
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },



      getPostersList: function() {
        return new Promise((resolve, reject) => {
          this.Posters = [];
          let body = this.getRequestBody("GET", undefined, this.PostersMethod);
          MasterService.GlobalRequest(body)
            .then(async (response) => {
              const { data } = response;
              if (data.status && data.Records.length > 0) {
                await data.Records.map((x) => {
                  if (x.image_setting_is_boxoffice) {
                    this.Posters.push({
                      ...x,
                      image_setting_path: "",
                      image_setting_static_path: "",
                      image_setting_baseurl: "",
                      image_setting_showpath: "",
                    });
                  }
                });
                resolve(this.Posters);
              } else {
                // Show Errors
                console.log("show error :", data.message);
              }
            })
            .catch((error) => {
              // Show Catch Error
              console.log("show error :", error);
              reject(error);
            });
        });
      },
      /**
       * GET REQUEST LIST START
       */

      /**
       * MOVIE TOP INFO SECTION START
       */
      onSelectCountryHandler: function(
        event,
        flag,
        Country,
        Obj,
        DistributorIndex,
        MovieContentIndex
      ) {
        if (flag) {
          this.MovieContainer.country_name = Country.country_name;
          this.MovieContainer.country_id = Country.country_id;
        }
      },
      /**
       * MOVIE TOP INFO SECTION END
       */

      onRemoveDistributorHandler: function(
        DistributorListItem,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].distributor_name = "";
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].distributor_id = null;

        //Clear SubDistributor Name and ID
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].sub_distributor_name = "";

        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].sub_distributor_id = null;
      },

      /**
       * DISTRIBUTORS DROPDOWN HANDLERS START
       */
      onSelectDistributorHandler: function(
        DistributorListItem,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].distributor_name =
          DistributorListItem.d_company_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].distributor_id =
          DistributorListItem.d_id;

        //Clear SubDistributor Name and ID
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].sub_distributor_name = "";

        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].sub_distributor_id = null;

        this.getSubDistributorsList(
          DistributorListItem.d_id,
          DistributorListItem.d_company_name
        );
      },
      onSelectSubDistributorHandler: function(
        event,
        DistributorListItem,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].sub_distributor_name =
          DistributorListItem.d_company_name;

        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].sub_distributor_id =
          DistributorListItem.d_id;
      },
      onChangeLeadTime(
        event,
        type,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        let time = event.target.value;

        if (type === "HH") {
          this.leadTimes[LangaugeFormatDistributorIndex].leadTimeHH = time;
        } else if (type === "MM") {
          this.leadTimes[LangaugeFormatDistributorIndex].leadTimeMM = time;
        }
        console.log({ leadTimes: this.leadTimes });
        this.$forceUpdate();
      },
      onInputOriginalReleaseDate: function(event) {
        console.log(
          "🚀 ~ file: addMovies.vue ~ line 6016 ~ Input event",
          event
        );
      },
      onChangeOriginalReleaseDate: function(event) {
        if (event.target.value) {
          let releasedate = event.target.value;
          this.setDefaultLicenceStartDate(releasedate);
        }
      },
      setDefaultLicenceStartDate: function(date) {
        console.log(date, "fsdfsdf");
        if (this.MovieContainer.movieLangaugeFormatDistributor.length > 0) {
          this.MovieContainer.movieLangaugeFormatDistributor.forEach((mldf) => {
            // if (!mldf.licence_start_date) {
            mldf.licence_start_date = moment(date).format("YYYY-MM-DD") || "";
            mldf.licence_end_date = date
              ? moment(date)
                  .add(365, "days")
                  .format("YYYY-MM-DD")
              : "";
            // }
          });
        }
      },
      getSubDistributorsList: function(d_id, d_name) {
        let payload = {
          tableName: "ms_distributors",
          d_is_active: "Y",
          parent_distributor_id: d_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.subdistributor = data.Records;
              // this.subdistributor = this.Distributors.filter(x => {
              //   return x.parent_distributor_id == 0;
              // });
            } else {
              this.subdistributor = [];
              this.$toasted.show("No Sub-Distributor found for " + d_name);
              // Show Errors
              console.log("show error :::", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },

      onSelectDistributorCinemaHandler: function(
        event,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].selected_cinema.push({
          cine_id: event.cine_id,
          cine_name: event.cine_name,
        });
      },
      onRemoveDistributorCinemaHandler: function(
        event,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        console.log(
          " this.MovieContainer.movieLangaugeFormatDistributor:>> ",
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ].movieDistributors[DistributorIndex]
        );

        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].selected_cinema.splice(
          event.cine_name,
          1
        );
      },
      onSelectDistributorsCountryHandler: function(
        event,
        Country,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].country_name =
          Country.country_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].country_id = Country.country_id;
        this.onResetSelectedDistributorDropdown(
          ["state", "city"],
          LangaugeFormatDistributorIndex,
          DistributorIndex
        );
        this.getStatesList(
          Country.country_id,
          LangaugeFormatDistributorIndex,
          DistributorIndex
        );
      },
      onSelectStateHandler: function(
        event,
        State,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].state_name = State.state_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].state_id = State.state_id;
        this.onResetSelectedDistributorDropdown(
          [, "city"],
          LangaugeFormatDistributorIndex,
          DistributorIndex
        );
        this.getCitiesList(
          State.state_id,
          LangaugeFormatDistributorIndex,
          DistributorIndex
        );
      },
      onSelectCityHandler: function(
        event,
        City,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].city_name = City.city_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].city_id = City.city_id;
      },
      onResetSelectedDistributorDropdown: function(
        [state, city],
        LangaugeFormatDistributorIndex,
        DistributorIndex
      ) {
        if (state && state === "state") {
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ].movieDistributors[DistributorIndex].state_name = "";
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ].movieDistributors[DistributorIndex].state_id = null;
          this.MovieDetailsCityAndStatesHandler[LangaugeFormatDistributorIndex][
            DistributorIndex
          ].stateList = [];
        }
        if (city && city === "city") {
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ].movieDistributors[DistributorIndex].city_name = "";
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ].movieDistributors[DistributorIndex].city_id = null;
          this.MovieDetailsCityAndStatesHandler[LangaugeFormatDistributorIndex][
            DistributorIndex
          ].cityList = [];
        }
      },

      // Increase & decrease Distributor
      removeDistributor: function(
        event,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors.splice(DistributorIndex, 1);
        this.MovieDetailsCityAndStatesHandler[
          LangaugeFormatDistributorIndex
        ].splice(DistributorIndex, 1);
      },
      addDistributor: function(
        event,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        let obj = {
          id: "",
          distributor_name: this.MovieContainer.original_distributor_name
            ? this.MovieContainer.original_distributor_name.d_company_name
            : "",
          distributor_id: this.MovieContainer.original_distributor_id
            ? this.MovieContainer.original_distributor_id
            : "",
          d_company_name: this.MovieContainer.original_distributor_name
            ? {
                ...this.MovieContainer.original_distributor_name,
              }
            : "",
          city_name: "",
          city_id: null,
          state_name: "",
          state_id: null,
          country_name: "",
          country_id: null,
          fromdate: new Date(),
          todate: new Date(),
          // NEW
          cinema_id: null,
          cinema_name: "",
          selected_cinema: [],
        };
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors.push(obj);
        let _obj = { country_id: null, stateList: [], cityList: [] };
        this.MovieDetailsCityAndStatesHandler[
          LangaugeFormatDistributorIndex
        ].push(_obj);
      },
      /**
       * DISTRIBUTORS DROPDOWN HANDLERS END
       */
      /**
       * MOVIE DETAILS -LANGUAGE -FORMAT HANDLER START
       */
      onChangeRuntime: _.debounce(function(event, RatingIndex) {
        let runtime = parseInt(event.target.value);
        if (!runtime) {
          return;
        }

        let timestring = this.getTimeString(runtime);
        if (timestring) {
          this.setDefaultMovieLength(timestring);
        }
      }, 2000),
      getTimeString: function(val) {
        val = parseInt(val);
        if (isNaN(val)) {
          return null;
        }

        let hours = Math.floor(val / 60);
        let minutes = val - hours * 60;
        let seconds = "00";

        hours = hours.toString().padStart(2, "0");
        minutes = minutes.toString().padStart(2, "0");

        return `${hours}:${minutes}:${seconds}`;
      },
      getTimeStringFromSeconds: function(val) {
        val = parseInt(val);
        if (isNaN(val)) {
          return null;
        }

        let hours = Math.floor(val / (60 * 60));
        let remaining_seconds = val - hours * 60 * 60;
        let minutes = Math.floor(remaining_seconds / 60);
        let seconds = remaining_seconds - minutes * 60;

        hours = hours.toString().padStart(2, "0");
        minutes = minutes.toString().padStart(2, "0");
        seconds = seconds.toString().padStart(2, "0");

        return `${hours}:${minutes}:${seconds}`;
      },
      onRemoveLanguageHandler: function(Language, index, type = 2) {
        if (type === 1) {
          // movie trailers language
          this.movie_trailers[index].language_id = null;
        } else if (type === 2) {
          // movie version language
          this.MovieContainer.movieLangaugeFormatDistributor[index].lang_name =
            "";
          this.MovieContainer.movieLangaugeFormatDistributor[
            index
          ].lang_id = null;
        } else if (type === 3) {
          // original trailer language
          this.MovieContainer.original_trailer.language_id = null;
        } else if (type === 4) {
          this.cast_and_crew[index].language_id = null;
          this.cast_and_crew[index].langauge = "";
        }
      },
      onSelectLanguageHandler: function(Language, index, type = 2) {
        if (type === 1) {
          // movie trailers language
          this.movie_trailers[index].language_id = Language.lang_id;
        } else if (type === 2) {
          // movie version language
          this.MovieContainer.movieLangaugeFormatDistributor[index].lang_name =
            Language.lang_name;
          this.MovieContainer.movieLangaugeFormatDistributor[index].lang_id =
            Language.lang_id;
        } else if (type === 3) {
          // original trailer language
          this.MovieContainer.original_trailer.language_id = Language.lang_id;
        } else if (type === 4) {
          this.cast_and_crew[index].language_id = Language.lang_id;
          this.cast_and_crew[index].langauge = Language.lang_name;
        }
      },
      onRemoveSubtitleLanguageHandler(
        Language,
        index,
        subtitle_number,
        type = 2
      ) {
        if (type == 2) {
          this.MovieContainer.movieLangaugeFormatDistributor[index][
            `subtitle_language_id_${subtitle_number}`
          ] = null;
          this.MovieContainer.movieLangaugeFormatDistributor[index][
            `subtitle_language_name_${subtitle_number}`
          ] = null;
        }
      },
      onSelectSubtitleLanguageHandler: function(
        Language,
        index,
        subtitle_number,
        type = 2
      ) {
        if (type === 1) {
          // movie trailer subtitle language
          this.movie_trailers[index][`subtitle_lang_id_${subtitle_number}`] =
            Language.lang_id;
        } else if (type === 2) {
          // movie version subtitle lang
          this.MovieContainer.movieLangaugeFormatDistributor[index][
            `subtitle_language_name_${subtitle_number}`
          ] = Language.lang_name;
          this.MovieContainer.movieLangaugeFormatDistributor[index][
            `subtitle_language_id_${subtitle_number}`
          ] = Language.lang_id;
        } else if (type === 3) {
          // original trailer subtitle lang
          this.MovieContainer.original_trailer[
            `subtitle_lang_id_${subtitle_number}`
          ] = Language.lang_id;
        }

        this.dummy = Math.random(); // to cause the featureVersionsText to recompute
        this.$forceUpdate();
      },
      onSelectOriginalLanguageHandler: function(Language) {
        this.MovieContainer.original_lang_name = Language.lang_name;
        this.MovieContainer.original_lang_id = Language.lang_id;
        this.changeOriginalFvdata(Language, "lang");
      },
      onSelectOriginalDistributorHandler(distributor) {
        this.MovieContainer.copyright = `Copyright ${distributor.d_company_name}`;
        this.MovieContainer.original_distributor_name =
          distributor.d_company_name;
        this.MovieContainer.original_distributor_id = distributor.d_id;

        this.MovieContainer.movieLangaugeFormatDistributor.forEach((lfd) => {
          if (lfd.movieDistributors && lfd.movieDistributors.length > 0) {
            lfd.movieDistributors.forEach((md) => {
              if (!md.distributor_id) {
                md.distributor_id = distributor.d_id;
                md.distributor_name = distributor.d_company_name;
                md.d_company_name = this.MovieContainer.original_distributor_id
                  ? {
                      d_company_name: this.MovieContainer
                        .original_distributor_name,
                      d_id: this.MovieContainer.original_distributor_id,
                    }
                  : "";
              } else {
                md.distributor_id = distributor.d_id;
                md.distributor_name = distributor.d_company_name;
                md.d_company_name = this.MovieContainer.original_distributor_id
                  ? {
                      d_company_name: this.MovieContainer
                        .original_distributor_name,
                      d_id: this.MovieContainer.original_distributor_id,
                    }
                  : "";
              }
            });
          }
        });
      },
      onSelectFormatHandler(Format, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].format_name = Format.mf_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].format_id = Format.mf_id;
      },
      onSelectExperienceHandler(experience, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_experience_format_name = experience.movie_experience;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_experience_format_id = experience.movie_experience_id;
      },
      onRemoveExperienceHandler(experience, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_experience_format_name = "";
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_experience_format_id = null;
      },
      onSelectAspectRatio(ar, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_aspect_ratio_name = ar.aspect_ratio_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_aspect_ratio_id = ar.aspect_ratio_id;
      },
      onSelectMovieResolution(resolution, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_resolution_name = resolution.resolution_short_code;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_resolution_id = resolution.resolution_id;
      },
      onSelectSoundFormatHandler: function(
        Format,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].sound_format_name = Format.sound_format_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].sound_format_id = Format.sound_format_id;
        console.log("Format", Format);
      },

      //Set Image
      // setImage: function(e, LangaugeFormatDistributorIndex) {
      //   this.file = e.target.files[0];
      //   this.filename = e.target.files[0]["name"];
      //   this.indexofthubmnail = LangaugeFormatDistributorIndex;

      //   // console.log("file.type.indexOf :", file.type);
      //   if (this.file.type.indexOf("image/") === -1) {
      //     this.$toasted.show("Please select an image file");
      //     return;
      //   }
      //   if (typeof FileReader === "function") {
      //     const reader = new FileReader();
      //     reader.onload = event => {
      //       this.imgSrc = event.target.result;
      //       this.width = 129;
      //       this.height = 192;
      //       // this.$cropper.setAspectRatio(1);
      //       // rebuild cropperjs with the updated source
      //       this.$bvModal.show("imagecropper");
      //       e.target.value = "";
      //     };
      //     reader.readAsDataURL(this.file);
      //   } else {
      //     // alert("Sorry, FileReader API not supported");
      //   }
      // },

      // cropImage() {
      //   this.$bvModal.hide("imagecropper");
      //   // get image data for post processing, e.g. upload or setting image src
      //   this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      //   // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      //   var block = this.cropImg.split(";");
      //   // Get the content type of the image
      //   var contentType = block[0].split(":")[1]; // In this case "image/gif"
      //   // get the real base64 content of the file
      //   var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      //   // Convert it to a blob to upload
      //   var blob1 = this.b64toBlob(realData, contentType);
      //   this.onThumbnailUpload(blob1, this.filename, this.indexofthubmnail);
      // },
      // b64toBlob(b64Data, contentType, sliceSize) {
      //   contentType = contentType || "";
      //   sliceSize = sliceSize || 512;

      //   var byteCharacters = atob(b64Data);
      //   var byteArrays = [];

      //   for (
      //     var offset = 0;
      //     offset < byteCharacters.length;
      //     offset += sliceSize
      //   ) {
      //     var slice = byteCharacters.slice(offset, offset + sliceSize);

      //     var byteNumbers = new Array(slice.length);
      //     for (var i = 0; i < slice.length; i++) {
      //       byteNumbers[i] = slice.charCodeAt(i);
      //     }

      //     var byteArray = new Uint8Array(byteNumbers);

      //     byteArrays.push(byteArray);
      //   }

      //   var blob = new Blob(byteArrays, { type: contentType });
      //   return blob;
      // },
      // UPLOAD THUMBNAIL FOR POS
      // event, LangaugeFormatDistributor, LangaugeFormatDistributorIndex
      // onThumbnailUpload: function(
      //   image,
      //   filename,
      //   LangaugeFormatDistributorIndex
      // ) {
      //   let loader = this.$loading.show();

      //   let formData = new FormData();
      //   // formData.append("image", image);
      //   formData.append("image", image, filename);
      //   formData.append("imagePath", "Movie Image");
      //   MasterService.GlobalUploadImage(formData)
      //     .then(response => {
      //       // console.log("response :", response);
      //       const { data } = response;
      //       if (data && data.status) {
      //         this.MovieContainer.movieLangaugeFormatDistributor[
      //           LangaugeFormatDistributorIndex
      //         ].md_thumbnail_url = data.path;
      //         this.imgSrc = "";
      //         this.$bvModal.hide("imagecropper");
      //       } else {
      //         data["message"] && data["message"]["message"]
      //           ? this.$toasted.show(data.message.message)
      //           : this.$toasted.show(
      //               data.message ||
      //                 "Sorry! Something went wrong. kindly contact your administrator"
      //             );
      //       }
      //     })
      //     .catch(this._CatchError)
      //     .finally(() => {
      //       setTimeout(() => loader.hide(), 1000);
      //     });
      // },
      // ___onThumbnailUpload: function(
      //   event,
      //   LangaugeFormatDistributor,
      //   LangaugeFormatDistributorIndex
      // ) {
      //   let self = this;
      //   let _URL = window.URL || window.webkitURL;
      //   let file, img;
      //   if ((file = event.target.files[0])) {
      //     img = new Image();
      //     img.src = _URL.createObjectURL(file);
      //     img.onload = async () => {
      //       console.log("img.width :", img.width);
      //       console.log("img. :", img.width);
      //       if (img.width < parseInt(280) || img.height < parseInt(350)) {
      //         this.$refs[
      //           "ThumbnailUploadImage" + LangaugeFormatDistributorIndex
      //         ].map((f, FIndex) => {
      //           if (FIndex == 0) {
      //             f.value = "";
      //             f.type = "text";
      //             f.type = "file";
      //           }
      //         });
      //       } else {
      //         console.log("upload images here :");
      //         // let formData = new FormData();
      //         // formData.append("image", event.target.files[0]);
      //         // formData.append("imagePath", "/uploads/moviesThumbnail/");
      //         // MasterService.GlobalUploadImage(formData)
      //         //   .then(response => {
      //         //     const { data } = response;
      //         //     if (data && data.status) {
      //         //       this.MovieContainer.movieLangaugeFormatDistributor[
      //         //         LangaugeFormatDistributorIndex
      //         //       ].md_thumbnail_url = data.path;
      //         //     } else {
      //         //       data["message"] && data["message"]["message"]
      //         //         ? this.$toasted.show(data.message.message)
      //         //         : this.$toasted.show(
      //         //             data.message ||
      //         //               "Sorry! Something went wrong. kindly contact your administrator"
      //         //           );
      //         //     }
      //         //   })
      //         //   .catch(this._CatchError);
      //       }
      //     };
      //   }
      // },
      // Increase & decrease
      addLangaugeFormatDistributor: function(event) {
        let obj = {
          id: "",
          lang_name: "",
          lang_id: null,
          format_id: null,
          format_name: "",
          searchable_language: "",
          //  sound_format_id: null,
          // sound_format_name: "",
          trailer: "",
          md_thumbnail_url: "",
          md_thumbnail_path: "/uploads/moviethumbnail/",
          md_thumbnail_name: "Upload Poster",
          md_thumbnail_size: "",
          subtitle_language_id_1: null,
          subtitle_language_name_1: "",
          selected_subtitle_1: null,
          selected_subtitle_2: null,
          subtitle_language_id_2: null,
          subtitle_language_name_2: "",
          sales_channel: _.cloneDeep(this.aggregatorUsersList),
          dist_share_threshold: null,
          dcp_available: "N",
          tms_id: "",
          macs_status: "Y",
          is_foreign_movie: "N",
          uuid: "",
          kdm: null,
          kdm_id: null,
          selected_kdm: "",
          key_valid_from: "",
          key_valid_to: "",
          movie_tms_length:
            this.MovieContainer.movieRatings &&
            this.MovieContainer.movieRatings[0] &&
            this.MovieContainer.movieRatings[0].runTime
              ? this.getTimeString(
                  this.MovieContainer.movieRatings[0].runTime
                ) || ""
              : "",
          movie_tms_intermission_time: "",
          movie_tms_credits_time: "",
          movie_fps: 24,
          movie_length_in_frames: null,
          movie_intermission_time_in_frames: null,
          movie_credits_time_in_frames: null,
          showMore: false,
          sound_format_id: null,

          movie_aspect_ratio_id: null,
          movie_aspect_ratio_name: "",

          movie_experience_format_id: null,
          movie_experience_format_name: null,
          selected_experience: null,

          movie_resolution_id: null,
          movie_resolution_name: "",

          is_classic_show: this.MovieContainer.is_classic_show,
          is_confirmed_show: this.MovieContainer.is_confirmed_show,
          is_private_show: this.MovieContainer.is_private_show,
          is_crowd_show: this.MovieContainer.is_crowd_show,
          is_movie_club: this.MovieContainer.is_movie_club,

          movieDistributors: [
            {
              id: "",
              distributor_name:
                this.original_distributor &&
                this.original_distributor.hasOwnProperty("d_id") &&
                this.original_distributor["d_id"]
                  ? this.original_distributor["d_company_name"]
                  : null,
              distributor_id:
                this.original_distributor &&
                this.original_distributor.hasOwnProperty("d_id") &&
                this.original_distributor["d_id"]
                  ? this.original_distributor["d_id"]
                  : null,
              d_company_name:
                this.original_distributor &&
                this.original_distributor.hasOwnProperty("d_id") &&
                this.original_distributor["d_id"]
                  ? this.original_distributor
                  : null,
              city_name: "",
              city_id: null,
              state_name: "",
              state_id: null,
              country_name: "",
              country_id: null,
              fromdate: new Date(),
              todate: new Date(),
              // NEW
              selected_cinema: [],
              // cinema_id: null,
              // cinema_name: ""
            },
          ],
          selected_cinema: this.Cinemas || [],
          licence_start_date: this.originalReleaseDate
            ? moment(this.originalReleaseDate).format("YYYY-MM-DD")
            : "",
          licence_end_date: this.originalReleaseDate
            ? moment(this.originalReleaseDate)
                .add(365, "days")
                .format("YYYY-MM-DD")
            : "",
          selectShowType: [],
          interval_time: "",
        };
        this.setInitialValuesToLanguageFormatDistributor(obj);
        let tempObj = this.copyPreviousFeatureData(obj);
        obj = _.cloneDeep(tempObj);
        let leadtime = {
          leadTimeHH: "00",
          leadTimeMM: "00",
        };
        this.leadTimes.push(leadtime);
        console.log("movieLangaugeFormatDistributor obj", obj);
        this.MovieContainer.movieLangaugeFormatDistributor.push(obj);
        let _obj = [
          {
            country_id: null,
            stateList: [],
            cityList: [],
          },
        ];
        this.MovieDetailsCityAndStatesHandler.push(_obj);
      },
      removeLangaugeFormatDistributor: function(
        event,
        LangaugeFormatDistributorIndex
      ) {
        if (!this.disableFeatureVersion) {
          this.onChangeEvent(LangaugeFormatDistributorIndex);
          this.MovieContainer.movieLangaugeFormatDistributor.splice(
            LangaugeFormatDistributorIndex,
            1
          );
          this.MovieDetailsCityAndStatesHandler.splice(
            LangaugeFormatDistributorIndex,
            1
          );
          this.leadTimes.splice(LangaugeFormatDistributorIndex, 1);
        } else {
          return this.$toasted.show("Edit Not Allowed For Events");
        }
      },
      setInitialValuesToLanguageFormatDistributor: function(
        languageFormatDistributor
      ) {
        // this.Formats has formats to be displayed in drop down.

        if (
          !languageFormatDistributor ||
          !this.Formats ||
          !this.initialPreferredFormat
        ) {
          // Exit if this.Formats or initialPreferredFormat does not have data
          return;
        }

        // Check if this.Formats contain this.initialPreferredFormat as `.mf_name`
        for (const index in this.Formats) {
          let formatsValue = this.Formats[index];
          if (!formatsValue || !formatsValue.mf_name) {
            continue;
          }
          if (
            formatsValue.mf_name.toUpperCase() ===
            this.initialPreferredFormat.toUpperCase()
          ) {
            console.log("Found match with initial preselected format");
            languageFormatDistributor.mf_name = formatsValue;
            languageFormatDistributor.format_name = formatsValue.mf_name;
            languageFormatDistributor.format_id = formatsValue.mf_id;
            break;
          }
        }
      },
      // using a function to avoid state issues
      validateEndDateField: function(languageFormatDistributor) {
        // show end date error
        return (
          this.submitted &&
          languageFormatDistributor.licence_start_date &&
          !languageFormatDistributor.licence_end_date
        );
      },
      calculateFramesFromLength: function(LangaugeFormatDistributor) {
        if (
          LangaugeFormatDistributor &&
          !isNaN(parseInt(LangaugeFormatDistributor.movie_fps))
        ) {
          let fps = parseInt(LangaugeFormatDistributor.movie_fps);

          if (
            LangaugeFormatDistributor &&
            LangaugeFormatDistributor.movie_tms_length
          ) {
            let length_in_seconds = this.getTimeFromTimeString(
              LangaugeFormatDistributor.movie_tms_length
            );
            let total_frames = length_in_seconds * fps;
            LangaugeFormatDistributor.movie_length_in_frames = total_frames;
          } else {
            LangaugeFormatDistributor.movie_length_in_frames = null;
          }

          if (
            LangaugeFormatDistributor &&
            LangaugeFormatDistributor.movie_tms_intermission_time
          ) {
            let length_in_seconds = this.getTimeFromTimeString(
              LangaugeFormatDistributor.movie_tms_intermission_time
            );
            let total_frames = length_in_seconds * fps;
            LangaugeFormatDistributor.movie_intermission_time_in_frames = total_frames;
          } else {
            LangaugeFormatDistributor.movie_intermission_time_in_frames = null;
          }

          if (
            LangaugeFormatDistributor &&
            LangaugeFormatDistributor.movie_tms_credits_time
          ) {
            let length_in_seconds = this.getTimeFromTimeString(
              LangaugeFormatDistributor.movie_tms_credits_time
            );
            let total_frames = length_in_seconds * fps;
            LangaugeFormatDistributor.movie_credits_time_in_frames = total_frames;
          } else {
            LangaugeFormatDistributor.movie_credits_time_in_frames = null;
          }
        }
      },
      calculateLengthFromFrames: function(LangaugeFormatDistributor) {
        if (
          LangaugeFormatDistributor &&
          !isNaN(parseInt(LangaugeFormatDistributor.movie_fps))
        ) {
          let fps = parseInt(LangaugeFormatDistributor.movie_fps);
          console.log("🚀 ~ file: addMovies.vue ~ line 7973 ~ fps", fps);

          if (
            LangaugeFormatDistributor &&
            !isNaN(parseInt(LangaugeFormatDistributor.movie_length_in_frames))
          ) {
            let total_frames = parseInt(
              LangaugeFormatDistributor.movie_length_in_frames
            );
            let total_seconds = Math.floor(total_frames / fps);
            let time_string_from_seconds = this.getTimeStringFromSeconds(
              total_seconds
            );
            LangaugeFormatDistributor.movie_tms_length = time_string_from_seconds;
          } else {
            LangaugeFormatDistributor.movie_tms_length = "";
          }

          if (
            LangaugeFormatDistributor &&
            !isNaN(
              parseInt(
                LangaugeFormatDistributor.movie_intermission_time_in_frames
              )
            )
          ) {
            let total_frames = parseInt(
              LangaugeFormatDistributor.movie_intermission_time_in_frames
            );
            let total_seconds = Math.floor(total_frames / fps);
            let time_string_from_seconds = this.getTimeStringFromSeconds(
              total_seconds
            );
            LangaugeFormatDistributor.movie_tms_intermission_time = time_string_from_seconds;
          } else {
            LangaugeFormatDistributor.movie_tms_intermission_time = "";
          }

          if (
            LangaugeFormatDistributor &&
            !isNaN(
              parseInt(LangaugeFormatDistributor.movie_credits_time_in_frames)
            )
          ) {
            let total_frames = parseInt(
              LangaugeFormatDistributor.movie_credits_time_in_frames
            );
            let total_seconds = Math.floor(total_frames / fps);
            let time_string_from_seconds = this.getTimeStringFromSeconds(
              total_seconds
            );
            LangaugeFormatDistributor.movie_tms_credits_time = time_string_from_seconds;
          } else {
            LangaugeFormatDistributor.movie_tms_credits_time = "";
          }
        }
      },
      getTimeFromTimeString: function(time_string) {
        if (!time_string || time_string.split(":").length !== 3) {
          return 0;
        }

        let time_components = time_string.trim().split(":");
        let hours = parseInt(time_components[0]);
        let minutes = parseInt(time_components[1]);
        let seconds = parseInt(time_components[2]);

        let total_minutes = hours * 60 + minutes;
        let total_seconds = total_minutes * 60 + seconds;

        return total_seconds;
      },
      /**
       * MOVIE DETAILS -LANGUAGE -FORMAT HANDLER END
       */

      /**
       * -RATING -RELEASED DATE -RUNTIME SECTION START
       */
      onSelectRatingCountryHandler: function(Country, RatingIndex) {
        this.MovieContainer.movieRatings[RatingIndex].country_name =
          Country.country_name;
        this.MovieContainer.movieRatings[RatingIndex].country_id =
          Country.country_id;
      },
      onSelectRatingRegionHandler: function(region, RatingIndex) {
        this.MovieContainer.movieRatings[RatingIndex].region_id =
          region.region_id;
        this.MovieContainer.movieRatings[RatingIndex].region_name =
          region.region_name;
        if (region.region_id == 0) {
          this.MovieContainer.movieRatings = this.MovieContainer.movieRatings.filter(
            (x, index) => index == RatingIndex
          );
        }
      },
      onSelectMovieRatingHandler(MovieRating, RatingIndex) {
        console.log("onSelectMovieRatingHandler -> MovieRating", MovieRating);
        this.MovieContainer.movieRatings[RatingIndex].rating =
          MovieRating.rating;
        this.MovieContainer.movieRatings[RatingIndex].rating_id =
          MovieRating.rating_id;
      },
      onRemoveMovieRatingHandler(MovieRating, RatingIndex) {
        console.log("onRemoveMovieRatingHandler -> MovieRating", MovieRating);
        this.MovieContainer.movieRatings[RatingIndex].rating = null;
        this.MovieContainer.movieRatings[RatingIndex].rating_id = null;
      },
      // Increase & decrease Rating
      addMoreRating: function(event) {
        let movieRating = {
          id: "",
          country_name: this.defaultCountry ? { ...this.defaultCountry } : "",
          country_id: this.defaultCountry
            ? this.defaultCountry.country_id
            : null,
          rating: "",
          rating_id: null,
          selectedRating: null,
          releaseDate: null,
          region_id: null,
          region_obj: null,
          region_name: "",
          runTime: "",
          intervalTime: "",
        };
        this.setInitialValuesToRating(movieRating);
        this.MovieContainer.movieRatings.push(movieRating);
      },
      removeRating: function(event, RatingIndex) {
        this.MovieContainer.movieRatings.splice(RatingIndex, 1);
      },
      setInitialValuesToRating: function(newMovieRatingData) {
        // this.Ratings has ratings to be displayed in drop down.

        if (!newMovieRatingData) {
          return;
        }

        // set default values for runTime & intervalTime
        newMovieRatingData.runTime = "0";
        newMovieRatingData.intervalTime = "0";

        if (!this.Ratings || !this.initialPreferredRating) {
          // Exit if this.Ratings or initialPreferredRating does not have data
          return;
        }

        // Check if this.Ratings contain this.initialPreferredRating as `.rating`
        for (const index in this.Ratings) {
          let ratingsValue = this.Ratings[index];
          if (!ratingsValue || !ratingsValue.rating) {
            continue;
          }

          if (
            ratingsValue.rating.toUpperCase() ===
            this.initialPreferredRating.toUpperCase()
          ) {
            console.log("Found match with initial preselected rating");
            newMovieRatingData.rating = ratingsValue;
            newMovieRatingData.rating_id = ratingsValue.rating_id;
            break;
          }
        }
      },
      // This must be called when Ratings is update
      setInitialValuesToAllRatings: function() {
        if (!this.MovieContainer.movieRatings) {
          return;
        }
        for (const index in this.MovieContainer.movieRatings) {
          let value = this.MovieContainer.movieRatings[index];
          if (value) {
            this.setInitialValuesToRating(value);
          }
        }
      },
      addMovieTrailer: function() {
        this.movie_trailers.push({
          language_id: null,
          language: null,
          trailer_link: "",
          subtitle_lang_id_1: null,
          subtitle_lang_1: null,
          subtitle_lang_id_2: null,
          subtitle_lang_2: null,
        });
      },

      removeMovieTrailer: function(index) {
        this.movie_trailers.splice(index, 1);
      },
      /**
       * -RATING -RELEASED DATE -RUNTIME SECTION START
       */
      /**
       * MOVIE CONTENT DROPDOWN HANDLERS START
       */
      onSelectCrewHandler: function(
        CrewItem,
        Obj,
        CrewIndex,
        MovieContentIndex
      ) {
        this.cast_and_crew[MovieContentIndex].movieCastAndCrewList[
          CrewIndex
        ].crew_title = CrewItem.crew_title;
        this.cast_and_crew[MovieContentIndex].movieCastAndCrewList[
          CrewIndex
        ].crew_id = CrewItem.crew_id;
      },
      // Increase & decrease Cast & Crew
      _addCastAndCrew: function(event, MovieContentIndex) {
        this.MovieContentContainer[MovieContentIndex].movieCastAndCrewList.push(
          {
            id: "",
            crew_title: "",
            crew_id: null,
            selectedCastMembers: [],
            members: [],
          }
        );
      },
      addCastAndCrew: function(event, index) {
        console.log("CALLING addCastAndCrew", index);
        this.cast_and_crew[index].movieCastAndCrewList.push({
          id: "",
          crew_title: "",
          crew_id: null,
          selectedCastMembers: [],
          members: [],
        });
      },
      _removeCastAndCrew: function(event, CrewIndex, MovieContentIndex) {
        this.MovieContentContainer[
          MovieContentIndex
        ].movieCastAndCrewList.splice(CrewIndex, 1);
      },
      removeCastAndCrew: function(event, CrewIndex, ContentIndex) {
        this.cast_and_crew[ContentIndex].movieCastAndCrewList.splice(
          CrewIndex,
          1
        );
      },
      addCastCrewMember: function(CastAndCrewItem) {
        console.log("CastAndCrewItem", CastAndCrewItem);
        CastAndCrewItem.members.push({
          person_name: "",
          order_no: "",
        });

        this.recomputeOrder(CastAndCrewItem.members, "order_no");
      },
      onAddCastCrewOption: function(option, CastAndCrewItem) {
        CastAndCrewItem.members.push({
          person_name: option['cast_name'],
          order_no: "",
          mcm_id: option['mcm_id'] || null,
        });
        this.recomputeOrder(CastAndCrewItem.members, "order_no");
        console.log('CastAndCrewItem.members', CastAndCrewItem.members);
      },
      onRemoveCastCrewOption: function(event, CastAndCrewItem) {
        let tempCastsArray = CastAndCrewItem['selectedCastMembers'].map((x, index) => {return {person_name: x['cast_name'], order_no: index, mcm_id: x['cast_name']}})
        CastAndCrewItem.members = _.cloneDeep(tempCastsArray)
        this.recomputeOrder(CastAndCrewItem.members, "order_no");
        console.log('CastAndCrewItem.members', CastAndCrewItem.members);
      },
      removeCastCrewMember: function(CastAndCrewItem, itemIndex) {
        CastAndCrewItem.members.splice(itemIndex, 1);
        this.recomputeOrder(CastAndCrewItem.members, "order_no");
      },
      recomputeOrder: function(items, prop_name) {
        if (!items || !Array.isArray(items) || !prop_name) return;

        for (let i = 0; i < items.length; i++) {
          items[i][prop_name] = i + 1;
        }
      },
      addSceneImage: function(event, MovieContentIndex) {
        this.movieScenes.push({
          image_path: "",
        });
        // this.Scenes.push({
        //   SceneImageUrl: "",
        //   SceneImageName: ""
        // })
      },
      removeSceneImage: function(event, sceneIndex) {
        this.movieScenes.splice(sceneIndex, 1);
      },

      removeImageHandler: function(obj, type) {
        if (!obj) return;

        if (type === 1) {
          // movie content artwork
          obj.artwork = "";
        } else if (type === 2) {
          // lang specific other images
          obj.image_setting_path = "";
        } else if (type === 3) {
          // movie scene
          obj.image_path = "";
        } else if (type === 4) {
          // movie versions artwork
          obj.md_thumbnail_url = "";
        } else if (type === 5) {
          // original movie artwork
          obj.original_artwork = "";
        }

        this.$forceUpdate();
      },

      // setImagePosters: function(e, PosterItem, PosterIndex, MovieContentIndex) {
      //   this.file = e.target.files[0];
      //   this.filename = e.target.files[0]["name"];
      //   this.indexofthubmnail = PosterIndex;
      //   this.movieindex = MovieContentIndex;

      //   this.width = PosterItem.image_setting_width;
      //   this.height = PosterItem.image_setting_height;
      //   console.log('this.width  :>> ', this.width );
      //   console.log('this.height :>> ', this.height);

      //   if (this.file.type.indexOf("image/") === -1) {
      //     this.$toasted.show("Please select an image file");
      //     return;
      //   }
      //   if (typeof FileReader === "function") {
      //     const reader = new FileReader();
      //     reader.onload = event => {
      //       this.imgSrc = event.target.result;

      //       this.$bvModal.show("imagecropperposters");
      //       e.target.value = "";
      //     };
      //     reader.readAsDataURL(this.file);
      //   } else {
      //     // alert("Sorry, FileReader API not supported");
      //   }
      // },

      // cropImagePoster() {
      //   this.$bvModal.hide("imagecropperposters");

      //   // get image data for post processing, e.g. upload or setting image src
      //   this.cropImg = this.$refs.cropperposters.getCroppedCanvas().toDataURL();
      //   // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      //   console.log(this.data);
      //   var block = this.cropImg.split(";");
      //   // Get the content type of the image
      //   var contentType = block[0].split(":")[1]; // In this case "image/gif"
      //   // get the real base64 content of the file
      //   var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      //   // Convert it to a blob to upload
      //   var blob1 = this.b64toBlob(realData, contentType);
      //   this.onFileUpload(
      //     blob1,
      //     this.filename,
      //     this.indexofthubmnail,
      //     this.movieindex
      //   );
      // },

      // b64toBlob(b64Data, contentType, sliceSize) {
      //   contentType = contentType || "";
      //   sliceSize = sliceSize || 512;

      //   var byteCharacters = atob(b64Data);
      //   var byteArrays = [];

      //   for (
      //     var offset = 0;
      //     offset < byteCharacters.length;
      //     offset += sliceSize
      //   ) {
      //     var slice = byteCharacters.slice(offset, offset + sliceSize);

      //     var byteNumbers = new Array(slice.length);
      //     for (var i = 0; i < slice.length; i++) {
      //       byteNumbers[i] = slice.charCodeAt(i);
      //     }

      //     var byteArray = new Uint8Array(byteNumbers);

      //     byteArrays.push(byteArray);
      //   }

      //   var blob = new Blob(byteArrays, { type: contentType });
      //   return blob;
      // },

      // onFileUpload: function(image, filename, PosterIndex, MovieContentIndex) {
      //   let loader = this.$loading.show();

      //   let formData = new FormData();
      //   formData.append("image", image, filename);
      //   formData.append("imagePath", "Movie Poster Image");
      //   // formData.append("imagePath", PosterItem.image_setting_static_path);
      //   MasterService.GlobalUploadImage(formData)
      //     .then(response => {
      //       const { data } = response;
      //       if (data && data.status) {
      //         // this.MovieContentContainer[MovieContentIndex].moviePosters[
      //         //   PosterIndex
      //         // ].image_setting_path = data.path;
      //         this.onSetImagePath(data, MovieContentIndex, PosterIndex);
      //         this.$bvModal.hide("imagecropperposters");
      //       } else {
      //         data["message"] && data["message"]["message"]
      //           ? this.$toasted.show(data.message.message)
      //           : this.$toasted.show(
      //               data.message ||
      //                 "Sorry! Something went wrong. kindly contact your administrator"
      //             );
      //       }
      //     })
      //     .catch(this._CatchError)
      //     .finally(() => {
      //       setTimeout(() => loader.hide(), 1000);
      //     });
      // },
      // onSetImagePath: function(data, MovieContentIndex, PosterIndex) {
      //   let Obj = this.MovieContentContainer[MovieContentIndex].moviePosters[
      //     PosterIndex
      //   ];
      //   let _Obj = {
      //     ...Obj,
      //     image_setting_path: data.path
      //   };
      //   Vue.set(
      //     this.MovieContentContainer[MovieContentIndex].moviePosters,
      //     PosterIndex,
      //     _Obj
      //   );
      // },
      /**
       * MOVIE CONTENT DROPDOWN HANDLERS END
       */

      MovieContentValidations: function() {
        // crew_title: "",
        // person_name: "",
        // order_no: ""
        let array = [
          { title: "movieContentTitle", type: "String", isRequired: true },
          {
            title: "movieCastAndCrewList",
            type: "Array",
            isRequired: true,
            keys: ["crew_title", "person_name"],
          },
        ];

        // let TempMovieContentContainer = this.MovieContentContainer;
        // Testing Only One Language Content or use above for all.
        let TempMovieContentContainer = [this.MovieContentContainer[0]];

        for (let i = 0; i < TempMovieContentContainer.length; i++) {
          const element = this.MovieContentContainer[i];
          for (let j = 0; j < array.length; j++) {
            const key = array[j];
            if (key.isRequired && key.type === "String") {
              if (!this.ValidateString(element[key.title])) {
                this.$toasted.show(
                  `Movie ${key.title} field cannot be empty in ${element.langauge} section.`
                );
                return false;
              }
            } else if (key.isRequired && key.type === "Array") {
              if (
                !this.ValidateArray(
                  element[key.title],
                  element[key.title].length,
                  key.keys
                )
              ) {
                this.$toasted.show(
                  `Movie ${key.title} field list cannot be empty in ${element.langauge} section.`
                );
                return false;
              }
            }

            if (
              // i == this.MovieContentContainer.length - 1 &&
              // Testing Only One Language Content or use above for all.
              i === TempMovieContentContainer.length - 1 &&
              // j === array.filter((x)=> x.isRequired).length - 1
              // Right Now I'am checking all, use above for check only is Required
              j == array.length - 1
            ) {
              return true;
            }
          }
        }
      },
      ValidateString(value) {
        return !value && String(value).trim().length == 0 ? false : true;
      },
      ValidateArray(array, length, keys) {
        return (
          array.filter((x) => {
            return this.compaireKeys(x, keys);
          }).length == length
        );
      },
      compaireKeys: function(obj, keys) {
        return (
          keys.filter((y) => obj[y] && String(obj[y]).trim().length > 0)
            .length === keys.length
        );
      },
      FormatValidation: function() {
        let count = 0;
        this.MovieContainer.movieLangaugeFormatDistributor.map((x) => {
          if (x.lang_id == null) {
            count++;
          }
        });

        if (count > 0) {
          return true;
        } else {
          return false;
        }
      },
      DistributorValidation: function() {
        let count = 0;

        // this.MovieContainer.movieLangaugeFormatDistributor.map(x =>
        //   x.movieDistributors.map(y => {
        //     if (y.distributor_id == null || y.selected_cinema.length == 0) {
        //       count++;
        //     }
        //   })
        // );

        if (count > 0) {
          return true;
        } else {
          return false;
        }
      },
      RatingValidation: function() {
        let count = 0;
        this.MovieContainer.movieRatings.map((x) => {
          if (x.country_id == null || x.rating_id == null) {
            count++;
          }
        });
        if (count > 0) {
          return true;
        } else {
          return false;
        }
      },
      CastCrewValidation: function() {
        let count = 0;
        let isDirectorFound = false;

        for (let i = 0; i < this.cast_and_crew.length; i++) {
          let x = this.cast_and_crew[i];

          if (!x.language_id) {
            this.$toasted.show(
              `Please Select Language In Cast And Crew Section`
            );
            return true;
          }

          let castCrew = x.movieCastAndCrewList;

          for (let j = 0; j < castCrew.length; j++) {
            let y = castCrew[j];
            if (
              y.crew_title &&
              y.crew_title.toLowerCase() === "director" &&
              x.langauge.toLowerCase() === "english"
            ) {
              isDirectorFound = true;
            }

            if (y.crew_id == null && y.members && y.members.length > 0) {
              count++;
              this.$toasted.show(
                `Please Enter Cast/Crew details for ${x.langauge} language`
              );
              break;
            } else if (
              y.crew_id !== null &&
              y.members &&
              y.members.length === 0
            ) {
              count++;
              this.$toasted.show(
                `Please Enter Crew Members for ${y.crew_title}`
              );
              break;
            }
          }
        }

        if (!isDirectorFound) {
          this.$toasted.show(`Please Add Director For English language`);
        }

        if (count > 0 || !isDirectorFound) {
          return true;
        } else {
          return false;
        }
      },
      durationValidation: function(value) {
        if (!value) return false;

        let splits = value.split(":");
        if (splits.length !== 3) return false;
        if (splits.some((num) => isNaN(parseInt(num)))) return false;

        return true;
      },
      basicInfoValidation: function() {
        console.log("this.basicInfoValidation main", this.MovieContainer);
        if (
          !this.MovieContainer.movieTitle ||
          !this.MovieContainer.movie_unique_identifier
        ) {
          return false;
        }
        return true;
      },
      filmInfoValidation: function() {
        console.log("this.filmInfoValidation main", this.MovieContainer);
        if (
          !this.MovieContainer.country_name ||
          this.MovieContainer.genres.length === 0
        ) {
          console.log("filmInfoValidation validation false");
          return false;
        }
        console.log("filmInfoValidation validation true");
        return true;
      },
      movieDescriptionsValidation: function() {
        let count = 0;

        for (let i = 0; i < this.MovieContentContainer.length; i++) {
          let x = this.MovieContentContainer[i];

          if (
            x.langauge &&
            x.langauge.toLowerCase() === "english" &&
            (!x.movieShortDescription || !x.movieDescription)
          ) {
            this.$toasted.show(
              `Please Enter Movie Descriptions for ${x.langauge} language`
            );
            count++;
            break;
          }
        }

        if (count > 0) {
          return true;
        } else {
          return false;
        }
      },
      onSaveAsDraft: function(redirect) {
        this.MovieContainer.movie_is_draft = "Y";
        this.MovieContainer.movie_isActive = "N";

        this.OnFinalSubmit(redirect, false);
      },
      checkMovieUUIDValidation() {
        this.ErrorIndex = [];
        let count = 0;
        this.MovieContainer.movieLangaugeFormatDistributor.forEach(
          (x, index) => {
            let regex = /^\S*$/;
            if (x.uuid.match(regex)) {
              this.uuidErrorMessage = "";
            } else {
              this.ErrorIndex.push(index);
              this.uuidErrorMessage = "Spaces are not Allowed.";
              count++;
            }
          }
        );
        if (count > 0) {
          return false;
        } else {
          return true;
        }
      },

      validateMovieInfo(type = "save", showMsg = true) {
        this.errorHandlerObj["errMsg"] = ``;
        this.errorHandlerObj["errorSectionIndex"] = null;
        this.errorHandlerObj["errorArrayIndex"] = null;

        let errorIndex = null;
        let errorFvIndex = null;
        let errorSectionIndex = null;
        let errorCount = 0;
        let errMsg = ``;
        // this.whatsAppMovieTitleForEpix = this.MovieContentContainer.filter(
        //   (data) => {
        //     return data.langaugeId == 3;
        //   }
        // );
        this.whatsAppMovieTitleForEpix = this.MovieContentContainer[0];
        // console.log(whatsAppMovieTitleForEpix, " whatsAppMovieTitleForEpix");
        // console.log(
        //   whatsAppMovieTitleForEpix[0].movieContentTitle.length > 24,
        //   " whatsAppMovieTitleForEpix[0].movieContentTitle.length > 24"
        // );
        if (type == "draft") {
          if (!this.MovieContainer.movieTitle) {
            errorCount++;
            errMsg = `Movie Title Required.`;
            errorSectionIndex = 1;
          } else if (
            !this.MovieContainer.movie_unique_identifier &&
            errorCount == 0
          ) {
            errorCount++;
            errMsg = `Movie UUID Required.`;
            errorSectionIndex = 1;
          }
        } else {
          if (!this.MovieContainer.movieTitle) {
            errorCount++;
            errMsg = `Movie Title Required.`;
            errorSectionIndex = 1;
          } else if (
            !this.MovieContainer.movie_unique_identifier &&
            errorCount == 0
          ) {
            errorCount++;
            errMsg = `Movie UUID Required.`;
            errorSectionIndex = 1;
          } else if (!this.MovieContainer.original_lang_id && errorCount == 0) {
            errorCount++;
            errMsg = `Language (Original) Required.`;
            errorSectionIndex = 1;
          }
          else if (!this.MovieContainer.productionCompany.length  && errorCount == 0) {
            errorCount++;
            errMsg = `Production Company Required.`;
            errorSectionIndex = 1;
          }
          else if (
            !this.MovieContainer.original_distributor_id &&
            errorCount == 0
          ) {
            errorCount++;
            errMsg = `Default Distributor Required.`;
            errorSectionIndex = 1;
          } else if (
            !moment(this.originalReleaseDate).isValid() &&
            errorCount == 0
          ) {
            console.log("this.originalReleaseDate", this.originalReleaseDate);
            errorCount++;
            errMsg = `Please enter Valid Original Release Date.`;
            errorSectionIndex = 1;
          } else if (
            this.MovieContainer.is_event &&
            !this.MovieContainer.parent_movie_id &&
            errorCount == 0
          ) {
            errorCount++;
            errMsg = `Parent Movie Required for Event.`;
            errorSectionIndex = 1;
          } else if (
            this.MovieContainer.is_event &&
            !this.MovieContainer.selected_version.length &&
            errorCount == 0
          ) {
            errorCount++;
            errMsg = `Parent Movie Version Required for Event.`;
            errorSectionIndex = 1;
          } else if (
            this.EPIX_CLIENT &&
            this.whatsAppMovieTitleForEpix &&
            this.whatsAppMovieTitleForEpix.length > 0 &&
            !this.whatsAppMovieTitleForEpix.movieContentTitle
          ) {
            errorCount++;
            errMsg = `WhatsApp Movie Title Required.`;
            errorSectionIndex = 1;
          } else if (
            this.EPIX_CLIENT &&
            this.whatsAppMovieTitleForEpix &&
            this.whatsAppMovieTitleForEpix.length > 0 &&
            this.whatsAppMovieTitleForEpix.movieContentTitle.length > 24
          ) {
            errorCount++;
            errMsg = `WhatsApp Movie Title should be Less then or Equal to 24 Characters.`;
            errorSectionIndex = 1;
          }

          if (errorCount == 0) {
            if (
              !this.MovieContainer.movieRatings ||
              !this.MovieContainer.movieRatings.length
            ) {
              errorCount++;
              errMsg = `Please Select Movie Ratings.`;
              errorSectionIndex = 1;
            } else {
              this.MovieContainer.movieRatings.forEach((_rating, ratIndex) => {
                if (!_rating.region_name) {
                  errorCount++;
                  errMsg = `Region Required.`;
                  errorSectionIndex = 1;
                  errorIndex = ratIndex;
                } else if (!moment(_rating.releaseDate).isValid()) {
                  errorCount++;
                  errMsg = `Release Date Invalid.`;
                  errorSectionIndex = 1;
                  errorIndex = ratIndex;
                } else if (!_rating.rating_id) {
                  errorCount++;
                  errMsg = `Please Select Ratings.`;
                  errorSectionIndex = 1;
                  errorIndex = ratIndex;
                } else if (isNaN(String(_rating.runTime))) {
                  errorCount++;
                  errMsg = `Runtime Required.`;
                  errorSectionIndex = 1;
                  errorIndex = ratIndex;
                }
              });
            }
          }

          if (errorCount == 0) {
            if (
              (!this.MovieContainer.movieLangaugeFormatDistributor ||
                !this.MovieContainer.movieLangaugeFormatDistributor.length) &&
              false
            ) {
              errorCount++;
              errMsg = `Please Add Movie Feature Versions.`;
              errorSectionIndex = 5;
            } else if (
              this.MovieContainer.movieLangaugeFormatDistributor &&
              this.MovieContainer.movieLangaugeFormatDistributor.length
            ) {
              this.MovieContainer.movieLangaugeFormatDistributor.forEach(
                (_version, verIndex) => {
                  if (errorCount == 0) {
                    if (!_version.format_id) {
                      errorCount++;
                      errMsg = `Content Type Required.`;
                      errorSectionIndex = 5;
                      errorIndex = verIndex;
                    } else if (!_version.lang_id) {
                      errorCount++;
                      errMsg = `Language Required.`;
                      errorSectionIndex = 5;
                      errorIndex = verIndex;
                    } else if (
                      !_version.movieDistributors ||
                      !_version.movieDistributors.length ||
                      !_version.movieDistributors[0]["distributor_id"]
                    ) {
                      errorCount++;
                      errMsg = `Distributor Required.`;
                      errorSectionIndex = 5;
                      errorIndex = verIndex;
                    } else if (
                      (!_version.selected_cinema ||
                      !_version.selected_cinema.length) && false
                    ) {
                      errorCount++;
                      errMsg = `Cinema Required for version.`;
                      errorSectionIndex = 5;
                      errorIndex = verIndex;
                    }
                  }
                }
              );
            }
          }

          if (errorCount == 0) {
            if (
              !this.MovieContentContainer ||
              !this.MovieContentContainer.length
            ) {
            } else {
              this.MovieContentContainer.forEach((_lang, langIndex) => {
                if (
                  errorCount == 0 &&
                  _lang.langauge.toLowerCase() == "english"
                ) {
                  if (!_lang.movieShortDescription && false) {
                    errorCount++;
                    errMsg = `Movie Short Description Required.`;
                    errorSectionIndex = 2;
                    errorIndex = langIndex;
                  } else if (!_lang.movieDescription) {
                    errorCount++;
                    errMsg = `Movie Long Description Required.`;
                    errorSectionIndex = 2;
                    errorIndex = langIndex;
                  }
                }
              });
            }
          }
        }

        if (errorCount > 0) {
          if (showMsg) {
            this.$toasted.show(errMsg);
          }
          this.errorHandlerObj["errMsg"] = errMsg;
          this.errorHandlerObj["errorSectionIndex"] = errorSectionIndex;
          this.errorHandlerObj["errorArrayIndex"] = errorIndex;

          if (errorSectionIndex == 1) {
            this.sectionCollapse["basicInfo"] = true;
          } else if (errorSectionIndex == 5) {
            this.sectionCollapse["detailsAndDistributors"] = true;
          } else if (errorSectionIndex == 2) {
            this.sectionCollapse["movieContent"] = true;
          }
          return false;
        } else {
          return true;
        }
      },
      OnFinalSubmit: function(redirect, validate = true) {
        let flag = true;
        let input = [];
        this.submitted = true;
        let validateType = !validate ? "draft" : "save";

        if (!this.validateMovieInfo(validateType, true)) {
          return false;
        }

        if (!validate) {
          this.showErrorMessages = false;
        } else {
          this.showErrorMessages = true;
        }
        this.$validator
          .validate()
          .then((valid) => {
            if (valid || !validate) {
              console.log(
                "🚀 ~ file: addMovies.vue ~ line 4788 ~ validate",
                validate
              );
              console.log(
                "🚀 ~ file: addMovies.vue ~ line 4788 ~ valid",
                valid
              );
              console.log("4788 coming here");
              console.log(
                "🚀 ~ file: addMovies.vue ~ line 4792 ~ validate",
                validate
              );
              console.log("🚀 ~ file: addMovies.vue ~ line 4792 ~ flag", flag);
              console.log("4790 coming here");
              for (let i in this.custom_fields_list) {
                input.push({
                  custom_field_id: this.custom_fields_list[i].custom_field_id,
                  input_data: this.input_data[i],
                });
              }

              this.MovieContainer.original_release_date = this.originalReleaseDate;
              console.log(
                this.originalReleaseDate,
                "Original Release",
                this.MovieContainer.original_release_date
              );

              if (!this.checkAddMoreRatings) {
                let RatignwithAllRegions = _.cloneDeep(
                  this.MovieContainer.movieRatings.filter(
                    (x) => x.region_id == 0
                  )
                );
                if (RatignwithAllRegions.length > 0) {
                  this.MovieContainer.movieRatings = [];
                  this.Regions.filter((y) => y.region_id).map((x) => {
                    let obj = {
                      ...RatignwithAllRegions[0],
                    };
                    obj["region_id"] = x.region_id;
                    obj["region_name"] = x.region_name;
                    obj["region_obj"] = {
                      region_id: x.region_id,
                      region_name: x.region_name,
                    };
                    this.MovieContainer.movieRatings.push(obj);
                  });
                }
              }
              if (
                this.EPIX_CLIENT &&
                this.whatsAppMovieTitleForEpix &&
                this.whatsAppMovieTitleForEpix.length > 0 &&
                this.whatsAppMovieTitleForEpix.hasOwnProperty(
                  "movieContentTitle"
                )
              ) {
                this.MovieContainer[
                  "movieAlternateLangTitle"
                ] = this.whatsAppMovieTitleForEpix.movieContentTitle;
              }
              this.btenable = true;
              let loader = this.$loading.show();
              let finalObj = {
                ...this.MovieContainer,
                ...this.Scenes,
                CastAndCrewContainer: this.cast_and_crew,
                MovieContentContainer: this.MovieContentContainer,
                custom_field_values: input,
                movieScenes: this.movieScenes,
                movie_trailers: this.movie_trailers,
              };

              if (this.selected_country) {
                finalObj.country_id = this.selected_country.country_id;
                finalObj.country_name = this.selected_country.country_name;
              }

              finalObj.movieLangaugeFormatDistributor.forEach((x, i) => {
                if (this.leadTimes[i].leadTimeMM.length === 1)
                  this.leadTimes[
                    i
                  ].leadTimeMM = `0${this.leadTimes[i].leadTimeMM}`;

                x.lead_time_in_hours = `${this.leadTimes[i].leadTimeHH}:${this.leadTimes[i].leadTimeMM}`;
              });

              finalObj.movieLangaugeFormatDistributor.map((x) => {
                x["selectShowType"] = [];

                let findIndex = -1;

                if (x.is_classic_show) {
                  findIndex = x["selectShowType"].findIndex((y) => {
                    return y.column_name == "is_classic_show";
                  });

                  if (findIndex < 0) {
                    x["selectShowType"].push(this.ShowTypeArray[0]);
                  }
                }
                if (x.is_confirmed_show) {
                  findIndex = x["selectShowType"].findIndex((y) => {
                    return y.column_name == "is_confirmed_show";
                  });

                  if (findIndex < 0) {
                    x["selectShowType"].push(this.ShowTypeArray[2]);
                  }
                }
                if (x.is_private_show) {
                  findIndex = x["selectShowType"].findIndex((y) => {
                    return y.column_name == "is_private_show";
                  });

                  if (findIndex < 0) {
                    x["selectShowType"].push(this.ShowTypeArray[1]);
                  }
                }
                if (x.is_crowd_show) {
                  findIndex = x["selectShowType"].findIndex((y) => {
                    return y.column_name == "is_crowd_show";
                  });

                  if (findIndex < 0) {
                    x["selectShowType"].push(this.ShowTypeArray[3]);
                  }
                }
                if (x.is_movie_club) {
                  findIndex = x["selectShowType"].findIndex((y) => {
                    return y.column_name == "is_movie_club";
                  });

                  if (findIndex < 0) {
                    x["selectShowType"].push(this.ShowTypeArray[4]);
                  }
                }
              });

              finalObj.movieLangaugeFormatDistributor.map((scheduleDetail) => {
                let errorMsg = "";
                if (!scheduleDetail.licence_start_date) {
                  errorMsg = "Please Select License Start Date";
                }
                if (!scheduleDetail.licence_end_date) {
                  errorMsg = "Please Select License End Date";
                }

                if (
                  moment(scheduleDetail.licence_end_date).isBefore(
                    scheduleDetail.licence_start_date
                  )
                ) {
                  errorMsg =
                    "License End Date Should be grater than Start Date";
                }
                if (
                  (!scheduleDetail.selected_cinema ||
                  scheduleDetail.selected_cinema.length == 0) && false
                ) {
                  errorMsg = "Please Select Cinema";
                }

                if (
                  (!scheduleDetail.selectShowType ||
                    scheduleDetail.selectShowType.length == 0) &&
                  this.getMyCinemaStatusNew() == "Y"
                ) {
                  errorMsg = "Please Select Show Type";
                }

                // if (!scheduleDetail.interval_time) {
                //   errorMsg = "Please Select Intermission Time";
                // }
                // let loader = this.$loading.show();

                let MulScheduleCinemaArray = [];
                if (!errorMsg) {
                  let is_private_show = true;
                  let is_confirmed_show = true;
                  let is_crowd_show = true;
                  let showTypeArray = Array.prototype.map.call(
                    scheduleDetail.selectShowType,
                    function(item) {
                      return String(item.booking_type_id);
                    }
                  );
                  scheduleDetail.selected_cinema.map((x) => {
                    let cinema_obj = {
                      cinema_id: x.cine_id,
                      category_id: 1,
                      sch_start_date: scheduleDetail.licence_start_date,
                      sch_end_date: scheduleDetail.licence_end_date,
                      MultipleSchedule: [],
                    };
                    x.screen_array.map((y) => {
                      if (y.is_default_screen == "Y") {
                        let newArray = [...showTypeArray];

                        let filterModule = cinema_obj.MultipleSchedule.findIndex(
                          (scree) => {
                            return scree.screen_id == y.screen_id;
                          }
                        );
                        if (filterModule < 0) {
                          if (
                            y.is_confirmed_show == "N" ||
                            x.is_confirmed_show == "N"
                          ) {
                            is_confirmed_show = false;

                            let index_crowd = newArray.indexOf("1");
                            if (index_crowd >= 0) {
                              newArray.splice(index_crowd, 1);
                            }
                          }
                          if (
                            y.is_crowd_show == "N" ||
                            x.is_crowd_show == "N"
                          ) {
                            is_crowd_show = false;

                            let index_crowd = newArray.indexOf("2");
                            if (index_crowd >= 0) {
                              newArray.splice(index_crowd, 1);
                            }
                          }
                          if (
                            y.is_private_show == "N" ||
                            x.is_private_show == "N"
                          ) {
                            is_private_show = false;

                            let index_crowd = newArray.indexOf("3");
                            if (index_crowd >= 0) {
                              newArray.splice(index_crowd, 1);
                            }
                          }
                          let screen_obj = {
                            screen_id: y.screen_id,
                            selectShowType:
                              this.getMyCinemaStatusNew() == "Y"
                                ? newArray.join(",")
                                : "4",

                            moviesArray: [
                              {
                                privateRateCard: {
                                  rate_card_id: y.rc_id_private,
                                  rate_card_group_id: y.rate_card_private_id,
                                },

                                cleaning_time_in_mins:
                                  x.cine_cleaning_time_in_mins,
                                interval_time_in_mins:
                                  x.cine_interval_time_in_mins,
                                ads_time_in_mins:
                                  x.cine_setting_ads_time_in_mins,
                                // movie_details_id: scheduleDetail.md_id,
                                min_seats: y.min_seats,
                                booked_seats: 0,
                                gogo_user_id: 0,
                                ss_category_id: 0,
                                start_time: y.start_date_time,
                                end_time: y.end_date_time,
                                interval_time: x.mycinema_creation_interval
                                  ? x.mycinema_creation_interval
                                  : 0,
                                is_monday: y.is_monday,
                                is_tuesday: y.is_tuesday,
                                is_wednesday: y.is_wednesday,
                                is_thursday: y.is_thursday,
                                is_friday: y.is_friday,
                                is_saturday: y.is_saturday,
                                is_sunday: y.is_sunday,
                                scheduling_price: [
                                  {
                                    screen_seat_type_id: y.screen_seat_type_id,
                                    rate_card_id: y.rc_id,
                                    rate_card_private_id: 0,
                                    rate_card_group_id: y.rate_card_id,
                                  },
                                ],
                              },
                            ],
                          };
                          cinema_obj.MultipleSchedule.push(screen_obj);
                        } else {
                          let findIndexNew = cinema_obj.MultipleSchedule[
                            filterModule
                          ].moviesArray.findIndex((mov) => {
                            return (
                              mov.start_time == y.start_date_time &&
                              mov.end_time == y.end_date_time
                            );
                          });
                          if (findIndexNew < 0) {
                            let Movieobj = {
                              privateRateCard: {
                                rate_card_id: y.rc_id_private,
                                rate_card_group_id: y.rate_card_private_id,
                              },
                              cleaning_time_in_mins:
                                x.cine_cleaning_time_in_mins,
                              interval_time_in_mins:
                                x.cine_interval_time_in_mins,
                              ads_time_in_mins: x.cine_setting_ads_time_in_mins,
                              movie_details_id: scheduleDetail.md_id,
                              min_seats: y.min_seats,
                              booked_seats: 0,
                              gogo_user_id: 0,
                              ss_category_id: 0,
                              start_time: y.start_date_time,
                              end_time: y.end_date_time,
                              interval_time: scheduleDetail.interval_time,
                              is_monday: y.is_monday,
                              is_tuesday: y.is_tuesday,
                              is_wednesday: y.is_wednesday,
                              is_thursday: y.is_thursday,
                              is_friday: y.is_friday,
                              is_saturday: y.is_saturday,
                              is_sunday: y.is_sunday,
                              scheduling_price: [
                                {
                                  screen_seat_type_id: y.screen_seat_type_id,
                                  rate_card_id: y.rc_id,
                                  rate_card_private_id: 0,
                                  rate_card_group_id: y.rate_card_id,
                                },
                              ],
                            };
                            cinema_obj.MultipleSchedule[
                              filterModule
                            ].moviesArray.push(Movieobj);
                          } else {
                            cinema_obj.MultipleSchedule[
                              filterModule
                            ].moviesArray[findIndexNew].scheduling_price.push({
                              screen_seat_type_id: y.screen_seat_type_id,
                              rate_card_id: y.rc_id,
                              rate_card_private_id: 0,
                              rate_card_group_id: y.rate_card_id,
                            });
                          }
                        }
                      }
                    });

                    MulScheduleCinemaArray.push(cinema_obj);
                  });
                }

                scheduleDetail["MulScheduleCinemaArray"] = {
                  md_id: 0,
                  CinemaSchedule: MulScheduleCinemaArray,
                };
              });

              if (this.MovieContainer.is_event && this.event_identifier) {
                finalObj.movie_unique_identifier =
                  finalObj.movie_unique_identifier +
                  "." +
                  this.event_identifier;
              }

              MovieService.AddMovie(finalObj)
                .then((response) => {
                  this.btenable = false;
                  const { data } = response;
                  loader.hide();
                  if (data && data.status) {
                    this.$toasted.show("Movie Added Successfully");
                    this.resetHandler();
                    if (redirect) {
                      this.$router.push({
                        path: "/cinema-manager/movies",
                      });
                    }
                  } else {
                    this.$toasted.show(data.message);
                  }
                })
                .catch(this._CatchError);
            } else {
              console.log(
                "COMING HERE IN ELSE FOR VALID LINE 10419",
                valid,
                validate
              );
            }
          })
          .catch((err) => {
            console.log("error when validating: ", err);
          });
        // }
      },
      translateToOtherLangs: function(movieContent, index) {
        console.log("translateToOtherLangs is called");

        console.log("movieContent", movieContent);
        console.log("this.MovieContentContainer", this.MovieContentContainer);

        /* movieDescription
movieShortDescription */
        let englishContent = this.MovieContentContainer.find((x) => {
          if (
            (x.movieDescription && x.movieDescription.length > 0) ||
            (x.movieShortDescription && x.movieShortDescription.length > 0)
          ) {
            return true;
          }
        });

        if (
          !englishContent ||
          !englishContent.movieDescription ||
          !englishContent.movieShortDescription
        ) {
          this.$toasted.show(
            "Please enter title and description for any language"
          );
          return;
        }

        let targetLang = movieContent.iso_2;

        if (!targetLang) {
          this.$toasted.show(
            "No ISO code found for " + movieContent.langauge + "language"
          );
          return;
        }

        this.onChangeTabHandler(null, index);
        this.translationLoading[index] = true;

        this.$forceUpdate();

        MovieService.GetDeeplTranslations({
          target_langs: [targetLang],
          text: [
            englishContent.movieDescription,
            englishContent.movieShortDescription,
          ],
        })
          .then((resp) => {
            const { data } = resp;
            console.log("data", data);

            if (data.status) {
              let translations = data.data[targetLang].translations;

              movieContent.movieDescription = translations[0].text;
              movieContent.movieShortDescription = translations[1].text;
              this.translated[index] = true;
            }
          })
          .catch((err) => {
            this.$toasted.show("Error when fetching translations");
            console.log("Error while fetching translations");
            console.log(err);
          })
          .finally(() => {
            this.translationLoading[index] = false;
            this.$forceUpdate();
          });
      },
      CheckEmptyContent: function(movieContent, index) {
        if (movieContent.langauge.toLowerCase() !== "english") {
          if (movieContent.movieContentTitle) {
            this.translated[index] = true;
          } else {
            this.translated[index] = false;
          }
        }
      },
      onChangeDraftStatus: function(changed) {
        console.log("🚀 ~ file: addMovies.vue ~ line 4812 ~ changed", changed);
        if (changed === "Y" && this.MovieContainer.movie_isActive === "Y") {
          this.$toasted.show(
            "Please set movie to inactive and then set to draft."
          );
          this.$nextTick(() => {
            this.MovieContainer.movie_is_draft = "N";
          });
        }
      },
      onChangeActiveStatus: function(changed) {
        if (changed === "Y") {
          this.MovieContainer.movie_is_draft = "N";
        }
      },
      onChangeOriginalShowtype: function(event, showtype) {
        this.MovieContainer.movieLangaugeFormatDistributor.map((mlfd, i) => {
          mlfd[showtype] = event.target.checked;
        });
      },
      getReleaseDate: function() {
        if (this.MovieContainer.original_release_date) {
          this.originalReleaseDate = this.MovieContainer.original_release_date;
        } else {
          let tempDate;
          let count = false;
          this.MovieContainer.movieRatings.forEach((item) => {
            if (item.releaseDate) {
              if (!count) {
                tempDate = Date.parse(item.releaseDate);
              } else {
                if (tempDate > Date.parse(item.releaseDate)) {
                  tempDate = Date.parse(item.releaseDate);
                }
              }
              count = true;
            }
          });
          this.originalReleaseDate = moment(tempDate).format("YYYY-MM-DD");
        }
      },
      deleteImageUrl(distributor) {
        distributor.md_thumbnail_url = null;

        distributor.md_thumbnail_name = null;

        this.$emit("imageDeleted", distributor);
      },
      onSelectProductionCompany(payload){
        // this.MovieContainer.production_company_id=payload.production_id
      },
      onRemoveProudctionCompany(){
        // this.MovieContainer.production_company_id=null
      },
    },
  };
</script>

<style>
  .disableFeatureVersion {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.8;
  }
  .disableFeatureVersion .forceAllowed {
    cursor: pointer !important;
    pointer-events: all !important;
    opacity: 1 !important;
  }
  .externalmovies {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 10px !important;
  }

  .error_border {
    border: 2px solid rgb(247, 78, 78) !important;
  }

  .dcp_box {
    background-color: #f5d8ee !important;
  }
  .new-border {
    border: 2px solid #b1b4b8;
  }
  label {
    color: black !important;
  }
  .internal-border-new {
    border: 1px solid #3876d2;
    /*background-color: #e6e6f8;*/
  }
  .internal-border {
    border: 1px solid #3876d2;
    background-color: #e6e6f8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    margin: 0 15px 15px 15px;
    padding-top: 15px;
  }
  .fs {
    font-size: 17px;
  }
  .back {
    background-color: #f5f5f5;
  }
  .mar {
    margin-left: 30px;
  }

  .new_movie_layout .input-material {
    height: 33px !important;
  }

  .new_movie_layout .material-file-upload {
    border-radius: 5px !important;
  }

  .new_movie_layout .material-file-upload .label {
    font-weight: 500 !important;
  }

  .new_movie_layout .input-material input,
  .new_movie_layout .input-material-textarea textarea {
    border-radius: 5px;
    min-height: 33px;
  }

  .new_movie_layout .input-material input + label,
  .new_movie_layout .input-material textarea + label,
  .new_movie_layout .input-material-textarea textarea + label {
    position: unset !important;
  }

  .new_movie_layout label {
    text-transform: capitalize;
    margin-bottom: 0rem !important;
  }

  .new_movie_layout {
    line-height: unset !important;
  }

  .new_movie_layout .multiselect__select {
    height: 30px !important;
  }
  .new_movie_layout .multiselect {
    min-height: 30px !important;
  }
  .new_movie_layout .multiselect__tags {
    min-height: 30px !important;
    border-radius: 5px !important;
  }

  .new_movie_layout .multiselect__tag {
    margin-right: 5px;
    margin-bottom: 0px;
  }

  .new_movie_layout .dropdown-curve-container label,
  .new_movie_layout .input-material-textarea label {
    position: unset !important;
    background: transparent;
    letter-spacing: 0.3px;
  }

  .new_movie_layout .input-material input::placeholder,
  .new_movie_layout .input-material-textarea textarea::placeholder {
    /* color: black; */
    /* color: #9e9e9e !important; */
    color: #9e9e9e9e !important;
    /* font-style: italic; */
    font-size: 12px;
    letter-spacing: 0.3px;
  }

  .new_movie_layout .multiselect__placeholder {
    /* color: #9e9e9e !important; */
    color: #9e9e9e9e !important;
    /* font-style: italic; */
    font-size: 12px;
    font-weight: unset !important;
    letter-spacing: 0.3px;
  }

  .new_movie_layout input[type="date"]::placeholder {
    color: #9e9e9e9e !important;
    font-size: 12px;
    letter-spacing: 0.3px;
  }

  .new_movie_layout .multiselect__strong {
    font-weight: 500 !important;
  }

  .new_movie_layout .minWidth135 {
    min-width: 135px;
  }
  .new_movie_layout .minWidth175 {
    min-width: 177px;
  }

  .new_movie_layout .movie-version-box .movie-version-inner {
    border: 1px solid #a1a1a4;
    border-radius: 5px;
    padding: unset;
    padding-top: 0.5rem;
    background: #f5f5f5;
    box-shadow: 1px 2px 5px 0px lightgray;
  }

  .new_movie_layout .movie-version-box {
    border: unset;
    background: #e6e6f8;
    padding: unset;
    border-radius: 5px;
  }

  .new_movie_layout {
    /* font-family: sans-serif; */
    zoom: 0.88 !important;
  }

  .new_movie_layout .blue-badge {
    margin-bottom: 0;
  }

  .new_movie_layout .min-h {
    min-height: 30px !important;
  }

  .backWhite {
    background: white;
  }

  .movieSceneImage {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background: lightgray;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .movieSceneImage .plusScenes {
    font-size: 25px;
    font-weight: bold;
    color: white;
    padding-bottom: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease;
  }

  .movieSceneImageIcon .image-circle {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    cursor: pointer;
    object-fit: cover; /* Keeps image proportionate */
  }

  .borderRight {
    border-right: 1px solid;
  }

  .maxW85 {
    max-width: 85px;
  }

  /* Overlay options (hidden by default) */
  .movieSceneImageoptions {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgb(239 226 226 / 83%);
    /* background: rgb(171 171 171 / 50%); */
    /* background: rgba(0, 0, 0, 0.5); */
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 0; /* Initially hidden */
    transition: opacity 0.3s ease; /* Smooth transition */
  }

  /* Hover effect to show options */
  .movieSceneImageIcon:hover .movieSceneImageoptions {
    opacity: 1; /* Show overlay */
  }

  /* Buttons for View and Delete */
  .movieSceneImageoptions button {
    background-color: white;
    border: none;
    padding: 10px;
    margin: 5px;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  /* Hover effect for buttons */
  .movieSceneImageoptions button:hover {
    background-color: #f0f0f0;
  }

  /* Icons or Text */
  .movieSceneImageoptions button i {
    margin-right: 5px;
  }

  .castCrewTab {
    border: 0.5px solid lightgray;
    border-top: none;
    /* padding-inline: 15px; */
    background: #f5f5f5;
  }

  .manual_bill_item .multiselect__tags {
    border-radius: unset !important;
    border: unset !important;
  }

  .manual_bill_input input {
    border: none;
    height: 40px;
    margin: 0;
    width: 100%;
    padding-inline: 10px;
  }

  .manual_bill_input input::placeholder,
  .manual_bill_wrapper .multiselect__placeholder {
    font-size: 12px;
    font-style: italic;
  }

  .input_text-center input {
    text-align: center;
  }

  .input_text-right input {
    text-align: right;
  }

  .manual_bill_wrapper .multiselect__placeholder {
    font-weight: unset !important;
  }

  .noItemsClass {
    text-align: center;
    width: 100%;
    margin: 16px auto;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
  }

  .taxPopOver {
    zoom: 0.8;
    min-width: 200px;
  }

  .errRow {
    border: 2px solid red;
  }
  .borderNone {
    border: none !important;
  }

  .complete-tick {
    width: 120px;
    height: 120px;
    display: inline-block;
    background-size: contain;
  }

  .fv_collapse_inner {
    text-align: left;
    padding: 10px;
  }

  .fv_collapse_inner_container {
    background: #f5f5f5;
    margin-inline: 7px;
  }

  .new_movie_layout .btn-tab-title.active {
    background-color: #3876d217;
  }

  .basicInforWrapper {
    background: #f5f5f5;
  }

  .new_movie_layout .bg-lightprimary {
    background-color: #3876d217;
  }

  .new_movie_layout .multiselect__single {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-bottom: unset !important;
    vertical-align: text-bottom !important;
  }

  .new_movie_layout .image-previewer {
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
  }

  .sectionError {
    border: 2px solid red;
    border-radius: 5px;
  }

  .required_star {
    font-size: 14px;
    color: #ff0202;
    font-weight: bolder;
    padding-left: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MoviesComponents/addMovies.vue